<template>
    <div>
        <GenericPopups ref="GenericPopups"></GenericPopups>
        <LoadingSpinner :busy="true" v-if="!order"></LoadingSpinner>
        <PhotoWidget ref="PhotoWidget"></PhotoWidget>
        <ImageLightBox ref="ImageLightBox"></ImageLightBox>

        <b-card v-if="order"
                header-class="kit-view-header"
                :header-class="(_not_banned || customer.stop_workflow_active) ? 'bg-danger': ''"
        >
            <template v-slot:header>
                <div class="kit-view-header">
                    <b-row>
                        <b-col cols="7">
                            <div class="d-flex">
                                <div class="editable">
                                    <div @click="edits.name.isEditing = !edits.name.isEditing"
                                         v-if="!edits.name.isEditing" class="data pointer">
                                        <span class="h2">{{ customer.first_name | titleCase }} {{ customer.last_name | titleCase }} </span>
                                        <div v-if="edits.name.isSaved" class="onSave saveBlock">
                                            <i class="fa-solid fa-check-circle text-success fa-2x"></i>
                                        </div>
                                    </div>

                                    <div class="edits" v-if="edits.name.isEditing">
                                        <div class="inputs">
                                            <b-form-input size="sm" type="text"
                                                          v-model="customer.first_name">
                                            </b-form-input>
                                            <b-form-input size="sm" type="text"
                                                          v-model="customer.last_name">
                                            </b-form-input>
                                        </div>
                                        <div class="controls mt-1 text-right">
                                            <i v-if="!edits.name.isSaving" @click="cancelEdits" data-editing="name"
                                               class="fa-solid fa-times text-danger pointer">
                                            </i>
                                            <i v-if="!edits.name.isSaving" @click="saveEdits" data-editing="name"
                                               class="fa-solid fa-save text-success pointer ml-2">
                                            </i>
                                            <i v-if="edits.name.isSaving" class="fa-solid fa-spinner fa-spin"></i>
                                        </div>
                                    </div>
                                </div>

                                <div class="ml-3 mt-2"
                                     id="customer_status_badge">
                                    <b-form-checkbox
                                        v-if="!edits.banned.isSaving"
                                        size="sm"
                                        class="nice-toggle-success nice-toggle-error-always toggle-error"
                                        name="check-button"
                                        v-model="_banned"
                                        switch >
                                     </b-form-checkbox>
                                    <i class="fa-spin fa-regular fa-spinner" v-if="edits.banned.isSaving">
                                    </i>
                                </div>
                                <b-tooltip
                                        noninteractive
                                        target="customer_status_badge"
                                        v-if="!edits.banned.isSaving"
                                        :variant="_banned ? 'success': 'light'">
                                    {{ (_banned? 'Active Customer' : ('Banned at ' + formatDate(customer.banned_at) + ' By ' + customer.banner_name)) }}
                                </b-tooltip>
                            </div>

                        </b-col>
                        <b-col cols="5">
                            <div class="d-flex justify-content-end">
                                <b-button variant="primary" class="ml-2" v-b-modal.modal-schedule-five9-call>
                                    <i class="fa-solid fa-phone fa-flip-horizontal mr-1"></i>Call
                                </b-button>

                                <b-button variant="primary" class="ml-2" v-b-modal.modal-email>
                                    <i class="fa-solid fa-envelope mr-1"></i>Email/Text
                                </b-button>
                                <b-button variant="primary" class="ml-2" v-b-modal.modal-resend-kit :disabled="order.status_id > 3 || (latestLead ? (latestLead.status != 'printed' && latestLead.status != 'do-not-print') : false)">
                                    <i class="fa-solid fa-share-square mr-1"></i>Re-Mail Kit
                                </b-button>
                                <b-button class="ml-2" v-b-modal.modal-create-new-order :disabled="customerOrders == null">
                                    <i v-if="customerOrders == null" class="fa-regular fa-spin fa-spinner mr-1"></i><i v-else class="fa-solid fa-plus mr-1"></i>Create New Order
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </template>



            <b-row>
                <b-col>
                    <!--************
                        FLAGS table
                    ****************-->
                    <b-card no-body ref="flags" id="flags"  v-if="flags">
                        <template v-slot:header>
                            <b-row>
                                <b-col>
                                    <span class="h5">Flags</span>
                                </b-col>
                                <b-col class="text-right">
                                    <b-button size="sm" v-on:click="addFlag">
                                        <i class="fa-solid fa-plus mr-1"></i>Add Flag
                                    </b-button>
                                </b-col>
                            </b-row>
                        </template>

                        <b-tabs card small pills vertical>
                            <b-tab title="Active Flags"
                                   class="p-0"
                                   no-body
                                   active
                                   :class="(_activeFlags.length > 4) ? 'set-flag-height': '' ">
                                <b-table
                                        hover
                                        outlined
                                        small
                                        class="text-center"
                                        :fields="[
                                        {key: 'flag_type.name', label: 'Flag'},
                                        {'key': 'user', 'label':'Assignee'},
                                        {'key': 'created_at', 'label':'Created'},
                                        {'key': 'follow_up', 'label':'Due Date'},
                                        {'key': 'note', 'label':'Note', 'tdClass': 'small'}
                                        ]"
                                        :items="_activeFlags">
                                    <template v-slot:cell(flag_type.name)="data">
                                        <div class="d-flex">

                                            <b-button @click="flagToView(data.item, data.index)"
                                                      v-b-tooltip.hover.right
                                                      :title="data.item.flag_type.description"
                                                      :variant="getFlagVariant(data.item.flag_type.config)"
                                                      class="p-0 text-white" block size="sm">
                                                <b-badge v-if="data.item.stop_workflow"
                                                         variant="light" pill class="mr-1">
                                                    <i class="fa-regular fa-exclamation-triangle text-danger "></i>
                                                </b-badge> <b>{{ data.value }}</b>
                                            </b-button>
                                        </div>

                                    </template>

                                    <template v-slot:cell(user)="data">
                                        <template v-if="data.item.users && data.item.users[0]">{{ data.item.users[0].name }}</template>
                                    </template>

                                    <template v-slot:cell(created_at)="data">
                                        {{ data.value | datetime }}
                                    </template>

                                    <template v-slot:cell(follow_up)="data">
                                        {{ data.value | datetime }}
                                    </template>

                                    <template v-slot:cell(note)="data">
                                        <div v-b-tooltip.hover :title="data.value">{{ truncate(data.value) }} </div>
                                    </template>
                                </b-table>

                            </b-tab>

                            <b-tab title="Cleared Flags"
                                   no-body
                                   class="p-0"
                                   :class="(_activeFlags.length > 4 || _clearedFlags.length > 4) ? 'set-flag-height': '' ">
                                <b-table
                                        hover
                                        outlined
                                        small
                                        class="text-center"
                                        :fields="[
                                        {key: 'flag_type.name', label: 'Flag'},
                                        {'key': 'user', 'label':'Assignee'},
                                        {'key': 'created_at', 'label':'Created'},
                                        {'key': 'cleared_at', 'label':'Resolved'},
                                        {'key': 'deletor', 'label':'Resolved By'},
                                        {'key': 'note', 'label':'Note', 'tdClass': 'small'}
                                        ]"
                                        :items="_clearedFlags">
                                    <template v-slot:cell(flag_type.name)="data">
                                        <b-button @click="flagToView(data.item,-1)"
                                                  v-b-tooltip.hover.right
                                                  :title="data.item.flag_type.description"
                                                  :variant="getFlagVariant(data.item.flag_type.config)"
                                                  class="p-0 text-white" block size="sm"><b>
                                            {{ data.value }}</b></b-button>
                                    </template>

                                    <template v-slot:cell(deletor)="data">
                                        <template v-if="data.item.deletor">{{ data.item.deletor.name }}</template>
                                    </template>

                                    <template v-slot:cell(user)="data">
                                        <template v-if="data.item.users && data.item.users[0]">{{ data.item.users[0].name }}</template>
                                    </template>

                                    <template v-slot:cell(created_at)="data">
                                        {{ data.value | datetime }}
                                    </template>

                                    <template v-slot:cell(cleared_at)="data">
                                        {{ data.value | datetime }}
                                    </template>

                                    <template v-slot:cell(note)="data">
                                        <div v-b-tooltip.hover :title="data.value">{{ truncate(data.value) }} </div>
                                    </template>
                                </b-table>
                            </b-tab>

                        </b-tabs>
                    </b-card>


                    <!--************
                         AML table
                    ****************-->
                    <b-card body-class="p-0" v-if="aml.length != 0">
                        <template v-slot:header>
                            <span class="h5">Anti Money Laundering Disclaimer</span>
                            <b-form-checkbox class="ml-4" v-model="amlShowVoided" name="aml-show-voided" switch inline  v-b-toggle:my-collapse>
                                Show Voided
                            </b-form-checkbox>
                        </template>
                        <b-table
                                outlined
                                small
                                :fields="['order_id', 'ID', 'type', 'created_by', 'created', 'signed']"
                                :items="_complianceSignedAML"
                                thead-class="small"
                                tbody-class="small"
                                table-variant="secondary"
                                class="mb-0 aml-table"
                        >
                            <template v-slot:cell(id)="data">
                                {{data.item.id}}
                            </template>
                            <template v-slot:cell(type)="data">
                                <div>{{data.item.document_type}}</div>
                                
                            </template>
                            <template v-slot:cell(created_by)="data">
                                {{data.item.causer_name}}
                            </template>
                            <template v-slot:cell(created)="data">
                                {{data.item.created_at | datetime}}
                            </template>
                            <template v-slot:cell(signed)="data">
                                <div v-if="data.item.voided_at">
                                    <label>Voided:</label> {{data.item.voided_at | datetime}}
                                </div>
                                <div v-else-if="data.item.signed_at">
                                    <label>Signed:</label> {{data.item.signed_at | datetime}}
                                    <b-button
                                        @click="openProtectedDocument(data.item.pdf_url)"
                                        v-if="data.item.pdf_url"
                                        variant="primary"
                                        size="sm" class="p-0 px-1 mx-4">
                                        <i>Download</i>
                                    </b-button>
                                    <a class="pointer text-primary font-xs"
                                    v-if="data.item.uploads && data.item.uploads.length != 0"
                                                                @click="data.toggleDetails"><small>
                                            <i class="fa-solid text-success"
                                                :class="data.detailsShowing ? 'fa-minus-circle': 'fa-plus-circle' "></i>
                                Attachments</small></a>
                                </div>
                                <b-button
                                        @click="disableItem(data.item)"
                                        :disabled="data.item.isSaving != undefined"
                                        v-else
                                        variant="danger"
                                        size="sm" class="p-0 px-1">
                                    <i v-if="data.item.isSaving != undefined" class="fa-regular fa-spin fa-spinner"></i>
                                    <i v-else>Void Document</i>
                                </b-button>
                            </template>
                            <template v-slot:row-details="row">
                                <b-table
                                        small
                                        :fields="['title', {'key': 'url', 'label': 'File'}]"
                                        :items="row.item.uploads"
                                        thead-class="small"
                                        tbody-class="small"
                                        table-variant="secondary"
                                        class="mb-0 aml-table">
                                    <template v-slot:cell(title)="data">
                                        {{data.item.type}}
                                    </template>
                                    <template v-slot:cell(url)="data">
                                        <b-button
                                                class="p-0 px-1"
                                                @click="openUploadedDocument(data.item.file_path)"
                                                variant="primary"
                                                size="sm">
                                            <i>Download</i>
                                        </b-button>
                                    </template>
                                </b-table>
                            </template>
                        </b-table>
                    </b-card>




                    <!--**************************
                         CUSTOMER & ORDER SECTIONS
                     *****************************-->
                    <b-form-row class="mb-2">

                        <!--customer-->
                        <b-col cols="5">
                            <b-card body-class="p-2"
                                    class="h-100"
                                    header-class="p-2"
                                    body-border-variant="dark"
                                    body-bg-variant="secondary">
                                <template v-slot:header>
                                    <span class="mb-0 h6 mr-3">
                                        <i class="fa-solid fa-user fa-fw"></i> Customer {{ customer.id }}
                                        <b-button variant="link" class="p-0" @click="openMyAccount" v-b-tooltip.hover title="Open My Account">
                                            <i class="fa-duotone fa-user-circle"></i>
                                        </b-button>
                                    </span>
                                    <div class="d-inline-block text-right float-right" v-if="customerOrders != null">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <label class="mr-1 mb-0">Accepted</label>
                                                <b-badge variant="success" pill>{{_ordersAccepted}}</b-badge>
                                            </div>

                                            <div class="ml-2">
                                                <label class="mr-1 mb-0">Declined</label>
                                                <b-badge variant="danger" pill>{{_ordersDeclined}}</b-badge>
                                            </div>

                                            <b-dropdown class="ml-2" size="sm" menu-class="large">
                                                <template v-slot:button-content>
                                                    Orders
                                                    <b-badge variant="primary" class="mx-1" pill>{{ customerOrders.length }}
                                                    </b-badge>
                                                </template>
                                                <b-table
                                                        selectable-row
                                                        class="orders-dropdown-table"
                                                        small
                                                        hover
                                                        :fields="[{key:'alerts', label:''},'id',{key:'brand.name', label:'Brand'},{key:'offers', label:'Offer %'}, {key:'status_name', label:'status'}, {key:'created_at', label:'date'}]"
                                                        :items="_customerOrdersReverse"
                                                        @row-clicked="orderSelect"
                                                >

                                                    <template v-slot:cell(alerts)="data">
                                                        <div class="d-flex">
                                                            <i v-if="hasStopWorkFlow(data)" class="fa-regular fa-exclamation-triangle text-danger"></i>
                                                            <i v-if="data.item.id === order.id"
                                                               class="fa-regular fa-arrow-circle-right"
                                                               :class="hasStopWorkFlow(data) && data.item.id === order.id ? 'ml-1': '' "></i>
                                                        </div>
                                                    </template>
                                                    <template v-slot:cell(offers)="data">
                                                        <span v-if="data.item.displayCurrentOffer">
                                                            {{((((data.item.displayCurrentOffer.total_offer+data.item.displayCurrentOffer.bonus_amount )/ data.item.displayCurrentOffer.total_value) * 100).toFixed()) || 0 }}%
                                                        </span>
                                                        <span v-else>
                                                            0%
                                                        </span>
                                                    </template>
                                                    <template v-slot:cell(brand.name)="data">
                                                        {{ (data.value).match(/[A-Z]/g).join('') }}
                                                    </template>
                                                    <template v-slot:cell(status)="data">
                                                        {{ data.item.Status.status }}
                                                    </template>
                                                    <template v-slot:cell(created_at)="data">
                                                        {{ data.item.created_at | datetime}}
                                                    </template>

                                                </b-table>
                                            </b-dropdown>
                                        </div>
                                    </div>
                                    <div class="d-inline-block text-center" v-else>
                                        <i class="fa-regular fa-spinner fa-spin"></i>
                                    </div>
                                </template>
                                <b-card class="mb-0 h-100">
                                    <div class="customer-section-rows">
                                        <!-- address and map -->
                                        <b-row>
                                            <b-col><label>Address</label></b-col>
                                        </b-row>
                                        <b-form-row>
                                            <b-col cols="7">
                                                <div class="editable item">
                                                    <validation-observer ref="observer" v-slot="{ passes, invalid, errors }">

                                                        <div @click="edits.address.isEditing = !edits.address.isEditing"
                                                             v-if="!edits.address.isEditing" class="data pointer"
                                                             :class="edits.compliance.address != 0 ? 'danger-zone': ''">
                                                            {{ customer.address.address1 }} {{ customer.address.address2 }}<br>
                                                            {{ customer.address.city }},
                                                            {{ customer.address.state }}
                                                            {{ customer.address.zip }}

                                                            <validation-provider
                                                                    :rules="{ required: true }"
                                                                    immediate
                                                                    name="address"
                                                                    v-slot="validationContext">

                                                            </validation-provider>
                                                            <div v-if="edits.address.isSaved" class="onSave saveBlock">
                                                                <i class="fa-solid fa-check-circle text-success fa-2x"></i>
                                                            </div>
                                                        </div>
                                                        <div class="edits" v-else>
                                                            <div class="inputs">
                                                                <b-form-input size="sm" type="text" title="Address 1" placeholder="Address 1"
                                                                              @click.once="$event.target.select()" v-model="customer.address.address1">
                                                                </b-form-input>

                                                                <b-form-input size="sm" type="text" title="Address 2" placeholder="Address 2"
                                                                              @click.once="$event.target.select()" v-model="customer.address.address2">
                                                                </b-form-input>

                                                                <b-form-input size="sm" type="text" title="City" placeholder="City"
                                                                              @click.once="$event.target.select()" v-model="customer.address.city">
                                                                </b-form-input>


                                                                <input type="hidden" v-model="customer.address.state">
                                                                <multiselect v-model="_state"
                                                                             :options="US_STATES_LIST"
                                                                             :optionHeight="8" group-values="types" group-label="name"
                                                                             :searchable="true" :close-on-select="true" :show-labels="false"
                                                                             :group-select="false" track-by="id" label="name"
                                                                             placeholder="Select State">

                                                                </multiselect>
                                                                <b-form-input size="sm" type="text" title="Zip Code" placeholder="Zip Code"
                                                                              maxlength="5" @click.once="$event.target.select()"
                                                                              v-model="customer.address.zip">
                                                                </b-form-input>
                                                                <b-form-checkbox
                                                                        size="sm"
                                                                        v-model="customer.address.po_box_verified"
                                                                        name="po-box-verified"
                                                                >PO Box Verified</b-form-checkbox>
                                                                <b-form-checkbox
                                                                        size="sm"
                                                                        v-model="customer.address.business_verified"
                                                                        name="business_verified"
                                                                >Business Verified</b-form-checkbox>
                                                                <b-form-checkbox
                                                                        size="sm"
                                                                        v-model="customer.address.address_undeliverable"
                                                                        name="address_undeliverable"
                                                                >Address Undeliverable</b-form-checkbox>

                                                            </div>
                                                            <div class="controls mt-1 text-right">
                                                                <template v-if="!edits.address.isSaving">
                                                                    <i @click="cancelEdits" data-editing="address"
                                                                       class="fa-solid fa-times text-danger pointer">
                                                                    </i>
                                                                    <i @click="saveEdits" data-editing="address"
                                                                       class="fa-solid fa-save text-success pointer ml-2">
                                                                    </i>
                                                                </template>
                                                                <template v-else>
                                                                    <i class="fa-solid fa-spinner fa-spin"></i>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </validation-observer>
                                                </div>

                                                <div class="font-xxs text-uppercase font-weight-bold" v-if="!edits.address.isEditing && !edits.address.isSaving">
                                                    <template v-if="!getValidStandardAddress() && !getPoBoxAddress()"><span class="text-danger mr-2"><i class="fa-regular fa-times-circle fa-fw"></i> Unable to Validate</span></template>
                                                    <template v-else-if="getValidStandardAddress()"><span class="text-success mr-2"><i class="fa-regular fa-check fa-fw"></i> Valid Address</span></template>
                                                    <template v-else-if="getPoBoxAddress()"><span class="text-warning mr-2"><i class="fa-regular fa-exclamation-triangle fa-fw"></i> P.O. Box</span></template>
                                                    <template v-if="customer.address.address_undeliverable"><span class="text-danger mr-2"><i class="fa-regular fa-exclamation-triangle fa-fw"></i> Address Undeliverable</span></template>
                                                </div>
                                            </b-col>
                                            <b-col>
                                                <a href="#" v-b-modal.modal-map><h5><i class="fa-solid fa-map-marker-alt fa-sm mr-1"></i>Map</h5></a>
                                                
                                            </b-col>
                                        </b-form-row>
                                        <b-form-row v-if="_filteredAddressValidationResults.length > 0">
                                            <b-col>
                                                <b-card no-body class="mt-1 mb-2" body-class="py-2">
                                                    <b-card-header v-b-toggle.address-messages class="p-1">
                                                        <i class="fa-solid fa-exclamation-triangle fa-xs mr-1"></i> <span class="label">Address Verification Alerts</span>
                                                        <span class="float-right">
                                                            <i class="when-open fa-solid fa-caret-up"></i>
                                                            <i class="when-closed fa-solid fa-caret-down"></i>
                                                        </span>
                                                    </b-card-header>
                                                    <b-collapse id="address-messages">
                                                        <b-card-body class="p-2">
                                                            <b-card-text>
                                                                <div v-for="item in _filteredAddressValidationResults" :key="item.code">
                                                                    <div>
                                                                        <i v-if="item.type == 'address_error'" class="fa-solid fa-circle-x text-danger fa-xs mr-1"></i>
                                                                        <i v-else-if="item.type == 'address_correction'" class="fa-solid text-info fa-edit fa-xs mr-1"></i>
                                                                        <i v-else class="fa-solid fa-exclamation-triangle text-warning fa-xs mr-1"></i>
                                                                        <span class="font-xs"><small class="font-weight-bold">{{ item.code}}</small></span>
                                                                    </div>
                                                                    <div class="font-xs" style="line-height: normal;"><small>{{ item.text }}</small></div>
                                                                </div>
                                                            </b-card-text>
                                                        </b-card-body>
                                                    </b-collapse>
                                                </b-card>
                                            </b-col>
                                        </b-form-row>
                                    </div>

                                    <!-- email and password -->
                                    <b-form-row class="customer-section-rows">
                                        <b-col cols="7">
                                            <div class="editable item">
                                                <label>Email</label>
                                                <div @click="edits.email.isEditing = !edits.email.isEditing"
                                                     v-if="!edits.email.isEditing" class="data pointer">
                                                    {{ customer.email }}
                                                    <div v-if="edits.email.isSaved" class="onSave saveBlock">
                                                        <i class="fa-solid fa-check-circle text-success fa-2x"></i>
                                                    </div>
                                                </div>
                                                <div class="edits" v-else>
                                                    <validation-observer ref="observer" v-slot="{ passes, invalid }">
                                                        <div class="inputs">
                                                            <validation-provider
                                                                    name="Email"
                                                                    :rules="{ required: true, email: true }"
                                                                    immediate
                                                                    v-slot="validationContext">
                                                                <b-form-input size="sm"
                                                                              v-model="customer.email"
                                                                              id="input_email"
                                                                              @click.once="$event.target.select()"
                                                                              autocomplete="off"
                                                                              :state="getValidationState(validationContext)">
                                                                </b-form-input>
                                                            </validation-provider>
                                                            <small v-if="mailCheckedEmail" class='mb-2 d-block form--notice form--suggestEmail'>
                                                                Did you mean <span class="font-weight-bold pointer" @click="setEmail">{{ mailCheckedEmail }}</span>?
                                                                <span class="font-weight-bold pointer text-primary" @click="setEmail">Yes</span> / <span class="font-weight-bold pointer text-danger" @click="ignoreEmail">No</span>
                                                            </small>


                                                            <b-form-checkbox
                                                                    size="sm"
                                                                    v-model="_do_not_send"
                                                                    name="checkbox-undeliverable"
                                                            >Send Email</b-form-checkbox>
                                                            <b-form-checkbox
                                                                    size="sm"
                                                                    v-model="_unsubscribed"
                                                                    name="checkbox-unsubscribe"
                                                            >Email Subscribed</b-form-checkbox>
                                                        </div>
                                                        <div class="controls mt-1 text-right">
                                                            <template v-if="!edits.email.isSaving">
                                                                <i @click="cancelEdits" data-editing="email"
                                                                   class="fa-solid fa-times text-danger pointer">
                                                                </i>
                                                                <i v-if="!invalid" @click="saveEdits" data-editing="email"
                                                                   class="fa-solid fa-save text-success pointer ml-2">
                                                                </i>
                                                                <i v-else
                                                                   class="fa-solid fa-save text-muted ml-2">
                                                                </i>
                                                            </template>
                                                            <template v-else>
                                                                <i class="fa-solid fa-spinner fa-spin"></i>
                                                            </template>
                                                        </div>
                                                    </validation-observer>
                                                </div>
                                                <div class="font-xxs text-uppercase font-weight-bold" v-if="!edits.email.isEditing && !edits.email.isSaving">
                                                    <template v-if="customer.email_undeliverable"><span class="text-danger"><i class="fa-regular fa-exclamation-triangle fa-fw"></i>Undeliverable</span></template>
                                                    <template v-else-if="customer.email_do_not_send"><span class="text-danger"><i class="fa-regular fa-times-circle fa-fw"></i>Do Not Send</span></template>
                                                    <template v-else-if="customer.email_unsubscribe"><span class="text-danger"><i class="fa-regular fa-times-circle fa-fw"></i>Unsubscribed</span></template>
                                                    <template v-else><span class="text-success"><i class="fa-regular fa-check fa-fw"></i>Subscribed</span></template>
                                                </div>
                                            </div>
                                        </b-col>
                                        <b-col>
                                            <div class="password item">
                                                <label>Password</label>
                                                <div class="data">
                                                    <button type="button" class="btn btn-link btn-sm p-0 mr-1" @click="resetPassword"
                                                            :disabled="passwordResetData.isSaving || !_customerHasAccount"
                                                            v-b-tooltip.hover title="Reset Password">
                                                        <i class="text-primary fa-solid fa-undo"
                                                           v-if="!passwordResetData.isSaving"></i>
                                                        <i v-else class="text-info ml-1 fa-regular fa-spin fa-spinner"></i>
                                                    </button>
                                                    <i class="fa-solid fa-user-lock fa-fw text-success" v-if="_customerHasAccount" id="customer-account-true"></i>
                                                    <i class="fa-solid fa-user-unlock fa-fw text-danger" v-else id="customer-account-false"></i>
                                                    <b-tooltip target="customer-account-true">
                                                        <i class="fa-solid fa-check fa-fw fa-lg text-success"></i> Account created. Password reset available.
                                                    </b-tooltip>
                                                    <b-tooltip target="customer-account-false">
                                                        <i class="fa-solid fa-ban fa-fw fa-lg text-danger"></i> Reset PW not available. Customer needs to create an account/password through My Account.
                                                    </b-tooltip>
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-form-row>
                                    <!-- phone 1 and phone 2 -->
                                    <b-form-row  class="customer-section-rows">
                                        <b-col cols="7">
                                            <div class="editable item">
                                                <label>Primary Phone</label>
                                                <validation-observer ref="observer" v-slot="{ passes, invalid, errors }">
                                                    <div @click="edits.phone.isEditing = !edits.phone.isEditing"
                                                         v-if="!edits.phone.isEditing" class="data pointer"
                                                         :class="invalid ? 'danger-zone': ''">
                                                        {{ customer.phone }}
                                                        <div style="margin-top: -6px;">
                                                            <small v-if="customer.do_not_call" class="label mr-2"><i class="fa-solid fa-ban text-danger"></i> DNC Customer</small>
                                                            <small v-if="order.do_not_call" class="label"><i class="fa-solid fa-ban text-danger"></i> DNC Order</small>
                                                        </div>
                                                        <div v-if="edits.phone.isSaved" class="onSave saveBlock">
                                                            <i class="fa-solid fa-check-circle text-success fa-2x"></i>
                                                        </div>
                                                        <validation-provider
                                                                :rules="{ is: null}"
                                                                immediate
                                                                name="phone_valid"
                                                                v-slot="validationContext">
                                                            <input type="hidden" v-model="customer.phone_invalid">
                                                        </validation-provider>
                                                        <validation-provider
                                                                :rules="{ required: true }"
                                                                immediate
                                                                name="phone"
                                                                v-slot="validationContext">
                                                            <input type="hidden" v-model="customer.phone">
                                                        </validation-provider>
                                                    </div>
                                                    <div class="edits" v-else>
                                                        <div class="inputs">
                                                            <validation-provider
                                                                    :rules="{ required: true, regex:/^\d{10}$/}"
                                                                    immediate
                                                                    name="phone"
                                                                    v-slot="validationContext">
                                                                <!--v-mask="'(###) ###-####'" this is too difficult to alter everything for right now-->
                                                                <b-form-input size="sm" type="number"
                                                                              v-model="customer.phone"
                                                                              @click.once="$event.target.select()"
                                                                              :state="getValidationState(validationContext)"
                                                                              v-b-tooltip.hover
                                                                              :title="getValidationComplaint(validationContext)"
                                                                >
                                                                </b-form-input>
                                                            </validation-provider>

                                                            <b-form-checkbox
                                                                    size="sm"
                                                                    v-model="customer.do_not_call"
                                                                    name="dnc-customer"
                                                            >DNC Customer</b-form-checkbox>

                                                            <b-form-checkbox
                                                                    size="sm"
                                                                    v-model="order.do_not_call"
                                                                    name="dnc-order"
                                                            >DNC Order</b-form-checkbox>
                                                        </div>
                                                        <div class="controls mt-1 text-right">
                                                            <template v-if="!edits.phone.isSaving">
                                                                <i @click="cancelEdits" data-editing="phone"
                                                                   class="fa-solid fa-times text-danger pointer">
                                                                </i>
                                                                <i @click="saveEdits" data-editing="phone"
                                                                   class="fa-solid fa-save text-success pointer ml-2">
                                                                </i>
                                                            </template>
                                                            <template v-else>
                                                                <i class="fa-solid fa-spinner fa-spin"></i>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </validation-observer>
                                            </div>
                                        </b-col>
                                        <b-col>
                                            <div class="phone-2 item">
                                                <validation-observer ref="observer" v-slot="{ passes, invalid, errors }">
                                                    <label>Secondary Phone</label>

                                                    <div @click="edits.mobile_phone.isEditing = !edits.mobile_phone.isEditing"
                                                         v-if="!edits.mobile_phone.isEditing" class="data pointer"
                                                         :class="invalid ? 'danger-zone': ''">
                                                        {{customer.mobile_phone ? customer.mobile_phone : '-'}}
                                                        <validation-provider
                                                                :rules="{ is: null}"
                                                                immediate
                                                                name="phone"
                                                                v-slot="validationContext">
                                                            <input type="hidden" v-model="customer.mobile_phone_invalid">
                                                        </validation-provider>
                                                    </div>
                                                    <div v-else>
                                                        <validation-provider
                                                                :rules="{ regex:/^\d{10}$/}"
                                                                immediate
                                                                name="phone"
                                                                v-slot="validationContext">
                                                            <b-form-input size="sm"
                                                                          :state="getValidationState(validationContext)"
                                                                          v-b-tooltip.hover
                                                                          @click.once="$event.target.select()"
                                                                          :title="getValidationComplaint(validationContext)"
                                                                          v-model="customer.mobile_phone">
                                                            </b-form-input>
                                                        </validation-provider>
                                                        <div class="controls mt-1 text-right">
                                                            <template v-if="!edits.mobile_phone.isSaving">
                                                                <i @click="cancelEdits" data-editing="mobile_phone"
                                                                   class="fa-solid fa-times text-danger pointer">
                                                                </i>
                                                                <i @click="saveEdits" data-editing="mobile_phone"
                                                                   class="fa-solid fa-save text-success pointer ml-2">
                                                                </i>
                                                            </template>
                                                            <template v-else>
                                                                <i class="fa-solid fa-spinner fa-spin"></i>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </validation-observer>
                                            </div>
                                        </b-col>
                                    </b-form-row>
                                    <!-- drivers license and DOB -->
                                    <b-form-row class="customer-section-rows">
                                        <b-col  cols="7">
                                            <div class="editable item">
                                                <validation-observer ref="id_observer" v-slot="{ passes, invalid, errors }">
                                                    <label>ID Number:</label>
                                                    <div @click="edits.id.isEditing = !edits.id.isEditing"
                                                         :class="invalid ? 'danger-zone': ''"
                                                         v-b-tooltip.hover
                                                         :title="getComplaintList(errors) ? 'tes': ''"
                                                         v-if="!edits.id.isEditing" class="data pointer">
                                                        <template v-if="customer.identity_type == 'passport'">
                                                            {{ customer.identity_country }}
                                                        </template>
                                                        <template v-else-if="customer.identity_type == 'drivers-license' || customer.identity_type == 'state-issued' ">
                                                            {{ customer.identity_state }}
                                                        </template>
                                                        {{ customer.identity_type | titleCase }}<br>
                                                        {{ customer.identity_number_masked }}<br>
                                                        {{ customer.identity_expiration ? formatDate(customer.identity_expiration) : '-'}}
                                                        <div v-if="edits.id.isSaved" class="onSave saveBlock">
                                                            <i class="fa-solid fa-check-circle text-success fa-2x"></i>
                                                        </div>
                                                        <validation-provider
                                                                :rules="{ required: true}"
                                                                immediate
                                                                name="id type"
                                                                v-slot="validationContext">
                                                            <input size="sm" type="hidden"
                                                                   v-model="customer.identity_type"
                                                                   :options="edits.id.identity_type.options"
                                                            >
                                                        </validation-provider>

                                                        <validation-provider
                                                                :rules="{ required: true}"
                                                                immediate
                                                                :name="customer.identity_type == 'passport' ? 'id state' : 'id country'"
                                                                v-slot="validationContext">
                                                            <input v-if="customer.identity_type == 'passport'"
                                                                   size="sm" v-model="customer.identity_country"
                                                                   type="hidden"
                                                                   :options="['US','AD']">
                                                            <input v-else size="sm"
                                                                   v-model="customer.identity_state"
                                                                   type="hidden"
                                                                   :options="US_STATES">
                                                        </validation-provider>


                                                        <validation-provider
                                                                :rules="{ required: true, regex: '^((?!true).)*$'}"
                                                                immediate
                                                                name="verified states"
                                                                v-slot="validationContext">
                                                            <input size="sm" v-model="customer.DL_error"
                                                                   type="hidden">
                                                        </validation-provider>

                                                        <validation-provider
                                                                :rules="{ required: true}"
                                                                immediate
                                                                name="id number"
                                                                v-slot="validationContext">
                                                            <input size="sm" v-model="customer.identity_number_masked"
                                                                   type="hidden">
                                                        </validation-provider>

                                                        <validation-provider
                                                                :rules="{ required: false, datenotexpired: customer.DL_verified ? false : true}"
                                                                immediate
                                                                name="id expiration"
                                                                v-slot="validationContext">
                                                            <input size="sm" v-model="customer.identity_expiration"
                                                                   type="hidden">
                                                        </validation-provider>
                                                    </div>
                                                    <div class="edits" v-else>
                                                        <div class="inputs">
                                                            <validation-provider
                                                                    :rules="{ required: true}"
                                                                    immediate
                                                                    name="id type"
                                                                    v-slot="validationContext">
                                                                <b-form-select size="sm"
                                                                               :state="getValidationState(validationContext)"
                                                                               v-b-tooltip.hover
                                                                               :title="getValidationComplaint(validationContext)"
                                                                               v-model="customer.identity_type"
                                                                               :options="edits.id.identity_type.options"
                                                                >
                                                                </b-form-select>
                                                            </validation-provider>

                                                            <validation-provider
                                                                    :rules="{ required: true}"
                                                                    immediate
                                                                    :name="customer.identity_type == 'passport' ? 'id state' : 'id country'"
                                                                    v-slot="validationContext">
                                                                <b-form-select v-if="customer.identity_type == 'passport'"
                                                                               size="sm" v-model="customer.identity_country"
                                                                               :state="getValidationState(validationContext)"
                                                                               v-b-tooltip.hover
                                                                               :title="getValidationComplaint(validationContext)"
                                                                               :options="['US']">
                                                                </b-form-select>
                                                                <template v-if="customer.identity_type != 'military' ">
                                                                    <input type="hidden" v-model="customer.identity_state">
                                                                    <multiselect v-model="_state_identity"
                                                                                 :options="US_STATES_LIST_UNFILTERED"
                                                                                 :optionHeight="8" group-values="types" group-label="name"
                                                                                 :searchable="true" :close-on-select="true" :show-labels="false"
                                                                                 :group-select="false" track-by="id" label="name"
                                                                                 placeholder="Select State">

                                                                    </multiselect>
                                                                </template>

                                                            </validation-provider>

                                                            <validation-provider
                                                                    :rules="{ required: true}"
                                                                    immediate
                                                                    name="id number"
                                                                    v-slot="validationContext">
                                                                <b-form-input size="sm" v-model="customer.identity_number"
                                                                              @click.once="$event.target.select()"
                                                                              :state="getValidationState(validationContext)"
                                                                              v-b-tooltip.hover
                                                                              :title="getValidationComplaint(validationContext)"></b-form-input>
                                                            </validation-provider>

                                                            <validation-provider
                                                                    :rules="{ required: false, datenotexpired: customer.DL_verified ? false : true}"
                                                                    immediate
                                                                    name="id expiration"
                                                                    v-slot="validationContext">
                                                                <b-form-input type="date" size="sm" v-model="customer.identity_expiration"
                                                                                @click.once="$event.target.select()"
                                                                                :state="getValidationState(validationContext)"
                                                                                v-b-tooltip.hover
                                                                                :title="getValidationComplaint(validationContext)"></b-form-input>
                                                            </validation-provider>

                                                            <b-form-checkbox
                                                                    v-if="!edits.banned.isSaving"
                                                                    size="sm"
                                                                    class="nice-toggle-success  mt-2"
                                                                    name="Drivers license force checked"
                                                                    v-model="customer.DL_verified"
                                                                    switch >
                                                                <strong>Override Driver License Check?</strong>
                                                            </b-form-checkbox>
                                                        </div>
                                                        <div class="controls mt-1 text-right">
                                                            <template v-if="!edits.id.isSaving">
                                                                <i @click="cancelEdits" data-editing="id"
                                                                   class="fa-solid fa-times text-danger pointer">
                                                                </i>
                                                                <i @click="saveEdits" data-editing="id"
                                                                   class="fa-solid fa-save text-success pointer ml-2">
                                                                </i>
                                                            </template>
                                                            <template v-else>
                                                                <i class="fa-solid fa-spinner fa-spin"></i>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </validation-observer>
                                            </div>

                                            <!-- ID Picture -->
                                            <div v-if="mediaCustomerIDPhoto">
                                                <b-button
                                                    variant="light"
                                                    size="sm"
                                                    @click="openUploadedDocument(mediaCustomerIDPhoto.file_path)"
                                                    v-b-tooltip.hover title="View ID"
                                                ><i class="text-primary fa-solid fa-id-card"></i>
                                                </b-button>
                                            </div>
                                        </b-col>
                                        <b-col>
                                            <div class="editable item">

                                                <validation-observer ref="dob_observer" v-slot="{ passes, invalid, errors }">
                                                    <label>DOB:</label>
                                                    <validation-provider
                                                            :rules="{ required: true, dobover18:true,dobreasonablerange:true }"
                                                            immediate
                                                            name="DOB"
                                                            v-slot="validationContext">
                                                        <div @click="edits.dob.isEditing = !edits.dob.isEditing" :class="invalid ? 'danger-zone': ''"
                                                             v-if="!edits.dob.isEditing" class="data pointer">
                                                            {{customer.dob ? formatDate(customer.dob) : '-'}}
                                                            <div v-if="edits.dob.isSaved" class="onSave saveBlock">
                                                                <i class="fa-solid fa-check-circle text-success fa-2x"></i>
                                                            </div>
                                                            <input type="hidden" v-model="customer.dob">
                                                        </div>
                                                        <div class="edits" v-else>
                                                            <div class="inputs">
                                                                <b-form-input type="date" size="sm" v-model="customer.dob"
                                                                              @click.once="$event.target.select()"
                                                                              :state="getValidationState(validationContext)"
                                                                              v-b-tooltip.hover
                                                                              :title="getValidationComplaint(validationContext)"></b-form-input>
                                                            </div>
                                                            <div class="controls mt-1 text-right">
                                                                <template v-if="!edits.dob.isSaving">
                                                                    <i @click="cancelEdits" data-editing="dob"
                                                                       class="fa-solid fa-times text-danger pointer">
                                                                    </i>
                                                                    <i @click="saveEdits" data-editing="dob"
                                                                       class="fa-solid fa-save text-success pointer ml-2">
                                                                    </i>
                                                                </template>
                                                                <template v-else>
                                                                    <i class="fa-solid fa-spinner fa-spin"></i>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </validation-provider>
                                                </validation-observer>
                                            </div>

                                            <!-- SSN Last 4 -->
                                            <div class="editable item">
                                                <validation-observer ref="ssn_observer" v-slot="{ passes, invalid, errors }">
                                                    <label>SSN Last 4:</label>
                                                    <validation-provider
                                                            :rules="{ required: true, digits:4 }"
                                                            immediate
                                                            name="SSN Last 4"
                                                            v-slot="validationContext">
                                                        <div @click="edits.ssn_last_4.isEditing = !edits.ssn_last_4.isEditing" :class="invalid ? 'danger-zone': ''"
                                                            v-if="!edits.ssn_last_4.isEditing" class="data pointer">
                                                            {{customer.ssn_last_4_masked ? customer.ssn_last_4_masked : '-'}}
                                                            <div v-if="edits.ssn_last_4.isSaved" class="onSave saveBlock">
                                                                <i class="fa-solid fa-check-circle text-success fa-2x"></i>
                                                            </div>
                                                            <input type="hidden" v-model="customer.ssn_last_4">
                                                        </div>
                                                        <div class="edits" v-else>
                                                            <div class="inputs">
                                                                <b-form-input size="sm" v-model="customer.ssn_last_4"
                                                                            :formatter="$inputSanitizer.toDigits"
                                                                            @click.once="$event.target.select()"
                                                                            :state="getValidationState(validationContext)"
                                                                            v-b-tooltip.hover
                                                                            :title="getValidationComplaint(validationContext)"></b-form-input>
                                                            </div>
                                                            <div class="controls mt-1 text-right">
                                                                <template v-if="!edits.ssn_last_4.isSaving">
                                                                    <i @click="cancelEdits" data-editing="ssn_last_4"
                                                                    class="fa-solid fa-times text-danger pointer">
                                                                    </i>
                                                                    <i @click="saveEdits" data-editing="ssn_last_4"
                                                                    class="fa-solid fa-save text-success pointer ml-2">
                                                                    </i>
                                                                </template>
                                                                <template v-else>
                                                                    <i class="fa-solid fa-spinner fa-spin"></i>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </validation-provider>
                                                </validation-observer>
                                            </div>
                                        </b-col>
                                    </b-form-row>

                                    <!-- Idology -->
                                    <b-form-row class="customer-section-rows">
                                        <b-col  cols="7">
                                            <div class="idology item">
                                                <label>Idology:</label>
                                                <div class="data">
                                                    <b-button
                                                            variant="primary"
                                                            size="sm"
                                                            @click="runIdology"
                                                            :disabled="idology.idology_working"
                                                    >Run IDV
                                                    </b-button>
                                                    <b-button
                                                            variant="primary"
                                                            size="sm"
                                                            class="ml-2"
                                                            @click="clearIdology"
                                                            :disabled="idology.idology_working"
                                                    >Clear
                                                    </b-button>
                                                </div>

                                            </div>

                                        </b-col>
                                        <b-col>
                                            <div class="idology-results item">
                                                <label>Idology Results:</label>
                                                <div v-if="idology.idology_working"><i class="fa-regular fa-spinner fa-spin fa-fw"></i></div>
                                                <div v-else class="data font-xs" :class="(order.idology_status === 2 && order.idology_message) ? 'text-success' : 'text-danger'">
                                                    <span v-if="order.idology_status === 2">PASS:</span>
                                                    <span v-else-if="order.idology_status !== 2 && order.idology_message">FAIL:</span>
                                                    <span :class="!order.idology_message ? 'text-dark' : ''">
                                                        {{order.idology_message ? order.idology_message : '-'}}
                                                    </span>
                                                </div>
                                            </div>
                                            <b-button
                                                    v-if="(order.idology_status == 0 || order.idology_status == 1) && !idology.questions_presented"
                                                    variant="success"
                                                    size="sm"
                                                    class="ml-2"
                                                    @click="forcefullyVerifyIdology"
                                                    :disabled="idology.idology_working"
                                            >Force Verify
                                            </b-button>
                                        </b-col>
                                    </b-form-row>
                                    <b-form-row  class="customer-section-rows">
                                        <b-col>
                                            <div class="schedule-call item">
                                                <label>Schedule Call for</label>
                                                <div class="data">
                                                    <i class="fa-light fa-clock fa-sm pt-1 pr-1"></i>
                                                    {{ _scheduledFive9Call ? (_scheduledFive9Call) : 'No calls scheduled'}}
                                                    <!--<i class="fa-light fa-trash text-danger fa-sm" @click="deleteScheduledFive9Call"></i>-->
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-form-row>
                                </b-card>
                            </b-card>
                        </b-col>

                        <!-- order -->
                        <b-col cols="7">
                            <b-card body-border-variant="dark"
                                    id="order"
                                    class="mb-0"
                                    header-class="p-2"
                                    body-class="p-2"
                                    body-bg-variant="secondary">
                                <!--header-->
                                <template v-slot:header>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <span class="mb-0 h6" id="inventory_management_icon">
                                                <i class="fa-solid fa-box fa-fw"></i> Order {{ order.id }}
                                                <template  v-if="currentInventoryManagement.length != 0"><span v-for="inventoryManagement in currentInventoryManagement" :id="'inventory_management_icon-'+inventoryManagement.id" class="badge badge-pill badge-info pr-2 mr-1" >{{ inventoryManagement.status_name_abbreviation }}</span>
                                                </template>
                                                <span v-else-if="latestInventoryManagement" class="badge badge-pill badge-info pr-2" >{{ latestInventoryManagement.status_name_abbreviation }}</span>
                                             </span>
                                            <template
                                                    v-if="currentInventoryManagement.length != 0">
                                                <b-tooltip
                                                        v-for="inventoryManagement in currentInventoryManagement"
                                                        noninteractive
                                                        :target="'inventory_management_icon-'+inventoryManagement.id"
                                                        :variant="'light'">
                                                    {{ inventoryManagement.status_name }} <span v-if="inventoryManagement.cage_id"> - Cage {{ inventoryManagement.cage_id }}</span>
                                                </b-tooltip>
                                            </template>
                                            <b-tooltip
                                                    v-else-if="latestInventoryManagement"
                                                    noninteractive
                                                    target="inventory_management_icon"
                                                    :variant="'light'">
                                                {{ latestInventoryManagement.status_name }} <span v-if="latestInventoryManagement.cage_id"> - Cage {{ latestInventoryManagement.cage_id }}</span>
                                            </b-tooltip>
                                        </div>
                                        <div class="d-flex">
                                            <div class="editable item d-flex pb-0 align-items-center mr-3">
                                                <label class="m-0 p-0">Status:</label>
                                                <div @click="activateStatus"
                                                     v-if="!edits.status.isEditing" class="data pointer pb-0 px-1 pr-3">
                                                    {{ order.status_name | titleCase }}
                                                    <div v-if="edits.status.isSaved" class="onSave saveBlock">
                                                        <i class="fa-solid fa-check-circle text-success fa-2x"></i>
                                                    </div>
                                                </div>
                                                <div class="edits d-flex" v-else>
                                                    <div class="inputs">
                                                        <b-form-select size="sm" v-model="order.status_id"
                                                                       :options="[
                                                                           {value: 1, text: 'Kit Requested'},
                                                                           {value: 2, text: 'Kit Shipped'},
                                                                           {value: 3, text: 'Kit Inbound'},
                                                                           {value: 4, text: 'Kit Received'},
                                                                           {value: 5, text: 'Appraisal'},
                                                                           {value: 6, text: 'Appraisal Hold'},
                                                                           {value: 16, text: 'Quality Assurance'},
                                                                           {value: 7, text: 'Offer Generation'},
                                                                           {value: 8, text: 'Offer Ready'},
                                                                           {value: 9, text: 'Offer Accepted'},
                                                                           {value: 10, text: 'Offer Declined'},
                                                                           {value: 11, text: 'Reverse Ship'},
                                                                           {value: 12, text: 'Returned'},
                                                                           {value: 13, text: 'Settled'},
                                                                           {value: 14, text: 'Batched'},
                                                                           {value: 15, text: 'Closed'},
                                                                       ]">
                                                            <template #first>
                                                                <b-form-select-option v-if="canMarkAsInvalidRequest" :value="0">Invalid Request</b-form-select-option>
                                                            </template>
                                                        </b-form-select>
                                                    </div>
                                                    <div class="controls ml-1">
                                                        <template v-if="!edits.status.isSaving">
                                                            <i @click="cancelEdits" data-editing="status"
                                                               class="fa-solid fa-times text-danger pointer">
                                                            </i>
                                                            <i @click="saveEdits" data-editing="status"
                                                               class="fa-solid fa-save text-success pointer ml-2">
                                                            </i>
                                                        </template>
                                                        <template v-else>
                                                            <i class="fa-solid fa-spinner fa-spin"></i>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>


                                            <b-dropdown text="Dropdown Button" class="mx-2" size="sm">
                                                <template #button-content>
                                                    <i class="fa-solid fa-barcode"></i> Print Labels
                                                </template>
                                                <b-dropdown-item @click="printOrderLabel"><i class="fa-solid fa-box fa-fw mr-2"></i> Print Order Label</b-dropdown-item>
                                                <b-dropdown-divider></b-dropdown-divider>
                                                <b-dropdown-item :disabled="!inventory" @click="printBagLabels"><i class="fa-solid fa-sack fa-fw mr-2"></i> Print Bag Labels</b-dropdown-item>
                                                <b-dropdown-item :disabled="!inventory" @click="printHoldLabels"><i class="fa-solid fa-rings-wedding fa-fw mr-2"></i> Print Hold Labels</b-dropdown-item>
                                                <b-dropdown-divider v-if="canPrintTracking"></b-dropdown-divider>
                                                <b-dropdown-item v-if="canPrintTracking" @click="modalTrackingShow = true"><i class="fa-solid fa-barcode-scan fa-fw mr-2"></i> Re-Print Shipping Labels</b-dropdown-item>
                                            </b-dropdown>
                                            <div class="d-flex flex-column">
                                                <h5 class="m-0"><b-badge class="p-2">{{ order.brand.name }}</b-badge></h5>
                                            </div>
                                        </div>
                                    </div>
                                </template>


                                <!--shipping-->
                                <b-card header-class="py-1 order-section-header" header="Shipping" class="mb-2" body-class="py-2">
                                    <!-- delivery method & print status -->
                                    <b-form-row>
                                        <b-col>
                                            <div class="print-status item">
                                                <label>Print Status</label>
                                                <div class="data">{{ latestLead ? (latestLead.status) : '-'  | titleCase}}</div>
                                                <b-button size="sm" class="py-0" v-if="latestLead && latestLead.status != 'do-not-print' && latestLead.status != 'printed'" @click="doNotPrintAction">
                                                    Do Not Print
                                                </b-button>
                                            </div>
                                        </b-col>
                                        <b-col>
                                            <div class="delivery-method item">
                                                <label>Delivery Method</label>
                                                <div class="data">{{ latestLead ? (latestLead.fulfillment_method) : '-' | titleCase}}</div>
                                            </div>
                                        </b-col>

                                        <b-col>
                                            <div class="inbound-method item">
                                                <label>Inbound Method</label>
                                                <div class="data">{{ fedex ? fedex.shipping_service : '-' }}</div>
                                            </div>
                                        </b-col>
                                        <b-col>
                                            <div class="estimate-delivery item">
                                                <label class="sub-label">Est. Delivery</label>
                                                <div class="data">{{_activeTracking ? formatDate(_activeTracking.expected_delivery_at) : '-' }}</div>
                                            </div>
                                        </b-col>
                                        <b-col>
                                            <div class="home-pickup item">
                                                <label class="sub-label" for="home-pickup">Home Pickup</label>
                                                <b-form-checkbox id="home-pickup"
                                                                 v-bind:true-value="1"
                                                                 v-bind:false-value="0"
                                                                 data-editing="home_pickup"
                                                                 switch
                                                                 size="sm"
                                                                 class="nice-toggle-success"
                                                                 v-model="order.home_pickup">
                                                </b-form-checkbox>
                                            </div>

                                            <div class="editable item" v-if="order.home_pickup">
                                                <label class="sub-label">Confirmation #</label>
                                                <div @click="edits.home_pickup_confirmation_number.isEditing = !edits.home_pickup_confirmation_number.isEditing"
                                                     v-if="!edits.home_pickup_confirmation_number.isEditing"
                                                     class="data pointer" style="overflow-wrap: anywhere;">
                                                    {{ order.home_pickup_confirmation_number ? order.home_pickup_confirmation_number : '-' }}
                                                    <div v-if="edits.home_pickup_confirmation_number.isSaved" class="onSave saveBlock">
                                                        <i class="fa-solid fa-check-circle text-success fa-2x"></i>
                                                    </div>
                                                </div>
                                                <div class="edits" v-else>
                                                    <div class="inputs">
                                                        <b-form-input size="sm" @click.once="$event.target.select()"
                                                                      v-model="order.home_pickup_confirmation_number">

                                                        </b-form-input>
                                                    </div>
                                                    <div class="controls mt-1 text-right">
                                                        <template v-if="!edits.home_pickup_confirmation_number.isSaving">
                                                            <i @click="cancelEdits" data-editing="home_pickup_confirmation_number"
                                                               class="fa-solid fa-times text-danger pointer">
                                                            </i>
                                                            <i @click="saveEdits" data-editing="home_pickup_confirmation_number"
                                                               class="fa-solid fa-save text-success pointer ml-2">
                                                            </i>
                                                        </template>
                                                        <template v-else>
                                                            <i class="fa-solid fa-spinner fa-spin"></i>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-form-row>
                                    <hr>

                                    <!-- shipping/fedex info -->
                                    <b-form-row>
                                        <b-col>
                                            <div class="customer-tracking-number item">
                                                <label class="sub-label">E-Kit Tracking</label>
                                                <div class="data" v-if="tracking_number_print">
                                                    <a class="d-block" :href="tracking_number_print_data.tracking_number_url"
                                                       target="_blank">{{ tracking_number_print }} <i
                                                            class="fa-solid fa-external-link-square-alt"></i> </a>
                                                    <b-badge v-if="printTrackingInbound" class="mr-2" variant="success" v-b-tooltip.hover title="Pending Inbound">{{ printTrackingInbound }}</b-badge>
                                                    <b-badge v-if="tracking_number_print_count > 1" class="mr-2" v-b-tooltip.hover title="Requested Labels Count">{{ tracking_number_print_count }}</b-badge>
                                                    <span class="label">{{ tracking_number_print_data.shipper.name }}</span>
                                                </div>
                                                <div v-else>-</div>
                                            </div>
                                        </b-col>
                                        <b-col>
                                            <div class="customer-tracking-number item">
                                                <label class="sub-label">Physical Kit Tracking</label>
                                                <div class="data" v-if="tracking_number_mail">
                                                    <a class="d-block" :href="tracking_number_mail_data.tracking_number_url"
                                                       target="_blank">{{ tracking_number_mail }} <i
                                                            class="fa-solid fa-external-link-square-alt"></i> </a>
                                                    <b-badge v-if="mailTrackingInbound" class="mr-2" variant="success" v-b-tooltip.hover title="Pending Inbound">{{ mailTrackingInbound }}</b-badge>
                                                    <b-badge v-if="tracking_number_mail_count > 1" class="mr-2" v-b-tooltip.hover title="Requested Labels Count">{{ tracking_number_mail_count }}</b-badge>
                                                    <span class="label">{{ tracking_number_mail_data.shipper.name }}</span>
                                                </div>
                                                <div v-else>-</div>
                                            </div>
                                        </b-col>
                                        <b-col>
                                            <div class="editable item">
                                                <label class="sub-label">Alt Tracking Number</label>
                                                <div @click="edits.alternate_tracking_num.isEditing = !edits.alternate_tracking_num.isEditing"
                                                     v-if="!edits.alternate_tracking_num.isEditing" class="data pointer">
                                                    {{ alternate_tracking_number ? alternate_tracking_number : '-' }}
                                                    <div v-if="edits.alternate_tracking_num.isSaved" class="onSave saveBlock">
                                                        <i class="fa-solid fa-check-circle text-success fa-2x"></i>
                                                    </div>
                                                </div>
                                                <div class="edits" v-else>
                                                    <div class="inputs">
                                                        <b-form-input size="sm" v-model="alternate_tracking_number"></b-form-input>
                                                    </div>
                                                    <div class="controls mt-1 text-right">
                                                        <template v-if="!edits.alternate_tracking_num.isSaving">
                                                            <i @click="cancelEdits" data-editing="alternate_tracking_num"
                                                               class="fa-solid fa-times text-danger pointer">
                                                            </i>
                                                            <i @click="saveEdits" data-editing="alternate_tracking_num"
                                                               class="fa-solid fa-save text-success pointer ml-2">
                                                            </i>
                                                        </template>
                                                        <template v-else>
                                                            <i class="fa-solid fa-spinner fa-spin"></i>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-form-row>
                                </b-card>



                                <b-form-row class="mb-2">
                                    <b-col>
                                        <!-- offer -->
                                        <b-card header="Offer"
                                                class="mb-0 h-100"
                                                header-class="py-1 order-section-header"
                                                body-class="py-2">
                                                <b-row>
                                                    <b-col>
                                                        <label>Bonuses</label>
                                                        <b-card class="mb-3" body-class="p-2" bg-variant="light">
                                                            <div class="d-flex">
                                                                <div class="bonus-10 item mr-5">
                                                                    <b-form-checkbox id="bonus-10"
                                                                                     switch
                                                                                     :disabled="edits.bonus_override.isSaving || !_canEditBonus"
                                                                                     @change="bonus_update10"
                                                                                     v-model="_10bonus"> 10% Bonus
                                                                    </b-form-checkbox>
                                                                </div>

                                                                <div class="bonus-5 item">
                                                                    <b-form-checkbox id="bonus-5"
                                                                                     switch
                                                                                     :disabled="edits.bonus_override.isSaving || !_canEditBonus"
                                                                                     @change="bonus_update5"
                                                                                     v-model="_5bonus"> 5% Bonus
                                                                    </b-form-checkbox>
                                                                </div>
                                                            </div>
                                                        </b-card>
                                                    </b-col>
                                                </b-row>
                                                <b-form-row>
                                                    <b-col>
                                                        <div class="editable item">
                                                            <label>Offer Quote:</label>
                                                            <div @click="edits.offer_quote.isEditing = !edits.offer_quote.isEditing"
                                                                 v-if="!edits.offer_quote.isEditing" class="data pointer">
                                                                {{ order.offer_quote ? order.offer_quote: '-' }}
                                                                <div v-if="edits.offer_quote.isSaved" class="onSave saveBlock">
                                                                    <i class="fa-solid fa-check-circle text-success fa-2x"></i>
                                                                </div>
                                                            </div>
                                                            <div class="edits" v-else>
                                                                <div class="inputs">
                                                                    <b-form-input size="sm" v-model="order.offer_quote"></b-form-input>
                                                                </div>
                                                                <div class="controls mt-1 text-right">
                                                                    <template v-if="!edits.offer_quote.isSaving">
                                                                        <i @click="cancelEdits" data-editing="offer_quote"
                                                                           class="fa-solid fa-times text-danger pointer">
                                                                        </i>
                                                                        <i @click="saveEdits" data-editing="offer_quote"
                                                                           class="fa-solid fa-save text-success pointer ml-2">
                                                                        </i>
                                                                    </template>
                                                                    <template v-else>
                                                                        <i class="fa-solid fa-spinner fa-spin"></i>
                                                                    </template>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                    <b-col>
                                                        <div class="editable item">
                                                            <label>Previous Payment Rate:</label>
                                                            <div @click="edits.payment_rate.isEditing = !edits.payment_rate.isEditing"
                                                                 v-if="!edits.payment_rate.isEditing" class="data pointer">
                                                                {{ customer.payment_rate ? `${customer.payment_rate}%`: '-' }}
                                                                <div v-if="edits.payment_rate.isSaved" class="onSave saveBlock">
                                                                    <i class="fa-solid fa-check-circle text-success fa-2x"></i>
                                                                </div>
                                                            </div>
                                                            <div class="edits" v-else>
                                                                <div class="inputs">
                                                                    <b-form-input size="sm" maxlength="2" v-model="customer.payment_rate"></b-form-input>
                                                                </div>
                                                                <div class="controls mt-1 text-right">
                                                                    <template v-if="!edits.payment_rate.isSaving">
                                                                        <i @click="cancelEdits" data-editing="payment_rate"
                                                                           class="fa-solid fa-times text-danger pointer">
                                                                        </i>
                                                                        <i @click="saveEdits" data-editing="payment_rate"
                                                                           class="fa-solid fa-save text-success pointer ml-2">
                                                                        </i>
                                                                    </template>
                                                                    <template v-else>
                                                                        <i class="fa-solid fa-spinner fa-spin"></i>
                                                                    </template>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-form-row>

                                        </b-card>
                                    </b-col>
                                    <b-col>
                                        <!-- payment -->
                                        <b-card header="Payment"
                                                class="mb-0 h-100"
                                                header-class="py-1 order-section-header"
                                                body-class="py-2 payment-card-height">
                                            <validation-observer ref="payment_method_observer" v-slot="{ passes, invalid, errors }">
                                                <div class="editable item">
                                                    <label>Payment Method</label>
                                                    <div @click="edits.payment_method.isEditing = !edits.payment_method.isEditing && !_pendingCustomerPaymentCanEdit"
                                                         :class="(invalid ? 'danger-zone': '') + (!_pendingCustomerPayment ? ' data pointer': '')"
                                                         v-if="!edits.payment_method.isEditing">
                                                        {{ order.payment_method | titleCase }}
                                                        <template v-if=" order.payment_method == 'paypal' ">
                                                            <br/>
                                                            {{ order.paypal_email }}
                                                            <validation-provider
                                                                    :rules="{ required: true, email: true}"
                                                                    immediate
                                                                    name="paypal_email"
                                                                    v-slot="validationContext">
                                                                <input type="hidden" size="sm"
                                                                       placeholder="PayPal Email"
                                                                       v-model="order.paypal_email">
                                                            </validation-provider>
                                                        </template>
                                                        <template v-if=" order.payment_method == 'direct-deposit' ">
                                                            <br/>
                                                            {{ order.bank_routing_masked }}
                                                            <br/>
                                                            {{ order.bank_account_masked }}
                                                            <validation-provider
                                                                    :rules="{ required: true, regex:  /^[\d|\*]{9}$/}"
                                                                    immediate
                                                                    name="routing number"
                                                                    v-slot="validationContext"
                                                            >
                                                                <input type="hidden" size="sm"
                                                                       placeholder="Routing Number"
                                                                       v-model="order.bank_routing_masked">
                                                            </validation-provider>
                                                            <validation-provider
                                                                    :rules="{ required: true } "
                                                                    immediate
                                                                    name="account number"
                                                                    v-slot="validationContext">
                                                                <input type="hidden" size="sm"
                                                                       placeholder="Account Number"
                                                                       v-model="order.bank_account_masked">
                                                            </validation-provider>
                                                            <validation-provider
                                                                    :rules="{ required: true, regex: '^((?!false).)*$'}"
                                                                    immediate
                                                                    name="Bank Routing Valid"
                                                                    v-slot="validationContext">
                                                                <input type="hidden" size="sm"
                                                                       placeholder="routing valid"
                                                                       v-model="order.bank_routing_valid">
                                                            </validation-provider>
                                                            <div class="text-success font-xs" v-if="order.bank_routing_valid && order.bank_routing_valid != true"><i class="fa-regular fa-check-circle mr-1"></i>{{ order.bank_routing_valid }}</div>
                                                            <div class="text-danger font-xs" v-if="!order.bank_routing_valid"><i class="fa-regular fa-times-circle mr-1"></i>BANK NOT FOUND</div>
                                                        </template>
                                                        <div v-if="edits.payment_method.isSaved" class="onSave saveBlock">
                                                            <i class="fa-solid fa-check-circle text-success fa-2x"></i>
                                                        </div>
                                                    </div>
                                                    <div class="edits" v-else>
                                                        <div class="inputs">
                                                            <b-form-select size="sm" v-model="order.payment_method"
                                                                           :options="[{value: 'company-check', text: 'Company Check'}, {value: 'paypal', text: 'Paypal'}, {value: 'direct-deposit', text: 'Direct Deposit'}]">
                                                            </b-form-select>
                                                            <template v-if=" order.payment_method == 'paypal' ">
                                                                <validation-provider
                                                                        :rules="{ required: true, email: true}"
                                                                        immediate
                                                                        name="paypal email"
                                                                        v-slot="validationContext">
                                                                    <b-form-input size="sm"
                                                                                  placeholder="PayPal Email"
                                                                                  @click.once="$event.target.select()"
                                                                                  :state="getValidationState(validationContext)"
                                                                                  v-b-tooltip.hover
                                                                                  :title="getValidationComplaint(validationContext)"
                                                                                  v-model="order.paypal_email">
                                                                    </b-form-input>
                                                                </validation-provider>
                                                            </template>
                                                            <template v-if=" order.payment_method == 'direct-deposit' ">
                                                                <validation-provider
                                                                        :rules="{ required: true, regex: /^\d{9}$/ }"
                                                                        immediate
                                                                        name="bank routing"
                                                                        v-slot="validationContext">
                                                                    <b-form-input size="sm"
                                                                                  :formatter="$inputSanitizer.toDigits"
                                                                                  placeholder="Routing Number"
                                                                                  @click.once="$event.target.select()"
                                                                                  :state="getValidationState(validationContext)"
                                                                                  v-b-tooltip.hover
                                                                                  :title="getValidationComplaint(validationContext)"
                                                                                  v-model="order.bank_routing">
                                                                    </b-form-input>
                                                                </validation-provider>
                                                                <validation-provider
                                                                        :rules="{ required: true}"
                                                                        immediate
                                                                        name="bank account"
                                                                        v-slot="validationContext">
                                                                    <b-form-input size="sm"
                                                                                  :formatter="$inputSanitizer.toDigits"
                                                                                  placeholder="Account Number"
                                                                                  @click.once="$event.target.select()"
                                                                                  :state="getValidationState(validationContext)"
                                                                                  v-b-tooltip.hover
                                                                                  :title="getValidationComplaint(validationContext)"
                                                                                  v-model="order.bank_account">
                                                                    </b-form-input>
                                                                </validation-provider>
                                                                <b-form-checkbox
                                                                        size="sm"
                                                                        v-model="order.invalid_bank_override"
                                                                        name="invalid_bank_override"
                                                                >Override Invalid Bank</b-form-checkbox>
                                                            </template>


                                                        </div>
                                                        <div class="controls mt-1 text-right">
                                                            <template v-if="!edits.payment_method.isSaving">
                                                                <i @click="cancelEdits" data-editing="payment_method"
                                                                   class="fa-solid fa-times text-danger pointer">
                                                                </i>
                                                                <i @click="saveEdits" data-editing="payment_method"
                                                                   class="fa-solid fa-save text-success pointer ml-2">
                                                                </i>
                                                            </template>
                                                            <template v-else>
                                                                <i class="fa-solid fa-spinner fa-spin"></i>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </validation-observer>


                                            <b-form-row>
                                                <div><label class="mb-0">Payment</label></div>
                                            </b-form-row>
                                            <b-form-row>
                                                <div class="text-danger" v-if="_paymentComplete">
                                                    Payment Complete:&nbsp;${{ _paymentComplete.amount | toFixed2 }}
                                                </div>
                                                <div class="text-warning" v-else-if="_paymentPending != null">
                                                    Pending Payment:&nbsp;${{ _paymentPending.amount | toFixed2 }}
                                                </div>

                                            </b-form-row>
                                        </b-card>
                                    </b-col>
                                </b-form-row>


                                <b-card header="Marketing" header-class="py-1 order-section-header" class="mb-0" body-class="py-2">
                                    <!-- marketing data -->
                                    <b-form-row>
                                        <b-col>
                                            <label>Source:</label>
                                            <div class="data" v-if="order.orderSource && order.orderSource.campaign_name">{{ order.orderSource.campaign_name | titleCase }}</div>
                                            <div class="data" v-else>-</div>
                                        </b-col>
                                        <b-col>
                                            <label>Campaign:</label>
                                            <div class="data" v-if="order.orderSource && order.orderSource.criterion_1">{{ order.orderSource.criterion_1 | titleCase }}</div>
                                            <div class="data" v-else>-</div>
                                        </b-col>
                                        <b-col>
                                            <label>Ad Group:</label>
                                            <div class="data" v-if="order.orderSource && order.orderSource.criterion_2">{{ order.orderSource.criterion_2 | titleCase }}</div>
                                            <div class="data" v-else>-</div>
                                        </b-col>
                                    </b-form-row>
                                </b-card>
                            </b-card>
                        </b-col>
                    </b-form-row>






                    <!--**************
                        COMPLIANCE
                    ******************-->

                    <b-card body-border-variant="dark"
                            id="conpliance-card"
                            class=""
                            header-class="p-2"
                            body-class="p-2"
                            body-bg-variant="secondary">
                        <b-card class="mb-0"
                                body-class="py-2"
                                header-class="py-1">
                            <template v-slot:header>
                                <b-form-row>
                                    <b-col class="text-center border-right">
                                        <span class="mb-0">Statute Requirements</span>
                                    </b-col>
                                    <b-col class="text-center">
                                        <span class="mb-0">Required Statute Documents</span>
                                    </b-col>
                                </b-form-row>
                            </template>


                            <div @click="edits.compliance.isEditing = true" class="item editable">
                                <b-row v-if="!edits.compliance.isEditing" id="compliance_section">
                                    <b-col>
                                        <div class="data pointer py-1">
                                            <div class="d-flex" v-if="edits.compliance.isLoading">
                                                <div class="">
                                                    <i class="fa-regular fa-spinner fa-spin"></i>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <b-row>
                                                    <b-col>
                                                        <div class="d-flex">
                                                            <div class="mr-3" :class="message.value == 0 ? 'text-danger' : 'text-success'" v-for="message in compliance">
                                                                <i v-if="message.value == 0" class="fa-duotone fa-check-circle mr-1"></i>
                                                                <i v-if="message.value == 1" class="fa-duotone fa-times-circle mr-1"></i>
                                                                <b>{{(message).text}}</b>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col class="">
                                                        <div class="d-flex justify-content-center">
                                                            <div class="mr-3" :class="edits.compliance.id ? 'text-success' : 'text-danger'">
                                                                <i v-if="edits.compliance.id" class="fa-duotone fa-check-circle mr-1"></i>
                                                                <i v-if="!edits.compliance.id" class="fa-duotone fa-times-circle mr-1"></i>
                                                                <b>ID Number</b>
                                                            </div>

                                                            <div class="mr-3" :class="edits.compliance.dob ? 'text-success' : 'text-danger'">
                                                                <i v-if="edits.compliance.dob" class="fa-duotone fa-check-circle mr-1"></i>
                                                                <i v-if="!edits.compliance.dob" class="fa-duotone fa-times-circle mr-1"></i>
                                                                <b>DOB</b>
                                                            </div>

                                                            <div class="mr-3" :class="edits.compliance.ssn ? 'text-success' : 'text-danger'">
                                                                <i v-if="edits.compliance.ssn" class="fa-duotone fa-check-circle mr-1"></i>
                                                                <i v-if="!edits.compliance.ssn" class="fa-duotone fa-times-circle mr-1"></i>
                                                                <b>SSN</b>
                                                            </div>

                                                            <div class="mr-3" :class="order.card_signed == 1 ? 'text-success' : 'text-danger'">
                                                                <i v-if="order.card_signed == 1" class="fa-duotone fa-check-circle mr-1"></i>
                                                                <i v-if="order.card_signed == 0" class="fa-duotone fa-times-circle mr-1"></i>
                                                                <b>Signature</b>
                                                            </div>

                                                            <div class="mr-3" :class="order.idology_status === 2 ? 'text-success' : 'text-danger'">
                                                                <i v-if="order.idology_status === 2" class="fa-duotone fa-check-circle mr-1"></i>
                                                                <i v-else class="fa-duotone fa-times-circle mr-1"></i>
                                                                <b>Idology</b>
                                                            </div>

                                                        </div>
                                                    </b-col>
                                                    <b-col>
                                                        <div class="d-flex justify-content-center">

                                                            <div class="mr-3" :class="edits.compliance.AML ? 'text-success' : edits.compliance.AML == null ? 'text-secondary' :'text-danger'">
                                                                <i v-if="edits.compliance.AML == null" class="fa-duotone fa-question-circle mr-1"></i>
                                                                <i v-else-if="!edits.compliance.AML" class="fa-duotone fa-times-circle mr-1"></i>
                                                                <i v-else-if="edits.compliance.AML" class="fa-duotone fa-check-circle mr-1"></i>
                                                                <b>AML</b>
                                                            </div>

                                                            <div class="mr-3" :class="edits.compliance.Enhanced_verification ? 'text-success' : edits.compliance.Enhanced_verification == null ? 'text-secondary' :'text-danger'">
                                                                <i v-if="edits.compliance.Enhanced_verification == null" class="fa-duotone fa-question-circle mr-1"></i>
                                                                <i v-else-if="!edits.compliance.Enhanced_verification" class="fa-duotone fa-times-circle mr-1"></i>
                                                                <i v-else-if="edits.compliance.Enhanced_verification" class="fa-duotone fa-check-circle mr-1"></i>
                                                                <b>Proof of Ownership</b>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>

                            <!-- Edits -->
                            <div v-if="edits.compliance.isEditing" placement="bottom" triggers="">
                                <b-row>
                                    <b-col>
                                        <div class="d-flex justify-content-center">
                                            <div label-for="card-signed" label-class="label" class="pr-2"
                                                 v-b-tooltip.hover
                                                 :title="order.card_signed ? 'yes':'no'">
                                                <label class="sub-label mb-0" for="card-signed">
                                                    <i class="fa-light fa-signature mr-1"></i>Card Signed?:</label>
                                                <b-form-checkbox
                                                        class="nice-toggle-success d-inline ml-2"
                                                        id="card-signed"
                                                        v-model="order.card_signed"
                                                        name="check-button"
                                                        :disabled="working"
                                                        switch>
                                                </b-form-checkbox>
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col>
                                        <div class="d-flex justify-content-center">

                                            <div label-for="aml_verified" label-class="label" class="pr-2"
                                                 v-b-tooltip.hover
                                                 v-if="edits.compliance.AML == null"
                                                 :title="'no'">
                                                <label class="sub-label mb-0" for="aml_verified">
                                                    <i class="fa-light fa-file-invoice mr-1"></i>AML?:</label>
                                                <b-form-checkbox
                                                        class="d-inline ml-2"
                                                        id="aml_verified"
                                                        v-model="checkbox_aml_verified"
                                                        name="check-button"
                                                        :disabled="true"

                                                        switch>
                                                </b-form-checkbox>
                                            </div>
                                            <div label-for="aml_verified" label-class="label" class="pr-2"
                                                 v-else
                                                 v-b-tooltip.hover
                                                 :title="(edits.compliance.AML == null || edits.compliance.AML) ? 'yes':'no'">
                                                <label class="sub-label mb-0" for="aml_verified">
                                                    <i class="fa-light fa-file-invoice mr-1"></i>AML?:</label>
                                                <b-form-checkbox
                                                        class="nice-toggle-success d-inline ml-2"
                                                        id="aml_verified"
                                                        v-model="checkbox_aml_verified"
                                                        name="check-button"
                                                        :disabled="working || !$store.getters.hasPermission('void documents')"

                                                        switch>
                                                </b-form-checkbox>
                                            </div>
                                            <div label-for="Enhanced_verification-verify" label-class="label"
                                                 v-b-tooltip.hover
                                                 v-if="edits.compliance.Enhanced_verification == null"
                                                 :title="'no'">
                                                <label class="sub-label mb-0" for="Enhanced_verification-verify">
                                                    <i class="fa-light fa-file mr-1"></i>Proof of Ownership?:</label>
                                                <b-form-checkbox
                                                        class="d-inline ml-2"
                                                        id="Enhanced_verification-verify"
                                                        v-model="checkbox_enhanced_verify"
                                                        name="check-button"
                                                        :disabled="true"
                                                        switch>
                                                </b-form-checkbox>
                                            </div>
                                            <div label-for="Enhanced_verification-verify" label-class="label"
                                                 v-b-tooltip.hover
                                                 v-else
                                                 :title="(edits.compliance.Enhanced_verification == null || edits.compliance.Enhanced_verification) ? 'yes':'no'">
                                                <label class="sub-label mb-0" for="Enhanced_verification-verify">
                                                    <i class="fa-light fa-file mr-1"></i>Proof of Ownership?:</label>
                                                <b-form-checkbox
                                                        class="nice-toggle-success d-inline ml-2"
                                                        id="Enhanced_verification-verify"
                                                        v-model="checkbox_enhanced_verify"
                                                        name="check-button"
                                                        :disabled="working || !$store.getters.hasPermission('void documents')"
                                                        switch>
                                                </b-form-checkbox>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                                <hr class="my-3">
                                <div class="d-flex justify-content-center">
                                    <template v-if="edits.compliance.isSaving">
                                        <i class="fa-solid fa-times text-muted mr-2 fa-2x"></i>
                                    </template>
                                    <template v-else>
                                        <i class="fa-solid fa-times mr-2 fa-2x text-danger pointer" @click="cancelEdits"
                                           data-editing="compliance">
                                        </i>
                                    </template>
                                    <i class="fa-solid pointer ml-2 text-success fa-2x"
                                       :class="edits.compliance.isSaving ? 'fa-spinner fa-spin' : 'fa-save '"
                                       @click="saveEdits"
                                       data-editing="compliance">
                                    </i>
                                </div>
                            </div>
                        </b-card>
                    </b-card>






                    <!--**************
                        DOCUMENTS
                    ******************-->
                    <div class="mb-4" role="tablist">
                        <b-card no-body ref="documents" id="documents">
                            <b-card-header v-b-toggle.documents header-tag="header"
                                           role="tab">
                                <b-row>
                                    <b-col>
                                        <template v-if="isVisibleDocuments">
                                            <i class="fa-solid fa-caret-up"></i>
                                        </template>
                                        <template v-else>
                                            <i class="fa-solid fa-caret-down"></i>
                                        </template>
                                        <span class="h5"> Documents</span>
                                    </b-col>
                                    <b-col class="text-right">
                                        <b-form-checkbox
                                                style="line-height:
                                                    2.5; height: 0"
                                                class="pt-1 align-items-right"
                                                v-model="documentsShowAllOrders"
                                                >All Orders
                                        </b-form-checkbox>

                                    </b-col>
                                    <b-col cols="3" class="text-right">
                                        <label>Pending</label>
                                        <b-badge class="mx-1"
                                                 variant="danger"
                                                 pill>
                                            {{ _pendingDocuments }}
                                        </b-badge>
                                        <b-button size="sm" @click="openDocuments">
                                            <i class="fa-solid fa-plus mr-1"></i>Add Document
                                        </b-button>
                                    </b-col>
                                </b-row>

                            </b-card-header>
                            <b-collapse v-model="isVisibleDocuments"
                                        id="documents"
                                        accordion="documents-accordion"
                                        role="tabpanel">
                                <b-card-body>
                                    <b-card-text>
                                        <b-table
                                                small
                                                striped
                                                hover
                                                outlined
                                                v-if="documents.length > 0"
                                                :items="documents"
                                                :fields="[...(documentsShowAllOrders ? ['order_id'] : []), 'ID', 'type', 'created_by', 'created', 'signed']">

                                            <template v-slot:cell(id)="data">
                                                {{data.item.id}}
                                            </template>
                                            <template v-slot:cell(type)="data">
                                                <div>{{data.item.document_type}}</div>
                                                <a class="pointer text-primary font-xs"
                                                   v-if="data.item.uploads && data.item.uploads.length != 0"
                                                                                @click="data.toggleDetails"><small>
                                                            <i class="fa-solid text-success"
                                                               :class="data.detailsShowing ? 'fa-minus-circle': 'fa-plus-circle' "></i>
                                                Attachments</small></a>
                                            </template>
                                            <template v-slot:cell(created_by)="data">
                                                {{data.item.causer_name}}
                                            </template>
                                            <template v-slot:cell(created)="data">
                                                {{data.item.created_at | datetime}}
                                            </template>
                                            <template v-slot:cell(signed)="data">
                                                <div v-if="data.item.voided_at">
                                                    <label>Voided:</label> {{data.item.voided_at | datetime}}
                                                </div>
                                                <div v-else-if="data.item.signed_at">
                                                    <label>Signed:</label> {{data.item.signed_at | datetime}}
                                                    <b-button
                                                        @click="openProtectedDocument(data.item.pdf_url)"
                                                        v-if="data.item.pdf_url"
                                                        variant="primary"
                                                        size="sm" class="ml-2">
                                                        <i>Download</i>
                                                    </b-button>
                                                </div>
                                                <b-button
                                                        @click="disableItem(data.item)"
                                                        :disabled="data.item.isSaving != undefined"
                                                        v-else
                                                        variant="danger"
                                                        size="sm">
                                                    <i v-if="data.item.isSaving != undefined" class="fa-regular fa-spin fa-spinner"></i>
                                                    <i v-else>Void Document</i>
                                                </b-button>
                                            </template>
                                            <template v-slot:row-details="row">
                                                <b-table
                                                        small
                                                        :fields="['title', {'key': 'url', 'label': 'File'}]"
                                                        :items="row.item.uploads">
                                                    <template v-slot:cell(title)="data">
                                                        {{data.item.type}}
                                                    </template>
                                                    <template v-slot:cell(url)="data">
                                                        <b-button
                                                                class="p-0 px-1"
                                                                @click="openUploadedDocument(data.item.file_path)"
                                                                variant="primary"
                                                                size="sm">
                                                            <i>Download</i>
                                                        </b-button>
                                                    </template>
                                                </b-table>
                                            </template>
                                        </b-table>
                                        <div class="text-center">
                                            <LoadingSpinner :busy="true" v-if='documentsLoading'></LoadingSpinner>
                                        </div>

                                        <b-table
                                                small
                                                striped
                                                hover
                                                outlined
                                                caption-html="<h6 class='mb-0'>Uploads</h6>"
                                                caption-top
                                                v-if="documentUploaded.length > 0"
                                                :items="documentUploaded"
                                                :fields="['ID', 'description', 'created_by', 'created', 'signed']">

                                            <template v-slot:cell(id)="data">
                                                {{data.item.id}}
                                            </template>
                                            <template v-slot:cell(description)="data">
                                                {{data.item.description}}
                                            </template>
                                            <template v-slot:cell(created_by)="data">
                                                {{data.item.causer_name}}
                                            </template>
                                            <template v-slot:cell(created)="data">
                                                {{data.item.created_at | datetime}}
                                            </template>
                                            <template v-slot:cell(signed)="data">
                                                <b-button
                                                        @click="openUploadedDocument(data.item.file_path)"
                                                        variant="primary"
                                                        size="sm">
                                                    <i>Open Document</i>
                                                </b-button>
                                            </template>
                                        </b-table>
                                    </b-card-text>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>






                    <!--**************
                         PROCESSING
                     ******************-->
                    <div class="mb-4" role="tablist">
                        <b-card no-body ref="processing" id="processing" v-if="canOrderDisplayIntake">
                            <b-card-header v-b-toggle.processing header-tag="header"
                                           role="tab">
                                <b-row>
                                    <b-col>
                                        <template v-if="isVisibleProcessing">
                                            <i class="fa-solid fa-caret-up"></i>
                                        </template>
                                        <template v-else>
                                            <i class="fa-solid fa-caret-down"></i>
                                        </template>
                                        <span class="h5"> Processing</span>
                                    </b-col>
                                    <b-col class="text-right">

                                    </b-col>
                                </b-row>

                            </b-card-header>
                            <b-collapse v-model="isVisibleProcessing"
                                        id="processing"
                                        accordion="processing-accordion"
                                        role="tabpanel">
                                <b-card-body>
                                    <b-card-text>
                                        <b-row>
                                            <b-col>
                                                <label class="mb-0">Card Images</label>
                                                <div>
                                                    <b-form-row class="my-3">
                                                        <b-col cols="6" class="mb-2" v-for="(item, index) in mediaIntakeImage" :key="index">
                                                            <img style="width: 100%;" :src="item.signed_url" alt="" v-on:click="openProtectedMedia(item.type, item.file_path)">
                                                        </b-col>
                                                    </b-form-row>
                                                </div>
                                            </b-col>
                                            <b-col cols="2">
                                                <label class="mb-0">Videos</label>
                                                <div v-for="media in mediaIntakeVideo" :key="media.id">
                                                    <b-button variant="link"
                                                              v-on:click="openProtectedMedia(media.type, media.file_path)">
                                                        <i class="fa-solid fa-video fa-fw"></i> Intake Video
                                                    </b-button>
                                                </div>
                                            </b-col>
                                            <b-col cols="7">
                                                <b-row>
                                                    <b-col>
                                                        <label class="mb-0">Total DWT</label>
                                                        <div class="small font-weight-bold">{{totalsAllPackages.totalWeight}}</div>
                                                    </b-col>
                                                    <b-col>
                                                        <label class="mb-0">Inventory DWT</label>
                                                        <div class="small font-weight-bold">{{totalsAllPackages.inventoryWeight}}</div>
                                                    </b-col>
                                                    <b-col>
                                                        <label class="mb-0">Packaging DWT</label>
                                                        <div class="small font-weight-bold">{{totalsAllPackages.packagingWeight}}</div>
                                                    </b-col>
                                                    <b-col>
                                                        <label class="mb-0">Packaging Condition</label>
                                                        <div class="small font-weight-bold">{{order.packing_quality
                                                            .replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()})}}</div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                        </b-row>
                                    </b-card-text>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>





                    <!--**************
                        INVENTORY
                    ******************-->
                    <b-card class="inventory-card" v-if="inventory"  id="inventory">
                        <template v-slot:header>
                            <b-row>
                                <b-col><span class="h5">Inventory</span></b-col>
                                <b-col>
                                    <div class="text-right">
                                        <b-badge pill variant="primary">
                                            <span class="h6">{{_inventoryCount}}</span>
                                        </b-badge>
                                    </div>
                                </b-col>
                            </b-row>
                        </template>
                        <LoadingSpinner :busy="true" v-if='inventory === true'></LoadingSpinner>

                        <b-card v-for="(value, name, index ) in inventory" body-class="p-0" :key="index">
                            <b-table :fields="inventoryFields" :items="inventory[name]"
                                     :tbody-tr-class="rowClass"
                                     thead-class="bg-dark"
                                     id="inventory-table"
                                     primary-key="id"
                                     class="text-center mb-0 font-weight-bold">
                                <template v-slot:custom-foot="data">
                                    <b-tr>
                                        <b-th colspan="4"></b-th>
                                        <b-th>{{name}}</b-th>
                                    </b-tr>
                                </template>
                                <template v-slot:thead-top="data">
                                    <b-tr class="table-header-bg">
                                        <b-th colspan="7" class="h4 text-left">



                                            <template v-if="marketPrices">

                                                <span v-if="(name == 'gold' || name == 'silver' || name == 'platinum' || name == 'palladium')">
                                                    {{ name | titleCase }} <small>(${{ marketPrices[name] }})</small>
                                                </span>

                                                <span v-else-if="name === 'gold-filled'">
                                                    {{ name | titleCase }} <small>(${{ marketPrices['gold'] }})</small>
                                                </span>

                                                <span v-else-if="name === 'diamond' || name === 'melee' ">Diamond</span>
                                                <span v-else>Non Precious Metals</span>
                                            </template>

                                            <template v-else>
                                                <span>{{(name == "Other" ? "Non Precious Metals" : name) | titleCase }}</span>
                                            </template>

                                            <b-button-group size="sm" class="ml-4">
                                                <b-button
                                                    variant="link"
                                                    size="sm"
                                                    @click="bulkSetInOffer(name, true)"
                                                    v-b-tooltip.hover
                                                    title="Add All To Offer">
                                                    <i class="fa-solid fa-circle-plus fa-lg text-success"></i>
                                                </b-button>
                                                <b-button
                                                    variant="link"
                                                    size="sm"
                                                    @click="bulkSetInOffer(name, false)"
                                                    v-b-tooltip.hover
                                                    title="Remove All From Offer">
                                                    <i class="fa-solid fa-circle-minus fa-lg text-danger"></i>
                                                </b-button>
                                            </b-button-group>
                                        </b-th>
                                        <b-th >
                                            <!--<b-input-group class="table-input m-auto text-right" size="sm" append="%">-->
                                                <!--<b-form-input @blur="updateItemPayoutRates(name, $event)"-->
                                                <!--v-model="_setMetalPayoutRate[name]"-->
                                                <!--:disabled="!isOfferNegotiable"-->
                                                <!--class="text-right"></b-form-input>-->

                                                <!--<b-form-input class="text-right"></b-form-input>-->
                                            <!--</b-input-group>-->

                                            <b-input-group size="sm" append="%" @click="attemptNPEdit()">

                                                <b-form-input @blur="updateItemPayoutRates(name, $event)"
                                                              :disabled="!isOfferUnlocked || !_metal_has_value[name] || !checkNPEdit()"
                                                              class="text-right"
                                                              v-model="_setMetalPayoutRate[name]">
                                                 </b-form-input>
                                            </b-input-group>
                                        </b-th>
                                        <b-th></b-th>
                                    </b-tr>
                                </template>

                                <template v-slot:head()="data">
                                    <span class="xxx-font">{{ data.label }}</span>
                                </template>

                                <!--id-->
                                <template v-slot:cell(id)="data">
                                    <span :class="inventorySearchHighlightClass(data.item.id)">{{ data.item.id }}</span>
                                    <div>{{ data.item.status_name | titleCase }}</div>
                                    <span @click="attemptNPEdit((wasOverride)=>{if(wasOverride) {data.item.in_offer = !data.item.in_offer;}}, data.item)" >
                                        <b-form-checkbox
                                            v-model="data.item.in_offer" name="check-button"
                                            :disabled="!isItemEditable(data.item)" switch>

                                        </b-form-checkbox>
                                    </span>
                                    <b-dropdown no-caret size="sm" variant="light" class="pY-0 m-0"
                                    toggle-class="text-decoration-none">
                                    <template v-slot:button-content>
                                    <i class="fa-solid fa-ellipsis-h"></i>
                                    </template>
                                    <b-dropdown-item @click="printItemLabel(data.item)">Print Label</b-dropdown-item>
                                    <b-dropdown-item v-if="isOrderProcessingInventory" href="#" :to="'/appraisals/appraise/'+order.id+'/inventory/'+data.item.id + '?after_save=Kits'">Edit</b-dropdown-item>
                                    <b-dropdown-item v-if="isOrderProcessingInventory" href="#" @click="deleteInventory(data.item.id)">Delete</b-dropdown-item>
                                    </b-dropdown>
                                </template>

                                <!--purity-->
                                <template v-slot:cell(purity)="data">
                                    <span v-if="data.item.children[0]">
                                        <span v-if="(data.item.children[0].purity || data.item.children[0].purity_type)">{{ data.item.children[0].purity }} {{ data.item.children[0].purity_type }}</span>
                                    </span>
                                </template>

                                <!--picture-->
                                <template v-slot:cell(picture)="data">


                                    <div class="pic position-relative pointer" @click="openLightBox(data.item.media)">
                                        <b-badge pill v-if="data.item.media.length > 1" variant="primary" class="position-absolute text-white m-1">
                                            <i class="fa-solid fa-images "></i> {{ data.item.media.length }}
                                        </b-badge>
                                        <img class="table-img" width="125px"  :src="data.item.media[0] ? data.item.media[0].url : '' " />
                                    </div>


                                </template>

                                <!--item details-->
                                <template v-slot:cell(item_details)="data">
                                    {{ data.item.type.name }}
                                    <div class="font-xxs" v-if="data.item.brand_name">Brand: {{ data.item.brand_name }}</div>

                                    <template  v-if="data.item.children.length > 1 || data.item.type.item_category_id == 13 || data.item.type.item_category_id == 2">
                                        <div>
                                            <a class="pointer"
                                               @click="data.toggleDetails"><small>
                                                <i class="fa-solid text-success"
                                                   :class="data.detailsShowing ? 'fa-minus-circle': 'fa-plus-circle' "></i>
                                                {{ data.detailsShowing ? 'Hide' : 'Show' }}
                                                Sub Items</small></a>
                                        </div>
                                    </template>

                                    <template v-if="data.item.appraiser_notes">
                                        <div>
                                            <a class="pointer"
                                               v-b-popover.click.top="{ variant: 'info', customClass: 'p-2', content: data.item.appraiser_notes }" title="Appraiser Notes"><small>
                                                <i class="fa-solid fa-note text-success fa-fw"> </i>Appraiser Notes</small></a>
                                        </div>
                                    </template>
                                </template>

                                <template v-slot:row-details="data">
                                    <b-container>
                                        <b-row align-h="center">
                                            <b-col cols="12" class="p-0">

                                                <!-- Child Items -->
                                                <b-table
                                                        small
                                                        outlined
                                                        fixed
                                                        bordered
                                                        thead-tr-class="bg-secondary"
                                                        tbody-tr-class="bg-light"
                                                        class="font-weight-normal"
                                                        :key="index"
                                                        :fields="[
                                                            {key: 'class_name', label: 'type'},
                                                            {key: 'tare_weight', label: 'weight'},
                                                            'quantity',
                                                            {key: 'appraisal.value', label: 'AV'},
                                                            'percentage_rate',

                                                            {key: 'details', label: 'Details'},]"
                                                        :items="data.item.children">
                                                    <!--head and cell styles-->
                                                    <template v-slot:head()="data">
                                                        <span class="font-xxs">{{ data.label | titleCase }}</span>
                                                    </template>
                                                    <template v-slot:cell()="data">
                                                        <span class="font-xxs">{{ (data.value || '-') | titleCase }}</span>
                                                    </template>
                                                    <!--head and cell styles-->

                                                    <template v-slot:cell(tare_weight)="data">
                                                        <span class="font-xxs" v-if="data.item.class_id == 8">
                                                            {{ data.item.tare_weight }} carats
                                                        </span>
                                                        <span class="font-xxs" v-else-if="data.item.class_id == 9">
                                                            {{ data.item.tare_weight }} points
                                                        </span>
                                                        <span class="font-xxs" v-else>
                                                            {{ data.item.aggregate_dwt }} dwt
                                                        </span>
                                                    </template>
                                                    <template  v-slot:cell(class_name)="data">
                                                        <span class="font-xxs">{{ data.value | titleCase }}</span>
                                                    </template>
                                                    <template v-slot:cell(percentage_rate)="data">
                                                        <span class="font-xxs">{{ calcChildPercentRate(data.item) }}%</span>
                                                    </template>

                                                    <template v-slot:cell(appraisal.value)="data">
                                                        <span class="font-xxs">${{ (data.value || 0) | toFixed2 }}</span>
                                                    </template>
                                                    <template v-slot:cell(appraisal.total)="data">
                                                        <span class="font-xxs">${{ (data.value || 0) | toFixed2}}</span>
                                                    </template>

                                                    <!--item details-->
                                                    <template v-slot:cell(details)="data">
                                                        <template v-if="childHasDetails(data.item.category_id)">
                                                            <i @click="data.toggleDetails" class="fa-solid text-success" :class="data.detailsShowing ? 'fa-minus-circle': 'fa-plus-circle' "></i>
                                                        </template>
                                                        <template v-else-if="isMetal(data.item)">
                                                            {{data.item.purity}}{{data.item.purity_type == "kt" ? " ": ""}}{{data.item.purity_type}}
                                                        </template>
                                                        <template v-else>
                                                            -
                                                        </template>
                                                    </template>

                                                    <template v-slot:row-details="data">
                                                        <!--Child Item Details -->
                                                        <b-row v-if="childHasDetails(data.item.category_id)">
                                                            <b-col offset="3" >
                                                                <b-table small
                                                                         outlined
                                                                         fixed
                                                                         table-variant="info"
                                                                         thead-tr-class=""
                                                                         tbody-tr-class=""
                                                                         class="font-weight-normal"
                                                                         :key="index"
                                                                         :fields="childDetailInventoryFields(data.item.category_id)"
                                                                         :items="[data.item]">

                                                                    <!--head and cell styles-->
                                                                    <template v-slot:head()="data">
                                                                        <span class="font-xxs">{{ data.label }}</span>
                                                                    </template>
                                                                    <template v-slot:cell()="data">
                                                                        <span class="font-xxs">{{ (data.value || '-') | titleCase }}</span>
                                                                    </template>
                                                                    <!--head and cell styles-->

                                                                    <!--numismatic-->
                                                                    <template v-slot:cell(appraisal.numismatic)="data">
                                                                        <span class="font-xxs">${{ data.value | toFixed2}}</span>
                                                                    </template>

                                                                    <!--certificate name-->
                                                                    <template v-slot:cell(certificate_name)="data">
                                                                        <span class="font-xxs">{{ data.value }}</span>
                                                                    </template>

                                                                    <!--total-->
                                                                    <template v-slot:cell(appraisal.total)="data">
                                                                        <span class="font-xxs">${{ data.value | toFixed2}}</span>
                                                                    </template>

                                                                </b-table>
                                                            </b-col>
                                                        </b-row>

                                                    </template>

                                                </b-table>

                                            </b-col>
                                        </b-row>
                                    </b-container>
                                </template>

                                <!--quantity-->
                                <template v-slot:cell(quantity)="data">
                                    <div v-if="data.item.type.item_category_id === 2">
                                        {{ data.item.children[0].quantity }}
                                        <small class="font-weight-normal d-block">Coins/Bullion</small>
                                    </div>
                                    <div v-else>
                                        {{ data.item.quantity }}
                                    </div>

                                </template>

                                <!--weight-->
                                <template v-slot:cell(weight)="data">
                                    <span v-if="data.item.children[0].class_id == 8">
                                        {{ data.item.children[0].tare_weight }} carats
                                    </span>
                                    <span v-else-if="data.item.children[0].class_id == 9">
                                        {{ data.item.children[0].tare_weight }} points
                                    </span>
                                    <span v-else>
                                        {{ data.item.aggregate_dwt }} dwt
                                    </span>
                                </template>

                                <!--Total-->
                                <template v-slot:cell(total)="data">
                                    <div class="text-right">
                                        <div class="font-xxs text-muted" v-if="data.item.numismatic_value">
                                            AV: {{ data.item.appraisal.value + data.item.appraisal.adjustment | toFixed2 }}<br>
                                            + EAV(P): {{ data.item.numismatic_value | toFixed2}}
                                            <template v-for="item in data.item.children">
                                                <div v-if="item.appraisal.numismatic != 0">
                                                    + EAV(C): {{ item.appraisal.numismatic | toFixed2}}
                                                </div>
                                            </template>
                                            <hr class="m-0">
                                        </div>
                                        ${{ data.item.appraisal.total | toFixed2}}
                                    </div>
                                </template>

                                <!--offer rate-->
                                <template v-slot:cell(offer_rate)="data">
                                    <!--<b-input-group size="sm" append="%">-->

                                        <!--<b-form-input @change="setItemAmount(data.item)"-->
                                                      <!--:disabled="!isOfferNegotiable"-->
                                                      <!--class="text-right"-->
                                                      <!--v-model="data.item.offer_percent">-->
                                        <!--</b-form-input>-->
                                    <!--</b-input-group>-->

                                    <b-input-group size="sm" append="%" class="table-input m-auto" @click="attemptNPEdit(()=>{}, data.item)">
                                        <b-form-input class="text-right"
                                        v-model="data.item.offer_percent"
                                        :disabled="!isOfferUnlocked || !checkNPEdit(data.item) || (data.item.appraisal.value + data.item.appraisal.adjustment + data.item.numismatic_value == 0)"
                                        @change="setItemAmount(data.item)">
                                        </b-form-input>
                                    </b-input-group>
                                </template>

                                <!--offer amount-->
                                <template v-slot:cell(offer_amount)="data">
                                    ${{ data.item.offer_amount | toFixed2 }}
                                </template>



                                <!--Footer| Totals-->
                                <template v-slot:custom-foot="data">
                                    <b-tr class="bg-secondary">
                                        <b-th colspan="3"></b-th>
                                        <b-th>TOTALS:</b-th>
                                        <b-th>{{_inventoryTotals[name].quantity}}</b-th>
                                        <b-th>{{_inventoryTotals[name].weight | toFixed2 }} dwt</b-th>
                                        <b-th class="text-right">${{_inventoryTotals[name].total | toFixed2 }}</b-th>
                                        <b-th class="text-right"> {{ _inventoryTotals[name].percentage | toFixed2 }}%</b-th>
                                        <b-th>${{_inventoryTotals[name].offer | toFixed2 }}</b-th>
                                    </b-tr>
                                </template>

                            </b-table>
                        </b-card>

                    </b-card>


                    <!--**************
                        Payments
                    ******************-->
                    <div class="mb-4" role="tablist">
                        <b-card no-body class="" ref="payment">
                            <b-card-header  header-tag="header" class=""
                                           role="tab">
                                <b-row>
                                    <b-col cols="10" v-b-toggle.payments>
                                        <template v-if="isVisiblePayments">
                                            <i class="fa-solid fa-caret-up"></i>
                                        </template>
                                        <template v-else>
                                            <i class="fa-solid fa-caret-down"></i>
                                        </template>
                                        <span class="h5"> Payments</span>
                                    </b-col>
                                    <b-col class="text-right">
                                        <b-button size="sm"
                                                  class="ml-1"
                                                  variant="primary"
                                                  @click="openPayments"
                                                  :disabled="manual_payment.selected == 'none'">
                                            <i class="fa-solid fa-cash"></i>Create Payment
                                        </b-button>
                                    </b-col>
                                </b-row>

                            </b-card-header>
                            <b-collapse v-model="isVisiblePayments"
                                        id="payments"
                                        accordion="payments-accordion"
                                        role="tabpanel">
                                <b-card-body>
                                    <b-card-text>
                                        <b-table
                                                small
                                                striped
                                                hover
                                                outlined
                                                :items="order.payments"
                                                :fields="getPaymentFields()">

                                            <template v-slot:cell(id)="data">
                                                {{data.value}}
                                            </template>
                                            <template v-slot:cell(status)="data">
                                                {{data.value}}
                                            </template>
                                            <template v-slot:cell(payment_type)="data">
                                                {{getPaymentTypeText(data.value)}}
                                            </template>

                                            <template v-slot:cell(amount)="data">
                                                ${{ data.value | toFixed2 }}
                                            </template>

                                            <template v-slot:cell(payment_method)="data">
                                                {{getPaymentMethodText(data.value)}}
                                            </template>
                                            <template v-slot:cell(check_number)="data">
                                                {{data.value}}
                                            </template>
                                            <template v-slot:cell(created_at)="data">
                                                {{data.value | datetime}}
                                            </template>
                                            <template v-slot:cell(processed_at)="data">
                                                {{data.value | datetime}}
                                            </template>
                                        </b-table>
                                    </b-card-text>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>




                    <!--**************
                        RETURNS
                    ******************-->
                    <div class="mb-4" role="tablist" v-if="_allReverseShip">
                        <b-card no-body class="">
                            <b-card-header v-b-toggle.returns header-tag="header"
                                           class="" role="tab">
                                <template v-if="isVisibleReturn">
                                    <i class="fa-solid fa-caret-up mr-0"></i>
                                </template>
                                <template v-else>
                                    <i class="fa-solid fa-caret-down mr-0"></i>
                                </template>
                                <span class="h5"> Returns</span>
                            </b-card-header>
                            <b-collapse v-model="isVisibleReturn"
                                        id="returns"
                                        accordion="returns-accordion"
                                        role="tabpanel">
                                <b-card-body>
                                    <b-card-text>
                                        <b-form-row>
                                            <b-col class="return-shipping item">
                                                <div v-for="item in _allReverseShip" :key="item.id">
                                                    <label class="sub-label">{{ item.service_provider }} Tracking - {{ item.updated_at | datetime }}:</label>
                                                    <div class="data">
                                                        <a :href="item.return_tracking_url"
                                                           target="_blank">{{ item.return_tracking_number }} <i
                                                            class="fa-solid fa-external-link-square-alt"></i> </a>
                                                        <span v-if="item.return_label_url">
                                                            <b-button variant="link" v-b-tooltip.hover title="Re-print Return Label"
                                                                :disabled="item.printing"
                                                                @click="printReturnShippingLabel(item)">
                                                                <i class="fa-solid fa-spinner fa-spin fa-fw" v-if="item.printing"></i>
                                                                <i class="fa-duotone fa-print fa-fw" v-else></i>
                                                            </b-button>
                                                        </span>
                                                    </div>
                                                </div>
                                            </b-col>
                                            <b-col class="return-shipping item mr-2">
                                                <label>Return Videos</label>
                                                <div v-for="media in mediaReturnVideo"  :key="media.id">
                                                    <b-button variant="link" class="p-0"
                                                              v-on:click="openProtectedMedia('video', media.file_path)">
                                                        <i class="fa-solid fa-video fa-fw"></i> Return Video - {{media.created_at | datetime }}
                                                    </b-button>
                                                </div>
                                            </b-col>
                                        </b-form-row>

                                    </b-card-text>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>


                    <!--**************
                        HISTORY
                    ******************-->
                    <b-card no-body id="history" ref="history">
                        <b-card-header
                                :class="historyVisible ? null : 'collapsed'"
                                :aria-expanded="historyVisible ? 'true' : 'false'"
                                aria-controls="collapse-3"
                                @click="openHistory"
                        >

                            <span class="">
                                <i v-if="!historyVisible" class="fa-solid fa-caret-down"></i>
                                <i v-else class="fa-solid fa-caret-up"></i>
                            </span>
                            <span class="h5 ml-2">History</span>
                        </b-card-header>
                        <b-collapse id="collapse-3" v-model="historyVisible">
                            <b-card-body>
                                <b-form-row class="mb-2" v-if='historyVisible && historyWasOpened'>
                                    <b-col cols="6"></b-col>
                                    <b-col cols="2">
                                        <b-form-checkbox
                                                style="line-height:
                                                    2.5; height: 0"
                                                class="pt-1 align-items-right"
                                                v-model="historyShowAllOrders"
                                                >All Orders
                                        </b-form-checkbox>

                                    </b-col>
                                    <b-col cols="3">
                                        <b-form-select
                                                style="font-size: 12px;
                                                line-height: 1"
                                                size="sm"
                                                class="pull-right p-1"
                                                v-model="historyType"
                                                :options="historyTypes">
                                        </b-form-select>
                                    </b-col>
                                    <b-col cols="1">
                                        <b-button @click="reloadHistory" size="sm">
                                            <i class="fa-regular fa-sync"></i>
                                        </b-button>
                                    </b-col>
                                </b-form-row>
                                <b-table
                                        v-if='historyVisible && history != null'
                                        striped
                                        hover
                                        bordered
                                        :items="historyView"
                                        :fields="['type','date','by','description']"
                                >
                                    <template v-slot:head(description)="data">
                                        Description
                                    </template>
                                    <template v-slot:cell(type)="data">
                                        <i class="fa-solid fa-user fa-fw fa-lg customer-icon-color"
                                           v-if="data.item.subject_type=='Customer'"></i>
                                        <i class="fa-solid fa-archive fa-fw fa-lg order-icon-color"
                                           v-else-if="data.item.subject_type=='Order'"></i>
                                        <i class="fa-solid fa-hand-holding-usd fa-fw fa-lg offer-icon-color"
                                           v-else-if="data.item.subject_type=='Offer'"></i>
                                        <i class="fa-solid fa-flag fa-fw fa-lg offer-icon-color"
                                           v-else-if="data.item.subject_type=='flag'"></i>
                                        <i class="fa-regular fa-money-bill-alt fa-fw fa-lg payment-icon-color"
                                           v-else-if="data.item.subject_type=='Payment'"></i>
                                        <i class="fa-solid fa-times subject_type fa-lg qa-icon-color"
                                           v-else-if="data.item.subject_type=='QA'"></i>
                                        <i class="fa-solid fa-dolly subject_type fa-lg qa-icon-color"
                                           v-else-if="data.item.subject_type=='ReverseShipment'"></i>
                                        <i class="fa-solid fa-boxes fa-fw fa-lg "
                                           v-else-if="data.item.subject_type=='Inventory' ||
                                               data.item.subject_type=='InventoryManagement'"></i>
                                            {{data.item.subject_id}}
                                    </template>
                                    <template v-slot:cell(date)="data">{{ data.item.created_at | datetime }}</template>
                                    <template v-slot:cell(by)="data">{{ data.item.causer_name }}</template>
                                    <template v-slot:cell(description)="data">
                                        <template v-if=" data.item.properties ==='' ">
                                            {{data.item.action}}
                                        </template>
                                        <template v-else>
                                            {{data.item.description}}
                                        </template>
                                        <b-button size="sm"
                                                  v-if="data.item.properties && Object.keys(data.item.properties).length > 1"
                                                  @click="data.toggleDetails" class="mr-2 py-0 float-right">
                                            Details
                                        </b-button>
                                    </template>
                                    <template v-slot:row-details="data">
                                        <b-card>
                                            <div v-if="data.item.properties && Object.keys(data.item.properties).length > 1">
                                                <ul>
                                                    <li v-for="row in sortHistory(data.item)" v-if="row.key!='order_id' && !(row.key=='status' && (data.item.subject_type!='ReverseShipment' && data.item.subject_type!='InventoryManagement'))">
                                                        <span v-if="row.key=='status_id' && data.item.subject_type=='Order'">
                                                            <strong>Status:</strong> {{ status_to_id(row.field) || '-'  }}
                                                        </span>
                                                        <span v-else-if="row.key=='status'">
                                                            <strong>Status:</strong> {{ fixFormatting(row.field) || '-'  }}
                                                        </span>
                                                        <span v-else-if="row.field != null
                                                            && (isDateField(row.key))">
                                                            <strong>{{ fixFormatting(row.key) }}:</strong> {{ row.field | datetime  }}
                                                        </span>
                                                        <span v-else-if="isBoolField(row.key)">
                                                            <strong>{{ fixFormatting(row.key) }}:</strong> {{ convertBool(row.field) }}
                                                        </span>
                                                        <span v-else>
                                                            <strong>{{ fixFormatting(row.key) }}:</strong> {{ fixFormattingNoCaps(row.field) || '-'  }}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </b-card>
                                    </template>
                                </b-table>
                                <div class="text-center">
                                    <LoadingSpinner :busy="true" v-if='historyVisible && history == null'></LoadingSpinner>
                                </div>

                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </b-col>
                <!-- End Column 9 -->


                <!--Side Column -->
                <b-col cols="3" class="side-panel-font">

                    <!--NOTES-->
                    <NotesModule :order_id="order.id" :customer_id="customer.id" ref="notesModule"></NotesModule>
                    <div class="sticky mb-5" v-if='inventory === true'>
                        <!--Offer Details-->
                        <b-card class="offer-card"
                                header="Offers"
                                :header-class="previous_order_negotiated() ? 'offers-issue-color' : ''"
                                body-class="p-3">
                            <template v-slot:header><span class="h5">Offers</span></template>
                            <b-table-simple small>
                                 <b-tbody>
                                     <b-tr>
                                            <LoadingSpinner :busy="true" v-if='inventory === true'></LoadingSpinner>
                                     </b-tr>
                                </b-tbody>
                            </b-table-simple>
                        </b-card>
                    </div>
                    <div class="sticky mb-5" v-if="order.status_id >= 8 && order.status_id != 16 && offer">
                        <!--Offer Details-->
                        <b-card class="offer-card"
                                header="Offers"
                                :header-class="previous_order_negotiated() ? 'offers-issue-color' : ''"
                                body-class="p-3">
                            <template v-slot:header><span class="h5">Offers</span></template>
                            <b-table-simple small>
                                <b-tbody>
                                    <b-tr>
                                        <b-th style="border-top: 0;">Cust. Convenience<br>Payment</b-th>
                                        <b-td style="border-top: 0;" colspan="2">
                                                <span class="offer-auto-accept"
                                                      :class="!order.allow_convenience_accept ? 'strike-through': ''">
                                                    {{ order.convenience_accepted_at | datetime}}</span>
                                            <div>

                                                <b-form-checkbox
                                                        class="customer-convenience-switch"
                                                        :class="order.allow_convenience_accept ? 'toggle-success':'toggle-error' "
                                                        switch
                                                        v-model="order.allow_convenience_accept"
                                                        :disabled="edits.customer_convience.isSaving"
                                                        @change="updateConvienceAccept">
                                                </b-form-checkbox>
                                            </div>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-th>Total Value</b-th>
                                        <b-td colspan="2">${{offer.actual_total_value.toFixed(2)}}</b-td>

                                    </b-tr>
                                    <!--
                                    <b-tr>
                                        <b-th>Initial Offer</b-th>
                                        <b-td>{{pushedOffer.total_offer.toFixed(2)}}</b-td>
                                        <b-td>{{ (pushedOffer.total_offer / pushedOffer.total_value * 100).toFixed(0)
                                            }}%
                                        </b-td>
                                    </b-tr>
                                    -->
                                    <b-tr>
                                        <b-th>Date Viewed</b-th>
                                        <b-td colspan="2">{{ order.offer_viewed_at | datetime }}</b-td>
                                    </b-tr>
                                </b-tbody>

                            </b-table-simple>

                            <!-- offer table -->
                            <b-table-simple
                                    small
                                    outlined
                                    bordered>
                                <b-tbody class="">
                                    <b-tr>
                                        <b-th>In Offer Actual</b-th>
                                        <b-td>${{offer.total_value.toFixed(2)}}</b-td>
                                        <b-td></b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-th>Offer</b-th>
                                        <b-td>${{ offer.total_offer.toFixed(2) }}</b-td>
                                        <b-td>{{ offer.total_value ? (((offer.total_offer) / offer.total_value ) *
                                            100).toFixed(1) : '' }}%
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-th class="pl-3">+ bonus</b-th>
                                        <b-td>${{ offer.bonus_amount | toFixed2 }}</b-td>
                                        <b-td @click="attemptNPEdit()">
                                            <b-select size="sm"
                                                      :options="getBonusOptions()" :disabled="!isOfferUnlocked || !checkNPEdit()"
                                                      v-model="bonus_percent"></b-select>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-th class="pl-3">- fees</b-th>
                                        <b-td>-</b-td>
                                        <b-td>-</b-td>
                                    </b-tr>
                                    <b-tr @click="attemptNPEdit()">
                                        <b-th width="33%">Offer Total</b-th>
                                        <b-td>
                                            <b-input-group size="sm" prepend="$">
                                                <b-form-input
                                                        :disabled="!isOfferUnlocked || _getOfferTotal.actual_value == 0 || !checkNPEdit()"
                                                        size="sm"
                                                        @blur="setTotalOfferWithBonusEvent($event)"
                                                        :value="_offerTotalAmount">
                                                </b-form-input>
                                            </b-input-group>




                                        </b-td>
                                        <b-td width="25%">
                                            <b-input-group size="sm" append="%">
                                                <b-form-input
                                                        :disabled="!isOfferUnlocked || _getOfferTotal.actual_value == 0 || !checkNPEdit()"
                                                        size="sm"
                                                        @blur="setTotalPercentOfferWithBonusEvent($event)"
                                                        :value="_offerTotalPercentage">
                                                </b-form-input>
                                            </b-input-group>





                                        </b-td>
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>

                            <!-- offer scale -->
                            <b-form-row>
                                <b-col>
                                    <b-table-simple hover borderless small class="offer-scale-table mb-0 pointer">
                                        <b-tbody>
                                            <tr @click="setTotalPercentOfferWithBonus(40)">
                                                <td rowspan="14"><img class="offer-scale-table-img"
                                                                      src="https://admin.apigx.com/img/rate-legend.png"
                                                                      alt=""></td>
                                                <th>40%</th>
                                                <td class="tier basic">{{ (offer.total_value * .40).toFixed(2) }}
                                                </td>
                                            </tr>
                                            <tr @click="setTotalPercentOfferWithBonus(49)">
                                                <th>49%</th>
                                                <td class="tier basic">{{ (offer.total_value * .49).toFixed(2) }}
                                                </td>
                                            </tr>
                                            <tr @click="setTotalPercentOfferWithBonus(50)">
                                                <th>50%</th>
                                                <td class="tier superior">{{ (offer.total_value * .50).toFixed(2)
                                                    }}
                                                </td>
                                            </tr>
                                            <tr @click="setTotalPercentOfferWithBonus(59)">
                                                <th>59%</th>
                                                <td class="tier superior">{{ (offer.total_value * .59).toFixed(2)
                                                    }}
                                                </td>
                                            </tr>
                                            <tr @click="setTotalPercentOfferWithBonus(60)">
                                                <th>60%</th>
                                                <td class="tier select">{{ (offer.total_value * .60).toFixed(2)
                                                    }}
                                                </td>
                                            </tr>
                                            <tr @click="setTotalPercentOfferWithBonus(69)">
                                                <th>69%</th>
                                                <td class="tier select">{{ (offer.total_value * .69).toFixed(2)
                                                    }}
                                                </td>
                                            </tr>
                                            <tr @click="setTotalPercentOfferWithBonus(70)">
                                                <th>70%</th>
                                                <td class="tier preferred">{{ (offer.total_value * .70).toFixed(2)
                                                    }}
                                                </td>
                                            </tr>
                                            <tr @click="setTotalPercentOfferWithBonus(79)">
                                                <th>79%</th>
                                                <td class="tier preferred">{{ (offer.total_value * .79).toFixed(2)
                                                    }}
                                                </td>
                                            </tr>
                                            <tr @click="setTotalPercentOfferWithBonus(80)">
                                                <th>80%</th>
                                                <td class="tier elite">{{ (offer.total_value * .80).toFixed(2) }}
                                                </td>
                                            </tr>
                                            <tr @click="setTotalPercentOfferWithBonus(89)">
                                                <th>89%</th>
                                                <td class="tier elite">{{ (offer.total_value * .89).toFixed(2) }}
                                                </td>
                                            </tr>
                                            <tr @click="setTotalPercentOfferWithBonus(90)">
                                                <th>90%</th>
                                                <td class="tier premium">{{ (offer.total_value * .90).toFixed(2)
                                                    }}
                                                </td>
                                            </tr>
                                            <tr @click="setTotalPercentOfferWithBonus(100)">
                                                <th>100%</th>
                                                <td class="tier rate-disabled">{{offer.total_value}}</td>
                                            </tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </b-col>
                                <b-col v-if="isOfferUnlocked">
                                    <b-button @click="saveOffer()" block variant="primary" size="sm" :disabled="edits.offer.isSaving != false || canAcceptOffer == false"><b>Save</b>&nbsp;<i v-if="edits.offer.isSaving === 'save'" class="fa-solid fa-spinner fa-spin"></i></b-button>
                                    <b-button @click="acceptOffer()" block variant="success" size="sm" :disabled="edits.offer.isSaving != false || canAcceptOffer == false"><b>Accept</b>&nbsp;<i v-if="edits.offer.isSaving === 'accept'" class="fa-solid fa-spinner fa-spin"></i></b-button>
                                    <b-button @click="declineOffer()" block variant="danger" size="sm" :disabled="edits.offer.isSaving != false || canAcceptOffer == false" style="line-height: 1.2">
                                        <b>Decline</b><br>
                                        <small>& reverse ship</small>&nbsp;<i v-if="edits.offer.isSaving === 'decline'" class="fa-solid fa-spinner fa-spin"></i>
                                    </b-button>
                                </b-col>
                                <b-col v-else>
                                    <b-button :disabled="!canUnlockOffer" @click="unlockOffer()" block variant="warning" size="sm"><b>Unlock Offer</b>&nbsp;<i v-if="edits.offer.isSaving === 'save'" class="fa-solid fa-spinner fa-spin"></i></b-button>
                                    <b-button v-if="order.status_name === 'Returned' && canForceReturnToOfferAccept"
                                        :disabled="!canUnlockOffer || edits.offer.isSaving === 'accept'"
                                        @click="unlockOfferAndSaveAsAccepted()"
                                        block variant="success" size="sm">
                                            <b>Set Return to Accepted</b>&nbsp;
                                            <i v-if="edits.offer.isSaving === 'accept'" class="fa-solid fa-spinner fa-spin"></i>
                                    </b-button>
                                </b-col>
                            </b-form-row>
                        </b-card>


                        <!-- Offer BreakDown -->
                        <b-card body-class="p-0 offer-breakdown-table">
                            <template v-slot:header>
                                <span class="h5">Offer Breakdown</span>
                            </template>
                            <b-table small
                                     striped
                                     fixed
                                     class="font-xxs mb-0"
                                     :items="_offer_breakdown"
                                     :fields="[
                                                 'metal',
                                                 {key: 'aggregate_dwt',label:'DWT'},
                                                 'qty',
                                                 {key: 'actual_value', label: 'Value'},
                                                 {key: 'offer_amount', label: 'Offer'},
                                                  {key: 'percent_rate', label: '%'},
                                                ]">

                                <template v-slot:cell(aggregate_dwt)="data">
                                    {{ data.value | toFixed2}} dwt
                                </template>
                                <template v-slot:cell(actual_value)="data">
                                    ${{ data.value | toFixed2 }}
                                </template>
                                <template v-slot:cell(offer_amount)="data">
                                    ${{ data.value | toFixed2 }}
                                </template>

                                <template v-slot:cell(percent_rate)="data">
                                    {{ (data.item.offer_amount / data.item.actual_value ) * 100 | toFixed2 }}
                                </template>
                            </b-table>
                            <b-table-simple class="mb-0 font-xxs font-weight-bold" fixed small responsive>
                                <b-tbody>
                                    <b-tr>
                                        <b-td>Totals:</b-td>
                                        <b-td>{{ _offer_breakdown_totals.aggregate_dwt | toFixed2 }} dwt</b-td>
                                        <b-td>{{ _offer_breakdown_totals.qty }}</b-td>
                                        <b-td>${{ _offer_breakdown_totals.actual_value | toFixed2 }}</b-td>
                                        <b-td>${{ _offer_breakdown_totals.offer_amount | toFixed2 }}</b-td>
                                        <b-td>{{ (((_offer_breakdown_totals.offer_amount/_offer_breakdown_totals.actual_value) * 100) || 0).toFixed(1) }}%</b-td>
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                        </b-card>
                    </div>
                    <!--End Sticky Wrapper-->

                </b-col>
            </b-row>
        </b-card>


        <!--********************
                MODALS
        ************************-->
        <!-- Manual payment -->

        <validation-observer ref="observer" v-slot="{ passes, invalid, errors }">
            <b-modal id="modal-payment-manual" size="lg" title="Payment" title-class="h4" v-model="manual_payment.modal">
                <b-form-group
                        label-class="font-weight-bold"
                        label="Payment Status:">
                    <!--<b-form-select-->
                            <!--v-model="manual_payment.status_selected"-->
                            <!--:options="manual_payment.status_options"-->
                            <!--class="mb-3">-->
                    <!--</b-form-select>-->
                    <b-form-input disabled v-model="manual_payment.status_selected"></b-form-input>
                </b-form-group>

                <b-form-group
                        label-class="font-weight-bold"
                        label="Payment Type:">
                    <b-form-select
                            v-model="manual_payment.type_selected"
                            :options="manual_payment.type_options"
                            class="mb-3">
                    </b-form-select>
                </b-form-group>

                <b-form-group
                        v-if="manual_payment.type_selected != 'reissue'"
                        label-class="font-weight-bold"
                        label="Payment Amount">
                    <b-form-input type="number"
                            v-model="manual_payment.amount" class="mb-3">
                    </b-form-input>
                </b-form-group>
                <b-form-group
                        v-else-if="_failedPaymentsCount > 0"
                        label-class="font-weight-bold"
                        label="Payment Amount">
                    <b-form-input type="number"
                                  disabled="true"
                                  v-if="_failedPaymentsCount == 1"
                                  v-model="manual_payment.amount_reissue" class="mb-3">
                    </b-form-input>
                    <b-form-select
                                  v-else-if="_failedPaymentsCount > 1"
                                  :options="_failedPaymentAmounts"
                                  v-model="manual_payment.amount_reissue" class="mb-3">
                    </b-form-select>
                </b-form-group>

                <b-form-group
                        label-class="font-weight-bold"
                        label="Payment Method:">
                    <b-form-select
                            v-model="manual_payment.method_selected"
                            :options="manual_payment.method_options"
                            class="mb-3">
                    </b-form-select>
                </b-form-group>


                <b-form-group v-if="manual_payment.method_selected == 'paypal'"
                        label-class="font-weight-bold"
                        label="Paypal Email">
                    <validation-provider
                            :rules="{ required: true, email: true}"
                            immediate
                            name="paypal email"
                            v-slot="validationContext">

                        <b-form-input size="sm"
                                      placeholder="PayPal Email"
                                      :state="getValidationState(validationContext)"
                                      v-b-tooltip.hover
                                      :title="getValidationComplaint(validationContext)"
                                      v-model="manual_payment.paypal_email" class="mb-3">
                        </b-form-input>
                    </validation-provider>
                </b-form-group>

                <b-form-group v-if="manual_payment.method_selected == 'direct-deposit'"
                        label-class="font-weight-bold"
                        label="Bank Routing">
                    <validation-provider
                            :rules="{ required: true, regex: /^\d{9}$/ }"
                            immediate
                            name="bank routing"
                            v-slot="validationContext">
                        <b-form-input size="sm"
                                      :formatter="$inputSanitizer.toDigits"
                                      placeholder="Routing Number"
                                      :state="getValidationState(validationContext)"
                                      v-b-tooltip.hover
                                      :title="getValidationComplaint(validationContext)"

                                      v-model="manual_payment.bank_routing" class="mb-3">
                        </b-form-input>
                    </validation-provider>
                </b-form-group>

                <b-form-group v-if="manual_payment.method_selected == 'direct-deposit'"
                        label-class="font-weight-bold"
                        label="Bank Account">
                    <validation-provider
                            :rules="{ required: true}"
                            immediate
                            name="bank account"
                            v-slot="validationContext">
                        <b-form-input size="sm"
                                      placeholder="Account Number"
                                      :formatter="$inputSanitizer.toDigits"
                                      :state="getValidationState(validationContext)"
                                      v-b-tooltip.hover
                                      :title="getValidationComplaint(validationContext)"

                                      v-model="manual_payment.bank_account" class="mb-3">
                        </b-form-input>
                    </validation-provider>
                </b-form-group>

                <template v-slot:modal-footer>
                    <b-button
                            variant="secondary"
                            class="float-right mr-2"
                            @click="closeManualPayment"
                    >Cancel
                    </b-button>
                    <b-button
                            @click="createManualPaymentFinal"
                            variant="primary"
                            :disabled="manual_payment.isSaving || manual_payment.status_selected == 'none' || manual_payment.type_selected == 'none'"
                            class="float-right">
                        <i :class="manual_payment.isSaving ? ' mr-2 fa-regular fa-spinner fa-spin' : 'mr-2 fa-solid fa-money-bill-alt'"></i>Create Payment
                    </b-button>
                </template>
            </b-modal><!-- end modal -->
        </validation-observer>


        <!-- EMAIL -->
        <b-modal id="modal-email" size="lg" title="Email/Text" title-class="h4">

            <b-form-group
                    label-class="font-weight-bold"
                    label="Topic:">
                <b-form-select
                        v-model="send_email.topic.selected"
                        :options="send_email.topic.options"
                        class="mb-3">
                </b-form-select>
            </b-form-group>

            <b-form-group
                    label-class="font-weight-bold"
                    label="Customer Service Emails/Texts:"
                    v-if=" send_email.topic.selected == 'customer_service' ">
                <b-form-select
                        v-model="send_email.customer_service.selected"
                        :options="send_email.customer_service.options" class="mb-3">
                </b-form-select>
            </b-form-group>

            <b-form-group
                    label-class="font-weight-bold"
                    label="Shipping Labels Emails:"
                    v-if=" send_email.topic.selected == 'shipping_label' ">
                <b-form-select
                        v-model="send_email.shipping_label.selected"
                        :options="send_email.shipping_label.options" class="mb-3">
                </b-form-select>
            </b-form-group>

            <b-form-group
                    label-class="font-weight-bold"
                    label="Missing Information Emails:"
                    v-if=" send_email.topic.selected == 'missing_info' ">
                <b-form-select
                        v-model="send_email.payment_hold.selected"
                        :options="send_email.payment_hold.options"
                        class="mb-3">
                </b-form-select>
            </b-form-group>

            <b-form-group label="Requested Number of Labels:" label-class="font-weight-bold"
                          v-if=" send_email.topic.selected == 'shipping_label' ">
                <b-input type="number" v-model.number="create_new_order.label_count">
                </b-input>
            </b-form-group>

            <b-form-group label="Insurance Coverage Amount:" label-class="font-weight-bold" description="Enter the insurance coverage amount in whole dollars (e.g. 25000 for $25,000)"
                          v-if=" send_email.topic.selected == 'customer_service' && (send_email.customer_service.selected == 'insurance_confirmation' || send_email.customer_service.selected == 'insurance_confirmation_overnight_label' || send_email.customer_service.selected == 'insurance_confirmation_parcal_pro') ">
                <b-input type="number" step="1" number
                    v-model="send_email.customer_service.insurance_coverage_amount"
                    :formatter="$inputSanitizer.toDigits"
                    placeholder="Enter insurance coverage amount in whole dollars">
                </b-input>
            </b-form-group>


            <template v-slot:modal-footer>
                <b-button
                        variant="secondary"
                        class="float-right mr-2"
                        @click="$bvModal.hide('modal-email')"
                >Cancel
                </b-button>
                <b-button
                        variant="primary"
                        @click="sendEmail"
                        :disabled="send_email.isSaving"
                        class="float-right">
                    <i :class="send_email.isSaving ? 'fa-regular fa-spinner fa-spin' : 'fa-solid fa-paper-plane'" class="mr-2"></i>Send Email/Text
                </b-button>
            </template>
        </b-modal><!-- end modal -->


        <!-- DOCUMENTS -->
        <b-modal id="modal-documents" size="lg" title="Documents" title-class="h4">
            <div class="h6">Generate Document</div>
            <b-form-group
                    label-cols-lg="2"
                    label="Type:"
                    label-align="right"
                    label-for="document-type"
                    label-class="font-weight-bold"
            >
                <b-form-select id="document-type"
                               size="lg"
                               v-model="document_created.type_selected"
                               :options="document_created.type_options">
                </b-form-select>
            </b-form-group>
            <b-form-group
                label-cols-lg="2"
                label="Replacement Jewelry:"
                label-align="right"
                label-for="settlement-type"
                label-class="font-weight-bold"
                v-if="document_created.type_selected == 7" class="mt-2">
                <b-form-checkbox
                    id="settlement-type"
                    v-model="document_created.is_jewelry_replacement"
                    name="settlement-type"
                    switch
                >
                </b-form-checkbox>
            </b-form-group>
            <b-form-group
                    label-cols-lg="2"
                    label="Settlment Amount:"
                    label-align="right"
                    label-for="document-type"
                    label-class="font-weight-bold"
                    v-if="document_created.type_selected == 7 && document_created.is_jewelry_replacement !== true" class="mt-2">
                <b-input type="number" v-model="document_created.settlement" @keydown="preventInvalidNumberKeys">

                </b-input>
            </b-form-group>
            <div class="my-2 force_height_button">
                <b-button class="float-right" variant="primary"
                          @click="createDocument"
                :disabled="!document_created.type_selected || document_created.isSaving"
                ><i :class="document_created.isSaving ? 'fa-regular fa-spin fa-spinner' : 'fa-regular fa-file'" aria-hidden="true"></i><span class="ml-2">Generate Document</span></b-button>
            </div>
            <hr class="my-4">
            <div class="h6">Choose Document To Upload</div>
            <b-form-group
                    label-cols-lg="2"
                    label="Type:"
                    label-align="right"
                    label-for="document-type"
                    label-class="font-weight-bold"
            >
                <b-form-select id="document-type"
                               size="lg"
                               v-model="document_upload.type_selected"
                               :options="document_upload.type_options">
                </b-form-select>
            </b-form-group>
            <b-form-group
                    v-if="document_upload.type_selected == 'other'"
                    label-cols-lg="2"
                    label="Type:"
                    label-align="right"
                    label-for="document-type"
                    label-class="font-weight-bold"
            >
                <b-form-select id="document-type"
                               size="lg"
                               v-model="document_upload.type_selected"
                               :options="document_upload.type_options">
                </b-form-select>
            </b-form-group>
            <b-form-group
                    label-cols-lg="2"
                    label="Description:"
                    label-align="right"
                    label-for="document-type"
                    label-class="font-weight-bold"
                    v-if="document_upload.type_selected == 'Other'" class="mt-2">
                <b-input v-model="document_upload.description">

                </b-input>
            </b-form-group>
            <b-form-group label="File:"
                          label-for="document-file"
                          label-cols-sm="2"
                          label-align="right"
                          label-class="font-weight-bold"
                          description="You may upload common image formats or PDF files.
Max filesize: 5MB."
            >
                <b-form-file
                        v-model="document_upload.file"
                        size="lg"
                        accept=".jpg, .png, .gif, .pdf"
                ></b-form-file>
            </b-form-group>
            <p>{{ document_upload.files }}</p>
            <template v-slot:modal-footer>
                <b-button
                        variant="secondary"
                        class="float-right mr-2"
                        @click="$bvModal.hide('modal-documents')"
                >Cancel
                </b-button>
                <b-button
                        variant="primary"
                        :disabled="!document_upload.type_selected || !document_upload.file || document_upload.isSaving"
                        @click="uploadDocument"
                        class="float-right">
                    <i :class="document_upload.isSaving ? 'fa-regular fa-spin fa-spinner' : 'fa-solid fa-arrow-to-right'"></i><span class="ml-2">Upload Document</span>
                </b-button>
            </template>
        </b-modal><!-- end modal -->


        <!-- RESEND KIT -->
        <b-modal id="modal-resend-kit" size="lg" title="Resend Kit" title-class="h4">
            <b-form-checkbox v-model="resend_kit" name="check-button" size="lg" switch :class="resend_kit ? 'toggle-success' : 'toggle-error' "><b>Resend Welcome Email?</b>
            </b-form-checkbox>
            <template v-slot:modal-footer>
                <b-button
                        variant="secondary"
                        class="float-right mr-2"
                        @click="$bvModal.hide('modal-resend-kit')">
                    Cancel
                </b-button>
                <b-button variant="primary" class="float-right" @click="resendKit" :disabled="resend_kit_isWorking"><span v-if="resend_kit_isWorking"> <i class="fa-regular fa-spin fa-spinner"></i>&nbsp;&nbsp;</span> Resend Kit </b-button>
            </template>
        </b-modal><!-- end modal -->


        <!-- CREATE NEW ORDER -->
        <b-modal id="modal-create-new-order" size="lg" title="Create New Order" title-class="h4" v-if="!_banned">
            Customer currently is Banned, change the status off banned to create a new order.
            <template v-slot:modal-footer>
                <b-button
                        variant="secondary"
                        class="float-right mr-2"
                        @click="$bvModal.hide('modal-create-new-order')"
                >Cancel
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-create-new-order" size="lg" title="Create New Order" title-class="h4" v-else>

            <b-form-group label="Shipping Method:" label-class="font-weight-bold">
                <b-select v-model="create_new_order.shipping_method.selected"
                          :options="create_new_order.shipping_method.options"></b-select>
            </b-form-group>

            <b-form-group label="Requested Number of Labels:" label-class="font-weight-bold">
                <b-input type="number" v-model.number="create_new_order.label_count">
                </b-input>
            </b-form-group>

            <b-form-group label="Home Pick Up?" label-class="font-weight-bold" label-for="create-order-home-pickup">
                <b-form-checkbox id="create-order-home-pickup" v-model="create_new_order.home_pickup"
                                 name="create_order_home_pickup" switch><b></b>
                </b-form-checkbox>
            </b-form-group>
            <b-form-group label="Brand:" label-class="font-weight-bold">
                <b-select v-model="create_new_order.brand.selected"
                          :options="create_new_order.brand.options"></b-select>
            </b-form-group>
            <b-form-group label="Campaign:" label-class="font-weight-bold">
                <b-form-radio-group>
                    <b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="phone"><b>Phone</b>
                    </b-form-radio>
                    <b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="text"><b>Text</b>
                    </b-form-radio>
                    <b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="email"><b>Email</b>
                    </b-form-radio>
                    <b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="google"><b>Google</b>
                    </b-form-radio>
                    <b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="bing"><b>Bing</b>
                    </b-form-radio>
                    <b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="valpak"><b>Valpak</b>
                    </b-form-radio>
                    <b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="referral"><b>Referral</b>
                    </b-form-radio>
                    <!--
                    <b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="chat"><b>Chat</b>
                    </b-form-radio>
                    <b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="tv"><b>TV</b>
                    </b-form-radio>
                    <b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="other"><b>Other</b>
                    </b-form-radio>
                    <template v-if="create_new_order.campaign.option_selected == 'other' " class="mt-2">
                        <b-form-select id="campaign" v-model="create_new_order.campaign.value" name="campaign" class="mt-2" :options="create_new_order.campaign.options">
                        </b-form-select>
                    </template>
                    -->
                </b-form-radio-group>
            </b-form-group>
            <template v-slot:modal-footer>
                <b-button
                        variant="secondary"
                        class="float-right mr-2"
                        @click="$bvModal.hide('modal-create-new-order')"
                >Cancel
                </b-button>
                <b-button
                        @click="createNewOrder"
                        variant="primary"
                        :disabled="createNewOrders.isSaving"
                        class="float-right"><i v-if="createNewOrders.isSaving" class="fa-regular fa-spinner fa-spin mr-2"></i><i v-else class="fa-solid fa-magic mr-2"></i>Create New Order
                </b-button>
            </template>
        </b-modal><!-- end modal -->


        <!-- SCHEDULE FIVE9 CALL -->
        <b-modal id="modal-schedule-five9-call" size="lg" title="Schedule Five9 Call" title-class="h4">

            <b-form-group label="Follow up Date/Time:" label-class="font-weight-bold" style="max-height:60px;">

                <!-- <DateRangePicker style="width:100%"
                                 ref="dt-picker"
                                 v-model="schedule_five9_call.date"
                                 :always-show-calendars="false"
                                 :time-picker="true"
                                 :show-ranges="false"
                                 :single-date-picker="'single'"
                                 :timePicker24Hour="false"
                >
                    <template v-slot:input="picker">
                        <div class="text-center" style="width:100%">
                            {{ schedule_five9_call.date.startDate | datetime }}{{ schedule_five9_call.date.startDate ? '': 'mm-dd-yyyy mm:ss' }}
                        </div>
                    </template>
                </DateRangePicker> -->

                <vc-date-picker mode="dateTime" v-model="schedule_five9_call.date" :minute-increment="5" :popover="schedule_five9_call.datePickerProps" :attributes="schedule_five9_call.attributes"
                                :min-date="new Date()" :disabled-dates='{ weekdays: [1, 7] }'>
                    <template v-slot="{ inputValue, inputEvents }">
                        <div v-on="inputEvents" style="width:190px">
                            <div class="text-center form-control d-inline" style="width:170px!important; max-height:30px">
                                {{ schedule_five9_call.date| datetime }}{{ schedule_five9_call.date ? '': 'mm-dd-yyyy mm:ss' }}
                            </div>
                        </div>
                    </template>
                </vc-date-picker>
            </b-form-group>

            <b-form-group label="Notes:" label-class="font-weight-bold">
                <b-form-textarea
                        id="five9_schedule_notes"
                        v-model="schedule_five9_call.notes"
                        placeholder="Notes..."
                        rows="3"
                        max-rows="6"
                ></b-form-textarea>
            </b-form-group>

            <b-form-radio-group>
                <b-form-radio buttons v-model="schedule_five9_call.type" name="five9_schedule_call_type"
                              value="General"><b>General</b></b-form-radio>
                <b-form-radio buttons v-model="schedule_five9_call.type" name="five9_schedule_call_type"
                              value="Negotiations"><b>Offer Related</b></b-form-radio>
            </b-form-radio-group>

            <template v-slot:modal-footer>
                <b-button
                        variant="secondary"
                        class="float-right mr-2"
                        @click="$bvModal.hide('modal-schedule-five9-call')"
                >Cancel
                </b-button>
                <b-button
                        @click="scheduleFive9Call"
                        variant="primary"
                        :disabled="schedule_five9_call.isSaving || !schedule_five9_call.type || !schedule_five9_call.date"
                        class="float-right">
                    <i :class="schedule_five9_call.isSaving ? 'fa-regular fa-spin fa-spinner' : 'fa-solid fa-phone fa-flip-horizontal'"></i><span class="ml-2">Schedule Follow Up</span>
                </b-button>
            </template>
        </b-modal><!-- end modal -->


        <!-- FIVE9 SCHEDULE -->
        <b-modal id="modal-five9-schedule" size="lg" title="Five9 Schedule" title-class="h4">
            <div v-for="flag in _fiveNineFlags" class="mx-2">
                <b-row class="five9_header">
                    {{ flag.follow_up | datetime }} | {{flag.note.split(':')[0] || 'General' }} Five 9 Call
                </b-row>
                <b-row>
                    {{ flag.note.split(':')[1] || '-' }}
                </b-row>
            </div>
        </b-modal><!-- end modal -->


        <!-- GOOGLE MAP -->
        <b-modal id="modal-map" size="lg" title="Map">
            <template v-slot:modal-title>
                <h3><i class="fa-solid fa-map-marked-alt"></i> Map</h3>
            </template>
            <iframe
                    width="100%"
                    height="450"
                    frameborder="0" style="border:0"
                    :src='`https://www.google.com/maps/embed/v1/place?key=AIzaSyA6J340dl2NOPZ5Xqys-Bzsn4Ln1ijGZY0&q=${_getAddress}`' allowfullscreen>
            </iframe>
        </b-modal><!-- end modal -->

        <!-- IDOLOGY QUESTIONS -->
        <b-modal id="modal-idology-questions" size="lg" title="IDology Questions" title-class="h4" :visible="idology.questions_presented" no-close-on-backdrop no-close-on-esc hide-header-close>
            <ValidationObserver ref="idology_questions">
                <div v-for="(question, index) in idology.questions" class="mx-2" :key="index">
                    <ValidationProvider :name="'Question' + index" rules="required" v-slot="{ errors }">
                        <b-form-group :label="question.question" :key="index">
                            <b-form-radio-group
                                :id="'idology-radio-group-' + index"
                                v-model="idology.answers[question.type]"
                                :options="question.answer"
                                :name="'radio-options' + index"
                                required
                            ></b-form-radio-group>
                            <span class="text-danger font-xxs">{{ errors[0] }}</span>
                        </b-form-group>
                    </ValidationProvider>
                </div>
            </ValidationObserver>

            <template #modal-footer="{ ok, cancel, hide }">
                <b-button @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="success" @click="submitIdologyAnswers()">
                    Submit Answers
                </b-button>
                <b-button variant="outline-danger" @click="forcefullyVerifyIdology()">
                    Forcefully Verify
                </b-button>
            </template>
        </b-modal><!-- end modal -->

        <!-- RE-PRINT SHIPPING MODAL -->
        <b-modal v-model="modalTrackingShow" size="lg" title="Available Tracking Numbers" ok-only ok-title="Close"
                 ok-variant="secondary">
            <b-table borderless small head-variant="dark" :tbody-tr-class="modalTrackingRowClass"
                    :busy="modalTrackingBusy" :fields="modalTrackingFields" :items="trackingNumbers">
                <template v-slot:table-busy>
                    <LoadingSpinner :busy="modalTrackingBusy"></LoadingSpinner>
                </template>
                <template v-slot:cell(tracking_number)="data">
                    <strong>
                        {{ data.value }}
                    </strong>
                </template>
                <template v-slot:cell(tracking_number_type)="data">
                    <div v-if="data.value === 'print'">
                        <i class="fa-duotone fa-lg fa-print fa-fw" v-b-tooltip.hover.left :title="data.value | titleCase"></i>
                    </div>
                    <div v-else-if="data.value === 'mail'">
                        <i class="fa-duotone fa-lg fa-mailbox fa-fw" v-b-tooltip.hover.left
                           :title="data.value | titleCase"></i>
                    </div>
                    <div v-else-if="data.value === 'alternate'">
                        <span class="font-weight-bold">ALT</span>
                    </div>
                    <div v-else>
                        {{ data.value | titleCase }}
                    </div>
                </template>
                <template v-slot:cell(master_label)="data">
                    <i class="fa-solid fa-star text-info" v-if="data.value === 1"></i>
                    <div v-else>
                        <small><i class="fa-solid fa-sort-size-up"></i> {{ data.item.master_tracking_number }}</small>
                    </div>
                </template>
                <template v-slot:cell(shipper.carrier)="data">
                    <div class="text-center" v-if="data.value === 'FedEx'"><i class="fa-brands fa-2x fa-fedex"></i></div>
                    <div class="text-center" v-else-if="data.value === 'UPS'"><i class="fa-brands fa-2x fa-ups"></i></div>
                    <div class="text-center" v-else-if="data.value === 'USPS'"><i class="fa-brands fa-2x fa-usps"></i></div>
                    <div class="text-center" v-else>{{ data.value }}</div>
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button :variant="modalTrackingButtonClass(data.item)" size="sm" :disabled="data.item.printing || !data.item.label_url"
                              @click="getPrintAsset(data.item)">
                        <i class="fa-regular fa-spinner fa-spin fa-fw" v-if="data.item.printing"></i>
                        <i class="fa-regular fa-print fa-fw" v-else></i>
                        <span v-if="modalTrackingIsInbound(data.item)">Re-Print Inbound</span>
                        <span v-else>Re-Print</span>
                    </b-button>
                </template>
            </b-table>

            <template #modal-footer="{ ok }">
                <b-button variant="light" @click="printTrackingLabels()">
                    Print Test Tracking Labels
                </b-button>
                <b-button variant="secondary" @click="ok()">
                    Cancel
                </b-button>
            </template>
        </b-modal>

    </div>

</template>


<script>
    import LoadingSpinner from '@/components/LoadingSpinner';
    import NotesModule from '@/components/NotesModule';
    import moment from 'moment-timezone';
    import _, {each, find} from 'lodash';
    import PhotoWidget from '@/components/PhotoWidget';
    import GenericPopups from '@/components/GenericPopups';
    import DateRangePicker from 'vue2-daterange-picker';
    import Multiselect from 'vue-multiselect';
    import {SYNC_USER, OVERRIDE} from '@/store/actions';
    import md5 from 'md5';
    import ImageLightBox from '@/components/ImageLightBox';

    export default {
        name: 'kit-view-index',
        title: 'Kit View',
        components: {PhotoWidget: PhotoWidget, GenericPopups, LoadingSpinner, NotesModule, DateRangePicker, Multiselect, ImageLightBox},
        created () {
            if (this.$route.query.search_filters) {
                this.searchFilters = JSON.parse(atob(this.$route.query.search_filters));
                this.$router.replace('/kit/view/' + this.$route.params.id);
            }
            this.loadOrder();
        },
        beforeDestroy() {
            this.leaveBroadcastChannel();
        },

        mounted() {
            /*  Five9 Preview Pop Functionality: If customer is recognized but is calling under a specific brand that they
             *  have no orders for, open the create new order modal with the recognized brand pre-set.
             */
            if (this.$route.query.create_new_order === '1') {
                this.$bvModal.show('modal-create-new-order');
            }

            // add mailcheck js
            this.setUpMailCheck();
        },

        data() {
            return {

                loading: true,
                profileCached: null,
                flagUpdateLoc: -1,
                working: false,
                latestLead: {status: 'no leads', fulfillment_method: 'no leads'}, //issue with it updating
                cachedCustomer: {},
                cachedOrder: {},
                cachedLeads: {},
                cachedOffer: {},
                customer: null,
                customerOrders: null,
                documents: null,
                documentsLoading: false,
                documentsShowAllOrders: false,
                packages: [],
                media: [],
                reverseShipments: [],
                flags: null,
                activeFlag: null,
                history: null,
                historyType: 'All',
                historyShowAllOrders: false,
                historyVisible: false,
                historyWasOpened: false,
                historyIsOpened: false,
                historyView: [],
                historyTypes: [],

                inventory: null,
                inventoryFields: ['id', 'purity', 'picture', 'item_details', 'quantity', 'weight', 'total', 'offer_rate', 'offer_amount'],
                isVisibleReturn: false,
                isVisibleDocuments: false,
                isVisiblePayments: false,
                isVisibleProcessing: false,
                mailCheckedEmail: undefined,
                mailCheckedEmailSuggestions: null,
                mailCheckedEmailIgnored: false,
                notes: null,
                order: null,
                leads: null,
                orderStatues: null,
                fedex: null,
                offer: null,
                documentUploaded: [],
                pushedOffer: null,
                resend_kit: false,
                resend_kit_isWorking:false,
                selected: null,
                flag_to_view: null,
                bonus_percent: null,
                np_unlock: false,
                locked: true,
                marketPrices: {},
                tracking_number_print: null,
                tracking_number_print_count: null,
                tracking_number_print_data: null,
                tracking_number_mail: null,
                tracking_number_mail_count: null,
                tracking_number_mail_data: null,
                alternate_tracking_number: null,
                alternate_tracking_number_count: null,
                alternate_tracking_number_cache: null,
                alternate_tracking_number_data: null,
                tracking_number_alternative: null,
                trackingNumbers: [],
                searchFilters: null,
                form: {
                    name: null,
                    order_id: null,
                    isBusy: false,
                    isOpen: false,
                    items: [],

                    fields: [
                        {key: 'id', label: 'Customer #', class: 'text-center'},
                        {key: 'order_id', label: 'Order #', class: 'text-center'},
                        {key: 'full_name', label: 'Name', class: 'text-center'},
                        //{key: 'address', label: 'Address', class: 'text-center'},
                        //'actions',
                    ],
                },
                aml: [ /*
                    {
                        id: 1234,
                        created_by: 'system',
                        created: 'Aug 31, 2019 4:56PM',
                        signed: 'Voided 1/2/2020'
                    }, */
                ],
                amlShowVoided: false,
                latestInventoryManagement: null,
                currentInventoryManagement: [],
                create_new_order: {
                    shipping_method: {
                        isSaving: false,
                        selected: 'standard',
                        options: [
                            {value: 'standard', text: 'Standard Shipping'},
                            {value: 'two_day', text: '2-Day Shipping'},
                            {value: 'overnight', text: 'Overnight Shipping'}
                        ]
                    },
                    label_count: 1,
                    home_pickup: false,
                    campaign: {
                        value: 'phone',
                        options: [],
                        option_selected: 'phone',
                    },
                    brand:{
                        selected: 1,
                        options: [{value: null, text: 'Select a Brand', disabled: true}],
                    },
                },
                document_upload: {
                    file: null,
                    isSaving: false,
                    document_type: null,
                    description: '',
                    type_options: [
                        {value: null, text: 'Select a document type', disabled: true},
                        {value: 'Appraisal', text: 'Appraisal'},
                        {value: 'Certification', text: 'Certification'},
                        {value: 'Identification', text: 'Identification'},
                        {value: 'Shipping Receip', text: 'Shipping Receipt'},
                        {value: 'Other', text: 'Other'},
                    ]
                },
                document_created: {
                    document_type: null,
                    isSaving: false,
                    settlement: null,
                    is_jewelry_replacement: false,
                    type_options: [
                        {value: null, text: 'Select a document type', disabled: true},
                        {value: '1', text:'Signature and ID'},
                        {value: '2', text:'Permission to Alter Condition'},
                        {value: '3', text:'Rescission and Payment Return'},
                        {value: '4', text:'Anti-Money Laundering Declaration'},
                        {value: '5', text:'Claim Form - Inbound'},
                        {value: '6', text:'Claim Form - Outbound'},
                        {value: '7', text:'Release of Claims'},
                        {value: '8', text:'Proof of Ownership'},
                        {value: '9', text:'PTA - Proof of Ownership'}
                    ]
                },
                compliance: null,
                edits: {
                    email: {isEditing: false, isSaved: false, isSaving: false},
                    home_pickup: {isEditing: false, isSaved: false, isSaving: false},
                    home_pickup_confirmation_number: {isEditing: false, isSaved: false, isSaving: false},
                    name: {isEditing: false, isSaved: false, isSaving: false},
                    address: {isEditing: false, isSaved: false, isSaving: false},
                    phone: {isEditing: false, isSaved: false, isSaving: false},
                    mobile_phone: {isEditing: false, isSaved: false, isSaving: false},
                    dob: {isEditing: false, isSaved: false, isSaving: false},
                    ssn_last_4: {isEditing: false, isSaved: false, isSaving: false},
                    status: {isEditing: false, isSaved: false, isSaving: false},
                    id: {
                        isEditing: false, isSaved: false, isSaving: false,
                        identity_type: {
                            options: [
                                {value: null, text: 'Select ID Type', disabled: true},
                                {value: 'drivers-license', text: 'Drivers License'},
                                {value: 'state-issued', text: 'State ID'},
                                {value: 'passport', text: 'Passport (US only)'},
                                {value: 'military', text: 'Military ID'},
                            ]
                        }
                    },
                    quote: {isEditing: false, isSaved: false, isSaving: false},
                    payment_method: {isEditing: false, isSaved: false, isSaving: false},
                    payment_rate: {isEditing: false, isSaved: false, isSaving: false},
                    offer_quote: {isEditing: false, isSaved: false, isSaving: false},
                    alternate_tracking_num: {isEditing: false, isSaved: false, isSaving: false},
                    offer: {isSaving: false},
                    bonus_override: {isSaving: false},
                    customer_convience: {isSaving: false, wasUpdated:false},
                    banned: {isEditing: false, isSaved: false},
                    compliance_post: {isEditing: false, isSaved: false},
                    compliance: {isEditing: false, isSaved: false, isLoading: true, isSaving: false, AML: null, Enhanced_verification: null, id: false, dob: false, ssn: false, address: 0, payment: false}
                },
                history_table_fields: ['type', 'date', {key: 'user', label: 'By'}, {
                    key: 'details',
                    label: 'Description'
                }],
                manual_payment: {
                    type_selected: 'none',
                    type_options: [
                        {value:'none', text:'Payment Options',disabled: true},
                        {value:'customer-payment', text:'Customer Payment'},
                        {value:'reimbursement', text:'Reimbursement'},
                        {value:'reissue', text:'Reissue'},
                        {value:'referral' , text:'Referral'},
                    ],
//                    all manual payments set as 'pre-approved' 6.7.21
                    status_selected: 'pre-approved',
                    status_options: [
                        {value:'none', text:'Status Options',disabled: true},
                        'pre-approved',
                        'approved',
                        'processed',
                        'failed',
                        'voided',
                    ],
                    method_selected: 'company-check',
                    method_options: [
                        {value:'paypal', text:'Paypal'},
                        {value:'direct-deposit', text:'Direct Deposit'},
                        {value:'company-check' , text:'Company Check'},
                    ],
                    paypal_email: null,
                    bank_routing: null,
                    bank_account: null,
                    amount: null,
                    modal: null,
                    isSaving: false,
                },
                notes_type: {
                    selected: 'user',
                    options: [
                        {value: 'user', text: 'User Only'},
                        {value: 'system', text: 'System Only'},
                        {value: 'none', text: 'None'},
                        {value: 'all', text: 'All'},
                        {value: 'custom', text: 'Custom'},
                    ]
                },
                schedule_five9_call: {
                    date: null,
                    notes: '',
                    type: null,
                    isSaving: false,
                    datePickerProps: {
                        placement: 'right',
                    },
                    attributes: [
                        {
                            key: 'today',
                            dot: true,
                            content: 'blue',
                            dates: new Date(),
                        }
                    ]
                },
                passwordResetData: {
                    isSaving: false,
                },
                createNewOrders: {
                    isSaving: false,
                },
                send_email: {
                    isSaving: false,
                    topic: {
                        selected: 'customer_service',
                        options: [
                            {value: 'customer_service', text: 'Customer Service'},
                            {value: 'shipping_label', text: 'Shipping Label'},
                            {value: 'missing_info', text: 'Missing Information'},
                        ]
                    },
                    customer_service: {
                        selected: 'follow_up_kit_request_spoke_with_customer',
                        options: [
                            {
                                label: 'Emails',
                                options: [
                                    {
                                        value: 'follow_up_kit_request_spoke_with_customer ',
                                        text: 'Kit Requested - Spoke to Customer'
                                    },
                                    {
                                        value: 'follow_up_kit_request_left_voicemail',
                                        text: 'Kit Requested - Didn\'t Speak to Customer OR Left Voicemail'
                                    },
                                    /*{value: 'trust_pilot_review', text: 'Trust Pilot Review'},*/
                                    {value: 'inventory_breakdown', text: 'Inventory Breakdown'},
                                    {value: 'inventory_breakdown_with_weights', text: 'Inventory Breakdown with Weights'},
                                    {value: 'claim_confirmation ', text: 'Claims Confirmation'},
                                    {value: 'insurance_request ', text: 'Additional Insurance'},
                                    {value: 'insurance_confirmation', text: 'Insurance Confirmation'},
                                    {
                                        value: 'insurance_confirmation_overnight_label',
                                        text: 'Insurance Confirmation - Overnight Label'
                                    },
                                    {
                                        value: 'insurance_confirmation_parcal_pro',
                                        text: 'Insurance Confirmation - Over $25k'
                                    },
                                    {
                                        value: 'referral_link_email',
                                        text: 'Customer Referral Link'
                                    },
                                ]
                            },
                            {
                                label: 'Texts',
                                options: [
                                    {value: 'welcome_text_with_ekit', text: 'Welcome Text with EKit Link'},
                                ]
                            },
                        ],
                        insurance_coverage_amount: null
                    },
                    shipping_label: {
                        selected: 'standard_shipping',
                        options: [
                            {value: 'standard_shipping', text: 'Standard Shipping Label'},
                            {value: 'overnight_upgrade', text: 'Overnight Shipping Label'},
                        ]
                    },
                    payment_hold: {
                        selected: 'missing_info',
                        options: [
                            {value: 'missing_info', text: 'Missing Information'}
                        ]
                    },
                },
                idology: {
                    idology_working: false,
                    idology_id: null,
                    questions: [
                        {
                            'question': 'Which of the following people do you know?',
                            'type': 'person.known.fic',
                            'answer': [
                                'SUSAN ROLLMAN',
                                'ROBERT PECOY',
                                'NANCY DOYLE',
                                'None of the above',
                                'Skip Question'
                            ]
                        },
                        {
                            'question': 'Which number goes with your address on KENNEDY DR?',
                            'type': 'street.number.b',
                            'answer': [
                                '1620',
                                '13018',
                                '9024',
                                'None of the above',
                                'Skip Question'
                            ]
                        },
                        {
                            'question': 'Which number goes with your address on W MONTE VISTA RD?',
                            'type': 'street.number',
                            'answer': [
                                '2748',
                                '2800',
                                '13665',
                                'None of the above',
                                'Skip Question'
                            ]
                        },
                        {
                            'question': 'Which number goes with your address on KENMARE DR?',
                            'type': 'street.number.fic',
                            'answer': [
                                '1343',
                                '2507',
                                '16026',
                                'None of the above',
                                'Skip Question'
                            ]
                        },
                        {
                            'question': 'Which street have you lived on?',
                            'type': 'street.name.b',
                            'answer': [
                                'GRANDEVILLE CT',
                                'FOXWORTH BLVD',
                                'ROGGE PL',
                                'None of the above',
                                'Skip Question'
                            ]
                        }
                    ],
                    answers: {},
                    question_skipped: false,
                    questions_presented: false,
                },
                modalTrackingShow: false,
                modalTrackingBusy: false,
                modalTrackingFields: [
                    {key: 'tracking_number_type', label: 'Type', class: ''},
                    {key: 'tracking_number', label: 'Tracking Number', class: ''},
                    {key: 'master_label', label: 'Master', class: ''},
                    {key: 'label_count', label: 'Count', class: ''},
                    {key: 'shipper.name', label: 'Method', class: ''},
                    {key: 'shipper.carrier', label: 'Carrier', class: ''},
                    {key: 'actions', label: '', class: 'text-right'},
                ],
                modalTrackingItems: [],
            };
        },
        computed: {
            _customerOrdersReverse() {
                return this.customerOrders ? _.reverse(_.cloneDeep(this.customerOrders)) : null;
            },
            _maxOfferOverride() {
                let totalMetal = 0;
                if(this.inventory && this.inventory !== true) {
                    _.forEach(this.inventory, (type) => {
                        _.forEach(type, (item) => {
                            if (item.type_name.toLowerCase().includes('bullion')) {
                                totalMetal += parseFloat(item.appraisal.total) * .952;
                            } else {
                                totalMetal += parseFloat(item.appraisal.total) * .902;
                            }
                        });
                    });
                    return Math.max(totalMetal, 5);
                } else {
                    return 0;
                }
            },
            _inventoryTotals() {
                let that = this;
                let totals = {};
                _.keys(this.inventory).forEach((metal) => {
                    totals[metal] = {
                        quantity: that.inventory[metal].reduce((acc, item) => acc + item.quantity, 0),
                        weight: that.inventory[metal].reduce((acc, item) => acc + item.aggregate_dwt, 0),
                        total: that.inventory[metal].reduce((acc, item) => acc + item.appraisal.total, 0),
                        percentage: ((that.inventory[metal].reduce((acc, item) => acc + item.offer_percent, 0)) / that.inventory[metal].length),
                        offer: that.inventory[metal].reduce((acc, item) => acc + parseFloat(item.offer_amount), 0),
                    };
                });
                return totals;
            },
            _unsubscribed: {
                get() {
                  return !this.customer.email_unsubscribe;
                },
                set(value) {
                    this.customer.email_unsubscribe = !value;
                }
            },
            _undeliverable: {
                get() {
                    return !this.customer.email_undeliverable;
                },
                set(value) {
                    this.customer.email_undeliverable = !value;
                }
            },
            _do_not_send: {
                get() {
                    return !this.customer.email_do_not_send;
                },
                set(value) {
                    this.customer.email_do_not_send = !value;
                }
            },
            checkbox_aml_verified:{
                set(val){
                    this.edits.compliance.AML = val;
                },
                get(){
                    if(this.edits.compliance.AML === null){
                        return false;
                    }
                    return this.edits.compliance.AML == 1;
                }
            },
            checkbox_enhanced_verify: {
                set(val) {
                    this.edits.compliance.Enhanced_verification = val;
                },
                get() {
                    if (this.edits.compliance.Enhanced_verification === null) {
                        return false;
                    }
                    return this.edits.compliance.Enhanced_verification == 1;
                }
            },
            _not_banned: {
                get() {
                    if(this.customer) {
                        return this.customer.banned_at != null;
                    }
                    return false;
                }
            },
            _banned: {
                get(){
                    if(this.customer) {
                        return this.customer.banned_at == null;
                    }
                    return true;
                },
                set(value){
                    if (!value) {
                        this.edits.banned.isSaving = true;
                        this.$forceUpdate();
                        this.$parent.$bvModal.msgBoxConfirm('Are you sure you want to ban this customer.', {
                            title: 'Ban Customer',
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'danger',
                            okTitle: 'Yes',
                            headerClass: 'p-2 border-bottom-0 text-center d-block',
                            footerClass: 'p-2 border-top-0',
                        }).then((e)=>{
                                if(e) {
                                    this.customer.banned_at = new Date();
                                    this._saveEdits('banned');
                                } else {
                                    this.customer.banned_at = null;
                                    this.$forceUpdate();//forces the toggle back
                                    this.edits.banned.isSaving = false;
                                }
                            });
                    } else {
                        this.customer.banned_at = null;
                        this._saveEdits('banned');
                    }
                }
            },
            _paymentPending() {
                let list = _.filter(this.order.payments, (e) => {return e.status == 'pre-approved' || e.status == 'approved';});
                if (list.length > 0) {
                    return list[list.length-1];
                }
                return null;
            },
            _paymentComplete() {
                let list = _.filter(this.order.payments, (e) => {return e.status == 'processed';});
                if (list.length > 0) {
                    return list[list.length-1];
                }
                return null;
            },
            _pendingCustomerPayment() {
                let list = _.filter(this.order.payments, (e) => {return (e.payment_type == 'customer-payment' || e.payment_type == 'reissue') && (e.status == 'pre-approved' || e.status == 'approved' || e.status == 'processed');});
                if (list.length > 0) {
                    return list[list.length-1];
                }
                return null;
            },
            _pendingCustomerPaymentCanEdit() {
                let list = _.filter(this.order.payments, (e) => {return (e.payment_type == 'customer-payment' || e.payment_type == 'reissue') && (e.status == 'processed');});
                if (list.length > 0) {
                    return !(this.$store.getters.hasPermission('manage payments') || this.$store.getters.hasPermission('update payments info')) && !(this.hasPaymentIssueFlags() && this.$store.getters.hasPermission('update after bad payment'));
                }
                return false;
            },
            _activeFlags() {
                return this.flags.filter(flag => flag.cleared_at == null);
            },
            _clearedFlags() {
                return this.flags.filter(flag => flag.cleared_at != null);
            },
            _offer_breakdown() {
                var aggregateFields = ['aggregate_dwt','actual_value','offer_amount','aggregate_value'];
                var sortOrder = ['platinum','gold','gold filled','gold plated','silver','silver plated','palladium','diamond','other'].reverse();
                var itemsToParse = [];
                var metalsObj = {};
                var getSummaryMetal = function(item) {
                    return _.startCase(item.class_name) + (item.purity > 0 ? ' ' + item.purity + '' + item.purity_type : '');
                };

                // Pass 1: Find inventory
                _.each(this.inventory, function(items) {
                    _.each(items, function(item) {
                        if (item.in_offer) {
                            if(item.children.length) {
                                if (item.children) {
                                    _.each(item.children, function (child) {
                                        itemsToParse.push(_.clone(child));
                                    });
                                }
                            }
                            else{
                                itemsToParse.push(_.clone(item));
                            }
                        }
                    });
                });

                // Pass 2: Aggregate
                _.each(itemsToParse, function(item) {
                    var metal = getSummaryMetal(item);
                    if(! metalsObj[metal]) {
                        metalsObj[metal] = _.mapValues(_.invert(aggregateFields),function() { return 0; });
                        metalsObj[metal]['qty'] = 0;
                    }
                    _.each(aggregateFields,function(field) {
                        if(field == 'actual_value') {
                            metalsObj[metal][field] += parseFloat(item.appraisal.total|| 0);
                        }
                        if(field == 'aggregate_value') {
                            metalsObj[metal][field] += parseFloat(item.appraisal.value|| 0);
                        }
                        metalsObj[metal][field] += parseFloat(item[field] || 0);
                    });
                    metalsObj[metal]['metal'] = metal;
                    metalsObj[metal]['score'] = Math.max(0,sortOrder.indexOf(metal.toLowerCase().replace(/ [0-9\.]+(kt|\%)/,'')))*1000 + ('kt' == item.purity_type ? item.purity * 999/24 : item.purity * 999/1000);
//
                    metalsObj[metal]['qty']++;
                });
                return _.orderBy(metalsObj,'score',['desc']);
            },
            _state: {
                get(){
                    let search = _.filter(this.US_STATES_LIST[0].types, (e)=>{
                        return this.customer.address.state == e.id;
                    });
                    if (search && search[0]) {
                        return search[0];
                    }
                    return null;
                },
                set(value){
                    if(value) {
                        this.customer.address.state = value.id;
                    }
                    else{
                        this.customer.address.state = null;
                    }
                }
            },
            _state_identity: {
                get(){
                    let search = _.filter(this.US_STATES_LIST_UNFILTERED[0].types, (e)=>{
                        return this.customer.identity_state == e.id;
                    });
                    if (search && search[0]) {
                        return search[0];
                    }
                    return null;
                },
                set(value){
                    if(value) {
                        this.customer.identity_state = value.id;
                    }
                    else{
                        this.customer.identity_state = null;
                        this.customer.identity_state = null;
                    }
                }
            },
            _activeTracking: function(){
                let tracking = null;
                _.forEachRight(this.trackingNumbers, (e)=>{
                    if(e.expected_delivery_at){
                        tracking = _.clone(e);
                    }
                });
                return tracking;
            },
            _offer_breakdown_totals: function() {
                let totals = {aggregate_dwt:0, qty: 0, actual_value: 0, offer_amount: 0,aggregate_value:0};
                _.each(this._offer_breakdown, function(value) {
                    totals.aggregate_dwt += parseFloat(value.aggregate_dwt || 0);
                    totals.actual_value += parseFloat(value.actual_value || 0);
                    totals.offer_amount += parseFloat(value.offer_amount || 0);
                    totals.qty += parseFloat(value.qty || 0);
                    totals.aggregate_value += parseFloat(value.aggregate_value || 0);
                });

                return totals;
            },
            _10bonus: {
                get(){
                    return this.order.trust_sequence_bonus;
                },
                set(){
                    //vue-js bug?? moved to methods
                }
            },
            _5bonus: {
                get(){
                    return this.order.bonus_card_present;
                },
                set(){
                    //vue-js bug?? moved to methods
                }
            },
            _canEditBonus() {
                return !(_.filter(this.flags,function(e){
                     return e.flag_type.id == 14 && e.cleared_at == null;
                }).length > 0 || parseFloat(this.order.offer_quote) > 0);
            },
            _blockAutoAccept: {
                set(res) {
                    this.order.allow_convenience_accept = !res;
                },
                get(){
                    return !this.order.allow_convenience_accept;
                }
            },
            _latestReverseShip: function () {
                if(this.reverseShipments && this.reverseShipments.length){
                    return this.reverseShipments[this.reverseShipments.length-1];
                }
                return null;
            },
            _allReverseShip: function () {
                if(this.reverseShipments && this.reverseShipments.length){
                    let reverseShipments = this.reverseShipments;
                    return reverseShipments.reverse();
                }
                return null;
            },
            _failedPayments() {
                return _.filter(this.order.payments, (payment) => {
                    return payment.status == 'failed'
                        || (payment.status == 'voided' && payment.processed_at != null);
                });
            },
            _failedPaymentAmounts() {
                return _.map(this._failedPayments, (payment) => {
                    return payment.amount;
                });
            },
            _failedPaymentsCount() {
                return _.size(this._failedPayments);
            },
            totalsAllPackages: function () {
                let totalWeight = 0;
                let packagingWeight = 0;
                let inventoryWeight = 0;
                this.packages.forEach(function (item) {
                    totalWeight += parseFloat(item.appraisal_total_dwt);
                    inventoryWeight += parseFloat(item.items_dwt);
                    packagingWeight += parseFloat(item.materials_dwt);
                });
                return {
                    totalWeight: (totalWeight).toFixed(2),
                    inventoryWeight: (inventoryWeight).toFixed(2),
                    packagingWeight: (packagingWeight).toFixed(2),
                };
            },
            mediaIntakeImage: function(){
                return _.filter(this.media, function(e){
                   return (e.type == 'photo' /* && e.subtype == 'intake'*/); //fixme ADD SUBTYPE
                });
            },
            mediaIntakeVideo: function(){
                return _.filter(this.media, function(e){
                    return (e.type == 'video'   && e.sub_type != 'return'); //fixme ADD SUBTYPE
                });
            },
            mediaReturnVideo: function(){
                return _.filter(this.media, function(e){
                    return (e.type == 'video'  && e.sub_type == 'return'); //fixme ADD SUBTYPE
                });
            },
            mediaCustomerIDPhoto: function() {
                return this.customer.identification_photo ? this.customer.identification_photo : undefined;
            },
            //FIXME this is bad, use vee-validate addition, rushed code
            _validAddress: function(){
                let pattern = /^p.*o.*b.*o.*x/i;
                return (this.customer && this.customer.address.verified || (this.customer.address.address1.match(pattern) || this.customer.address.po_box_verified));
            },
            _fiveNineFlags: function(){
                return _.filter(this.flags,function(e){
                     return e.flag_type.id == 32;
                });
            },
            _scheduledFive9Call: function(){
                let result = _.sortBy(_.filter(this._fiveNineFlags,(e)=>{
                    return this.isAfterNow(new Date(e.follow_up))
                        && ((e.cleared_at != null && e.followed_up != null) || e.cleared_at == null); //cleared, but not followedup is invalid.
                }), (e1)=>{
                    let date1 = new Date(e1.follow_up);
                    return date1;
                });
                if(result && result[0]){
                    return moment(result[0].follow_up).format('MM/DD/YYYY hh:mm a');
                }
                return null;
            },
            isOrderProcessingInventory() {
                switch (this.order.status_name) {
                    case 'Invalid Request':
                    case 'Kit Requested':
                    case 'Kit Shipped':
                    case 'Kit Inbound':
                    case 'Kit Received':
                    case 'Appraisal':
                    case 'Appraisal Hold':
                    case 'Offer Generation':
                    case 'Quality Assurance':
                        return true;
                }
                return false;
            },
            isOfferUnlocked(){
                if(this.order.status_name == 'Offer Ready'){
                    return true;
                }
                return !this.locked;
            },
            isOrderSettled() {
                switch (this.order.status_name) {
                    case 'Returned':
                    case 'Settled':
                    case 'Batched':
                    case 'Closed':
                        return true;
                }
                return false;
            },
            canUnlockOffer() {
                return this.getFlagsByType(9).length == 0;
            },
            canAcceptOffer() {
                let itemsInOfferCount = 0;
                _.forEach(this.inventory, (metal) => {
                    itemsInOfferCount += _.filter(metal, function(item) { return item.in_offer; }).length;
                });
                
                return itemsInOfferCount > 0;
            },
            isOfferNegotiable(){
                if(this.order) {
                    switch (this.order.status_name) {
                        case 'Offer Accepted':
                            if (this.order.payments) {
                                for (var i = 0; i < this.order.payments.length; i++) {
                                    switch(this.order.payments[i].payment_type){
                                        case 'customer-payment':
                                        case 'reissue':
                                            switch (this.order.payments[i].status) {
                                                case 'voided':
                                                    if(this.order.payments[i].processed_at) {
                                                        return false;
                                                    }
                                                    break;
                                                case 'processed':
                                                case 'failed':
                                                    return false;
                                            }
                                    }
                                }
                            }
                            //intensional fall through.
                        case 'Offer Ready':
                        case 'Offer Declined':
                        case 'Reverse Ship':
                            return true;
                    }
                }
                return false;
            },
            canOrderDisplayIntake(){
                if(this.order) {
                    switch(this.order.status_name){
                        case 'Appraisal':
                        case 'Appraisal Hold':
                        case 'Offer Generation':
                        case 'Quality Assurance':
                        case 'Offer Ready':
                        case 'Offer Accepted':
                        case 'Offer Declined':
                        case 'Reverse Ship':
                        case 'Returned':
                        case 'Settled':
                        case 'Batched':
                        case 'Closed':
                            return true;
                    }
                }
                return false;
            },
            canOrderDisplayInventory(){
                if(this.order) {
                    switch(this.order.status_name){
                        case 'Offer Ready':
                        case 'Offer Accepted':
                        case 'Offer Declined':
                        case 'Reverse Ship':
                        case 'Returned':
                        case 'Settled':
                        case 'Batched':
                        case 'Closed':
                            return true;
                    }
                }
                return false;
            },
            _getAddress() {
                if(this.customer) {
                    let address1 = this.customer.address.address1;
                    let address2 = this.customer.address.address2;
                    let city = this.customer.address.city;
                    let state = this.customer.address.state;
                    let zip = this.customer.address.zip;
                    return address1+'+'+city+','+state+'+'+zip;
                }
            },
            _offerTotalAmount: function(){
                return this._offerTotalAmountPure.toFixed(2);
            },
            _offerTotalAmountPure: function(){
                if(this.offer) {
                    return (this.offer.bonus_amount + this.offer.total_offer || 0);
                }
                return 0;
            },
            _offerTotalPercentage() {
                return (this.offer ? ( (this._offerTotalAmount / this.offer.total_value) * 100 || 0).toFixed(2) : 0) || 0;
            },
            _pendingDocuments() {
                if(this.documents) {
                    return _.filter(this.documents,doc => { return doc.voided_at == null && doc.signed_at == null; }).length;
                }
                return 0;
            },
            _metal_has_value() {
                let that = this;
                let obj = {};
                _.keys(this.inventory).forEach(function (metal) {
                    let m_total = 0;
                    let m_offer = 0;
                    that.inventory[metal].forEach(function (item) {
                        if (parseFloat(item.offer_amount) > 0 && parseFloat(item.appraisal.total) > 0) {
                            //set each metal offer percent based on total
                            item.offer_percent = _.round((parseFloat(item.offer_amount) / parseFloat(item.appraisal.total) * 100), 2) || 0;
                            //get totals for math
                            m_total += parseFloat(item.appraisal.total);
                            m_offer += parseFloat(item.offer_amount);
                            //percent += item.offer_percent;

                        } else {
                            item.offer_percent = 0;
                        }
                    });
                    obj[metal] = m_total > 0;
                });
                return obj;
            },
            _setMetalPayoutRate() {
                let that = this;
                let obj = {};
                _.keys(this.inventory).forEach(function (metal) {
                    let m_total = 0;
                    let m_offer = 0;
                    that.inventory[metal].forEach(function (item) {
                        if (parseFloat(item.offer_amount) > 0 && parseFloat(item.appraisal.total) > 0) {
                            //set each metal offer percent based on total
                            item.offer_percent = _.round((parseFloat(item.offer_amount) / parseFloat(item.appraisal.total) * 100), 2) || 0;
                            //get totals for math
                            m_total += parseFloat(item.appraisal.total);
                            m_offer += parseFloat(item.offer_amount);
                            //percent += item.offer_percent;

                        } else {
                            item.offer_percent = 0;
                        }
                    });
                    obj[metal] = _.round(m_offer/m_total*100, 2) || 0;
                });
                return obj;
            },
            _inOfferActualTotal: function(){
                return this._getOfferTotal.actual_value;
            },
            _getOfferTotal() {
                let that = this;
                let actual_value = _.round(this.offer.total_value, 2);
                let offer_value = 0;
                _.keys(this.inventory).forEach(function (metal) {
                    that.inventory[metal].forEach(function (item) {
                        offer_value += _.round(parseFloat(item.offer_amount), 2);
                    });
                });
                return {
                    actual_value: actual_value,
                    offer_value: offer_value,
                    offer_rate: _.round(((offer_value / actual_value) * 100), 2) || 0,
                };
            },
            _ordersAccepted(){
                let count = 0;
                _.forEach(this.customerOrders,(order)=>{
                    switch(order.status_name){
                        case 'Offer Accepted':
                        case 'Batched':
                            count++;
                    }
                });
                return count;
            },
            _ordersDeclined(){
                let count = 0;
                _.forEach(this.customerOrders,(order)=>{
                    switch(order.status_name){
                        case 'Offer Declined':
                        case 'Reverse Ship':
                        case 'Returned':
                            count++;
                    }
                });
                return count;
            },
            _ordersOther(){
                return this.customerOrders.length - this._ordersAccepted - this._ordersDeclined;
            },
            _inventoryCount(){
                let size = 0;
                _.keys(this.inventory).forEach((metal) => {
                    size += this.inventory[metal].length;
                });
                return size;
            },
            _isFlagUpdated () {
                return this.$store.getters.updatedFlag;
            },
            mailTrackingInbound () {
                let list = _.filter(this.trackingNumbers, (e) => {return e.tracking_number_type === 'mail' && e.expected_delivery_at !== null;});
                if (list.length > 0) {
                    return list.length;
                }
                return null;
            },
            printTrackingInbound () {
                let list = _.filter(this.trackingNumbers, (e) => {return e.tracking_number_type === 'print' && e.expected_delivery_at !== null;});
                if (list.length > 0) {
                    return list.length;
                }
                return null;
            },
            _customerHasAccount() {
                return !!this.customer.auth0_user_id;
            },
            canPrintTracking() {
                let canPrintTracking = false;
                if (this.$store.getters.getProfile.roles) {
                    let userRoles = this.$store.getters.getProfile.roles.data;
                    each(userRoles, (role) => {
                        if (role.name === 'Super Admin' || role.name === 'B79 Admin' || role.name === 'Processing Admin' || role.name === 'Processing Level 1 Appraiser') {
                            canPrintTracking = true;
                        }
                    });
                }
                return canPrintTracking;
            },
            canMarkAsInvalidRequest() {
                let canMarkAsInvalidRequest = false;
                if (this.$store.getters.getProfile.roles) {
                    let userRoles = this.$store.getters.getProfile.roles.data;
                    each(userRoles, (role) => {
                        if (role.name === 'Super Admin' || role.name === 'B79 Admin') {
                            canMarkAsInvalidRequest = true;
                        }
                    });
                }
                return canMarkAsInvalidRequest;
            },
            canForceReturnToOfferAccept() {
                let canForceReturnToOfferAccept = false;
                if (this.$store.getters.getProfile.roles) {
                    let userRoles = this.$store.getters.getProfile.roles.data;
                    each(userRoles, (role) => {
                        if (role.name === 'Super Admin' || role.name === 'B79 Admin'
                        || role.name === 'Processing Admin' || role.name === 'Inventory Management Admin'
                        || role.name === 'Customer Service Admin' || role.name === 'Customer Service Lead') {
                            canForceReturnToOfferAccept = true;
                        }
                    });
                }
                return canForceReturnToOfferAccept;
            },
            _complianceSignedAML() {
                if (this.amlShowVoided) {
                    return this.aml;
                } else {
                    return _.filter(this.aml, (e) => {return (e.voided_at == null);});
                }
            },
            _complianceVoidedAML() {
                return _.filter(this.aml, (e) => {return (e.voided_at != null);});
            },
            _filteredAddressValidationResults() {
                if (this.customer.address.verification_service_raw_response && this.customer.address.verification_service_raw_response.validation_results && this.customer.address.verification_service_raw_response.validation_results.messages) {
                    return _.filter(this.customer.address.verification_service_raw_response.validation_results.messages, (e) => {return e.type != 'address_correction' && e.text != 'The delivery point isn\'t receiving deliveries. This may be because the building has been unoccupied for 90 days. Please correct this information.';});
                } else {
                    return [];
                }
            },
        },
        methods: {
            openLightBox(media) {
                this.$refs.ImageLightBox.showLightBox(media);
            },
            isDateField(field) {
                const DATE_FIELDS = [
                    'created_at',
                    'updated_at',
                    'cleared_at',
                    'followed_up',
                    'follow_up',
                    'convenience_accepted_at',
                    'inbound_at',
                    'received_at',
                    'appraised_at',
                    'quality_assurance_at',
                    'offer_generated_at',
                    'decided_at',
                    'returned_at',
                    'settled_at',
                    'batched_at',
                    'closed_at',
                    'planned_sunset_at',
                    'sunset_at',
                    'banned_at',
                    'voided_at',
                    'signed_at',
                    'last_visit',
                    'created',
                    'modified',
                    'expected_delivery_at',
                    'pending_delivery_at',
                    'delivered_at',
                    'printed_at',
                    'processed_at',
                ];
                return DATE_FIELDS.includes(field);
            },
            isMetal: function (itemComponent) {
                if (itemComponent && itemComponent.category_id !== null) {
                    let category_id = itemComponent.category_id;
                    return category_id !== 7 && category_id !== 13 && category_id !== 8 && category_id !== 9 && category_id !== 12 && category_id !== 11;
                }
                return false;
            },
            setUpMailCheck: function () {
                const plugin = document.createElement('script');
                plugin.setAttribute(
                        'src',
                        'https://cdnjs.cloudflare.com/ajax/libs/mailcheck/1.1.2/mailcheck.js'
                );
                plugin.async = true;
                document.head.appendChild(plugin);
            },

            verifyEmail: function () {
                let self = this;
                if (!this.mailCheckedEmailIgnored) {
                    Mailcheck.run({
                        email: self.customer.email,
                        suggested: function (suggestion) {
                            self.mailCheckedEmail = suggestion.full;
                        },
                        empty: function () {

                        }
                    });
                }
            },
            setEmail: function () {
                this.customer.email = this.mailCheckedEmail;
                this.mailCheckedEmail = undefined;
            },
            ignoreEmail: function () {
                this.mailCheckedEmail = undefined;
                this.mailCheckedEmailIgnored = true;
            },
            loadOrder() {
                //clear previous order to reactivate loading spinner
                this.loading = true;
                this.np_unlock = false;
                this.leaveBroadcastChannel(); //leave broadcast channels if current on them (for orders). this is to handle page switching
                this.order = null;
                ///campaigns
                this.$store.dispatch('GET_REQUEST', '/campaigns').then((campaigns) => {
                    this.create_new_order.campaign.options = [];
                    _.forEach(campaigns.data, item => {
                        this.create_new_order.campaign.options.push({value: item.id, text: item.name});
                    });
                });
                //this.getInventory();
                // this.getDocuments();
//            this.getNotes();
                //this.getHistory(); called when opened
                //this.getCustomer();
                this.getCustomerOrders();
//            this.getOrder();
//            this.getOffer();

                this.$qz.connect().then(() => {

                });

                this.$store.commit('setActiveFlag', null);
                this.$http.get('/orders/' + this.$route.params.id + '?include=trackingNumbers,currentLead,documentUploads,documents,flags,customer.flags,reverseShipments,payments,leads,customer.address,pushedOffer,packages,media,customer.amlDocuments,currentInventoryManagement,latestInventoryManagement,orderSource')
                    .then(response => {
                        this.order = response.data.data;
                        this.packages = this.order.packages;
                        this.media = this.order.media;
                        this.latestInventoryManagement = this.order.latestInventoryManagement;
                        this.currentInventoryManagement = this.order.currentInventoryManagement || [];
                        this.reverseShipments = this.order.reverseShipments;
                        _.forEach(this.reverseShipments, (e) => {
                            this.$set(e, 'printing', false);
                        });
                        this.flags = response.data.data.flags;
                        this.flags = this.flags.concat(response.data.data.customer.flags);
                        this.leads = this.order.leads;
                        this.customer = response.data.data.customer;
                        this.pushedOffer = response.data.data.pushedOffer;
                        this.documents = this.order.documents;
                        this.documentUploaded = this.order.documentUploads;
                        this.cachedCustomer = Object.assign({}, this.customer);
                        this.cachedOrder = Object.assign({}, this.order);
                        this.cachedLeads = Object.assign([], this.leads);
                        this.cachedOffer = Object.assign({}, this.offer);
                        this.latestLead = this.order.currentLead || this.latestLead;
                        this.create_new_order.brand.selected = this.order.brand.id;
                        this.aml = this.customer.amlDocuments.data;

                        this.tracking_number_print = null;
                        this.tracking_number_print_count = 0;
                        this.tracking_number_mail = null;
                        this.tracking_number_mail_count = 0;
                        this.alternate_tracking_number = null;
                        this.alternate_tracking_number_count = 0;
                        this.alternate_tracking_number_cache = null;
                        this.trackingNumbers = response.data.data.trackingNumbers;
                        _.forEachRight(this.trackingNumbers, (e) => {
                            switch(e.tracking_number_type){
                                case 'print':
                                    this.tracking_number_print = e.tracking_number;
                                    this.tracking_number_print_count = e.label_count;
                                    this.tracking_number_print_data = e;
                                    break;
                                case 'mail':
                                    this.tracking_number_mail = e.tracking_number;
                                    this.tracking_number_mail_count = e.label_count
                                    this.tracking_number_mail_data = e;
                                    break;
                                default:
                                    this.alternate_tracking_number = e.tracking_number;
                                    this.alternate_tracking_number_count = e.label_count;
                                    this.alternate_tracking_number_data = e;
                                    this.alternate_tracking_number_cache = e.tracking_number;
                                    break;
                            }
                            this.$set(e, 'printing', false);
                        });
                        if (!this.tracking_number_print && this.order.status_id < 4) {
                            this.$parent.$bvModal.msgBoxOk('Order is missing a tracking number for e-kit, update to a valid address or re-save address to fix this issue.', {
                                title: 'Issue Loading Order, Missing E-kit',
                                size: 'md',
                                buttonSize: 'sm',
                                okVariant: 'danger',
                                headerClass: 'p-2 border-bottom-0 text-center d-block',
                                footerClass: 'p-2 border-top-0',
                            });
                        }
                        //this.trackingNumbers = this.order.trackingNumbers;
                        this.$nextTick(()=> { //allows most of v-ifs to assemble
                            let timeoutloop = () =>{
                                if(this.$refs.payment_method_observer && this.$refs.payment_method_observer.$nextTick) {
                                    setTimeout(()=> {
                                        this.$refs.payment_method_observer.$nextTick(() => { //when this displays if it hasn't yet
                                            this.updateCompliance();
                                        });
                                    },2000);
                                }
                                else{
                                    setTimeout(timeoutloop,2000);
                                }
                                // scroll to kit view section if requested
                                this.anchorHashCheck();
                            };
                            setTimeout(timeoutloop,2000);
                        });

                        this.$store.commit('setActiveOrder', this.order);

                        if(this.canOrderDisplayInventory && this.pushedOffer){
                            this.getAppraisals();
                        }
                        this.loadBrand();
                        this.joinBroadcastChannel();
                        if(this.customer.identity_type == 'military') {
                            this.customer.identity_state = 'NA';
                        }
                        this.loading = false;
                    })
                    .catch((e) => {
                        this.$router.push('/kit/view/');
                    });
                this.customerOrders = null;
                this.$http.get('/orders/' + this.$route.params.id + '?include=customer.orders,customer.orders.flags,customer.orders.displayCurrentOffer')
                    .then(response => {
                        this.customerOrders = response.data.data.customer.orders.data;
                    });
            },
            joinBroadcastChannel() {
                this.$store.dispatch(SYNC_USER, (profile) => {
                    console.info(String.fromCodePoint(0x1F514) + ' Joining App.Document.Orders..' + profile.id+ ' channel from Kits-View Index.');
                    this.profileCached = profile;
                    this.$echo.channel('App.Document.Order.' + this.order.id)
                        .listen('DocumentWasCreated', this.updateDocument)
                        .listen('DocumentWasUpdated', this.updateDocument)
                        .listen('DocumentWasSigned', this.updateDocument)
                        .listen('DocumentWasDeleted', this.updateDocument)
                        .error((e) => {
                            console.log('ERROR OCCURRED', e);
                        });
                    //'.'

                    this.$echo.channel('App.Document.Customer.' + this.customer.id)
                        .listen('DocumentWasCreated', this.updateAMLDocument)
                        .listen('DocumentWasUpdated', this.updateAMLDocument)
                        .listen('DocumentWasSigned', this.updateAMLDocument)
                        .listen('DocumentWasDeleted', this.updateAMLDocument)
                        .error((e) => {
                            console.log('ERROR OCCURRED', e);
                        });
                    this.$echo.channel('App.Payments.Order.' + this.order.id)
                        .listen('PaymentWasCreated', this.updatePayment)
                        .listen('PaymentWasUpdated', this.updatePayment)
                        .error((e) => {
                            console.log('ERROR OCCURRED', e);
                        });

                    this.$echo.channel('App.KitsView.Order.' + this.order.id)
                        .listen('TrackingNumberWasCreated', this.updateKitsView)
                        .listen('TrackingNumberWasUpdated', this.updateKitsView)
                        .listen('OrderWasUpdated', this.updateKitsView)
                        .listen('OrderWasCreated', this.updateKitsView)
                        .listen('LeadWasCreated', this.updateKitsView)
                        .listen('LeadWasUpdated', this.updateKitsView);

                    this.$echo.channel('App.KitsView.Customer.' + this.customer.id)
                        .listen('CustomerWasUpdated', this.updateKitsView)
                        .listen('FlagWasCreated', this.updateStopworkflow)
                        .listen('FlagWasUpdated', this.updateStopworkflow)
                        .listen('FlagWasCleared', this.updateStopworkflow)
                        .listen('FlagWasDeleted', this.updateStopworkflow);
                });
            },
            leaveBroadcastChannel: function() {
                if(this.profileCached) {
                    this.$echo.leaveChannel('App.Document.Order.' + this.order.id);
                    this.$echo.leaveChannel('App.Document.Customer.' + this.customer.id);
                    this.$echo.leaveChannel('App.Payments.Order.' + this.order.id);
                    this.$echo.leaveChannel('App.KitsView.Order.' + this.order.id);
                    this.$echo.leaveChannel('App.KitsView.Customer.' + this.customer.id);
                }
            },
            updateStopworkflow(event) {
                //this.$nextTick(() => {
                    this.customer.stop_workflow_active = (event.stop_workflow_active == 1 ? true : false);
                    this.cachedCustomer.stop_workflow_active = (event.stop_workflow_active == 1 ? true : false);
                //});
            },
            updatePayment(event) {
                this.$nextTick(() => {
                    let payment = event.payment;
                    if(!payment) {
                        return; //some wierd null payment null errror?? ignoring this bad case!
                    }
                    //document.document_type = type.name;
                    //document.causer_name = document.causer ? document.causer.name : "System";
                    let i;
                    for (i = 0; i < this.order.payments.length; i++) {
                        if (this.order.payments[i].id == payment.id) {
                            if (payment.deleted_at) {
                                this.order.payments.splice(i, 1);
                            } else {
                                this.order.payments[i] = payment;
                            }
                            //fixes rendering issue
                            this.order.payments = _.clone(this.order.payments);
                            this.cachedOrder = Object.assign({}, this.order);
                            this.$forceUpdate();
                            return;
                        }
                    }
                    if (!payment.deleted_at) {
                        this.order.payments.push(payment);
                        this.cachedOrder = Object.assign({}, this.order);
                        this.$forceUpdate();
                    }
                });
            },
            updateKitsView(event) {
                if(event.order) {
                    this.updateCustomer(event.order);
                }
                if(event.customer) {
                    this.updateOrder(event.customer);
                }
                if(event.trackingNumber) {
                    this.updateTracking(event.trackingNumber);
                }
                if(event.Lead) {
                    this.updateLead(event.Lead);
                }
            },
            updateCustomer(customer) {
                this.customer.banned_at = customer.banned_at;
                this.customer.stop_workflow_active = customer.stop_workflow_active;
                this.customer.mobile_phone_invalid = customer.mobile_phone_invalid;
                this.customer.phone_invalid = customer.phone_invalid;
                this.customer.payment_rate = customer.payment_rate;


                this.cachedCustomer.banned_at = customer.banned_at;
                this.cachedCustomer.stop_workflow_active = customer.stop_workflow_active;
                this.cachedCustomer.mobile_phone_invalid = customer.mobile_phone_invalid;
                this.cachedCustomer.phone_invalid = customer.phone_invalid;
                this.cachedCustomer.payment_rate = customer.payment_rate;

                //todo don't interrupt current work
                //this.cachedCustomer = Object.assign({}, this.customer);
            },
            updateOrder(order) {
                if(this.order.status_name == 'Offer Accepted' && order.status_name == 'Reverse Ship'){
                    this.$bvModal.msgBoxOk('The order has a zero value offer and is missing information. Please update the missing information, or this order will automatically return to the customer.', {
                        title: 'This Order is Missing `Information',
                        size: 'md',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        headerClass: 'p-2 border-bottom-0 text-center d-block',
                        footerClass: 'p-2 border-top-0',
                    });
                }
                this.order.allow_convenience_accept = order.allow_convenience_accept;
                this.order.status_id = order.status_id;
                this.order.status_name = order.status_name;
                this.order.bank_account_masked = order.bank_account_masked;
                this.order.bank_routing_valid = order.bank_routing_valid;
                this.order.idology_status = order.idology_status;
                this.order.idology_message = order.idology_message;
                this.order.label_count = order.label_count;
                this.order.offer_quote = order.offer_quote;

                this.cachedOrder.allow_convenience_accept = order.allow_convenience_accept;
                this.cachedOrder.status_id = order.status_id;
                this.cachedOrder.status_name = order.status_name;
                this.cachedOrder.bank_account_masked = order.bank_account_masked;
                this.cachedOrder.bank_routing_valid = order.bank_routing_valid;
                this.cachedOrder.idology_status = order.idology_status;
                this.cachedOrder.idology_message = order.idology_message;
                this.cachedOrder.label_count = order.label_count;
                this.cachedOrder.offer_quote = order.offer_quote;

                this.idology.idology_id = order.idology_transaction_id;
                //this.order.trackingNumbers = order.trackingNumbers;
                //resp();
                if (order.idology_status !== 2 && order.idology_questions_presented) {
                    this.idology.questions = JSON.parse(order.idology_questions);
                    this.idology.answers = {};
                    this.idology.questions_presented = true;
                }
                //this.cachedOrder = Object.assign({}, this.order);
            },
            updateTracking(trackingNumber) {
                let i;
                for (i = 0; i < this.trackingNumbers.length; i++) {
                    if (this.trackingNumbers[i].id == trackingNumber.id) {
                        if (trackingNumber.deleted_at) {
                            this.trackingNumbers.splice(i, 1);
                        } else {
                            this.trackingNumbers[i] = trackingNumber;
                        }
                        //fixes rendering issue
                        this.trackingNumbers = _.clone(this.trackingNumbers);
                        this.$forceUpdate();
                    }
                }
                if (i == this.trackingNumbers.length && !trackingNumber.deleted_at) {
                    this.trackingNumbers.push(trackingNumber);
                    this.$forceUpdate();
                }
                _.forEachRight(this.trackingNumbers, (e) => {
                    switch (e.tracking_number_type) {
                        case 'print':
                            this.tracking_number_print = e.tracking_number;
                            this.tracking_number_print_count = e.label_count;
                            break;
                        case 'mail':
                            this.tracking_number_mail = e.tracking_number;
                            this.tracking_number_mail_count = e.label_count;
                            break;
                        default:
                            this.alternate_tracking_number = e.tracking_number;
                            this.alternate_tracking_number_count = e.label_count;
                            this.alternate_tracking_number_cache = e.tracking_number;
                            break;
                    }
                });
                //this.trackingNumbers = this.order.trackingNumbers;
            },
            updateLead(lead) {
                let i;
                for (i = 0; i < this.leads.length; i++) {
                    if (this.leads[i].id == lead.id) {
                        if (lead.deleted_at) {
                            this.leads.splice(i, 1);
                        } else {
                            this.leads[i] = lead;
                        }
                        if(this.latestLead.id == lead.id) {
                            this.latestLead = lead;
                        }
                        //fixes rendering issue
                        this.leads = _.clone(this.leads);
                        this.$forceUpdate();
                        return;
                    }
                }
                if (!lead.deleted_at) {
                    this.leads.push(lead);
                    this.$forceUpdate();
                }
            },
            updateDocument(event) {
                this.$nextTick(() => {
                    let document = event.document;
                    let i;
                    for (i = 0; i < this.documents.length; i++) {
                        if (this.documents[i].id == document.id) {
                            if (document.deleted_at) {
                                this.documents.splice(i, 1);
                            } else {
                                this.documents[i] = document;
                            }
                            //fixes rendering issue
                            this.documents = _.clone(this.documents);
                            this.$forceUpdate();
                            return;
                        }
                    }
                    if (!document.deleted_at) {
                        this.documents.push(document);
                        this.$forceUpdate();
                    }
                    this.updateCompliance();
                });
            },
            updateAMLDocument(event) {
                this.$nextTick(() => {
                    let document = event.document;
                    let type = document.document_type;
                    document.document_type = type.name;
                    document.causer_name = document.causer ? document.causer.name : 'System';
                    let i;
                    for (i = 0; i < this.aml.length; i++) {
                        if (this.aml[i].id == document.id) {
                            if (document.deleted_at) {
                                this.aml.splice(i, 1);
                            } else {
                                this.aml[i] = document;
                            }
                            //fixes rendering issue
                            this.aml = _.clone(this.aml);
                            this.$forceUpdate();
                            return;
                        }
                    }
                    if (!document.deleted_at) {
                        this.aml.push(document);
                        this.$forceUpdate();
                    }
                });
            },
            activateStatus() {
                this.$store.dispatch(SYNC_USER, (e) => {
                    if (!this.$store.getters.hasPermission('manage orders')) {
                        this.$refs.GenericPopups.displayPermission =
                            {
                                title: 'Permission denied',
                                permission: 'manage orders',
                                text: 'Action was denied, request override for manage orders',
                                ok: 'Manager Override', //manager override will do function
                                cancel: 'Cancel', //cancel is a 'ok'
                                okAction: () => {
                                    this.edits.status.isEditing = true;
                                },
                                endPointsLater: ['/orders/' + this.order.id]
                            };
                    } else {
                        this.edits.status.isEditing = true;
                    }
                });
            },
            openPayments() {
                this.$store.dispatch(SYNC_USER, (e) => {
                    if (!this.$store.getters.hasPermission('manage payments')) {
                        this.$refs.GenericPopups.displayPermission =
                            {
                                title: 'Permission denied',
                                permission: 'manage payments',
                                text: 'Action was denied, request override for manage payment',
                                ok: 'Manager Override', //manager override will do function
                                cancel: 'Cancel', //cancel is a 'ok'
                                okAction: () => {
                                    this.createManualPayment();
                                },
                                endPointsLater: ['/orders/' + this.order.id + '/payments']
                            };
                    } else {
                        this.createManualPayment();
                    }
                });
            },
            openDocuments() {
                this.$store.dispatch(SYNC_USER, (e) => {
                    if (!this.$store.getters.hasPermission('manage documents')) {
                        this.$refs.GenericPopups.displayPermission =
                            {
                                title: 'Permission denied',
                                permission: 'manage documents',
                                text: 'Action was denied, request override for manage documents',
                                ok: 'Manager Override', //manager override will do function
                                cancel: 'Cancel', //cancel is a 'ok'
                                okAction: () => {
                                    this.$bvModal.show('modal-documents');
                                },
                                endPointsLater: ['/orders/' + this.order.id +'/documents']
                            };
                    } else {
                        this.$bvModal.show('modal-documents');
                    }
                });
            },
            openMyAccount() {
                 this.$store.dispatch(SYNC_USER, (e) => {
                     if (!this.$store.getters.hasPermission('view myaccount')) {
                         this.$refs.GenericPopups.displayPermission =
                             {
                                 title: 'Permission denied',
                                 permission: 'view myaccount',
                                 text: 'Action was denied, request override for view myaccount',
                                 ok: 'Manager Override', //manager override will do function
                                 cancel: 'Cancel', //cancel is a 'ok'
                                 okAction: () => {
                                     this.openMyAccountFinal();
                                 },
                                 //no idea wher to give this permission.
                             };
                      } else {
                         this.openMyAccountFinal();
                     }
                 });
            },
            openMyAccountFinal() {

                // Final call to open My Account link
                let auth_params = {'auth_bypass': true, 'customer_email': this.customer.email, hash: this.customer.hash};
                let auth_hash = btoa(JSON.stringify(auth_params));

                // TODO: Add expiration and checksum for security
                
                let brand_url = this.order.brand.url;
                let domain = brand_url.replace('https://www.','');
                let env_prefix = process.env.VUE_APP_MYACCOUNT_ENV_PREFIX || '';
                let url = 'https://' + env_prefix + '.' + domain + '/account?auth=' + auth_hash;
                window.open(url, '_blank');
            },
            hasStopWorkFlow(data) {
                let workflow = false;
                data.item.flags.forEach( function (flag) {
                    if(flag.stop_workflow) {
                        workflow = true;
                    }
                });
                return workflow;
            },
            reloadData(methods = [], resp = function(){}){
                resp();
                this.loadBrand();//fixes bug with change order statuses.
            },
            reloadData2(methods = [], resp = function(){}){
                let index = _.findIndex(methods, (e)=> {return e == 'flags';});
                if(index != -1){
                    methods.push('customer.flags');
                }
                index = _.findIndex(methods, (e)=> {return e == 'documents';});
                if(index != -1){
                    methods.push('customer.amlDocuments');
                }
                this.$http.get('/orders/' + this.$route.params.id + '?include='+methods.join(',')).then((response)=>{
                    this.$nextTick( () => {
                        _.forEach(methods, (e) => {
                            switch (e) {
                                case 'documents':
                                    this.documents = response.data.data.documents;
                                    break;
                                case 'customer.amlDocuments':
                                    this.aml = response.data.data.customer.amlDocuments.data;
                                    break;
                                case 'leads':
                                    this.leads = response.data.data.leads;
                                    break;
                                case 'currentLead':
                                    this.latestLead = response.data.data.currentLead || this.latestLead;
                                    break;
                                case 'flags':
                                    this.flags = response.data.data.flags;
                                    this.flags = this.flags.concat(response.data.data.customer.flags);
                                case 'payments':
                                    this.order.payments = response.data.data.payments;
                                    break;
                            }
                        });
                        this.order.allow_convenience_accept = response.data.data.allow_convenience_accept;
                        this.order.status_id = response.data.data.status_id;
                        this.order.bank_account_masked = response.data.data.bank_account_masked;
                        this.order.bank_routing_valid = response.data.data.bank_routing_valid;
                        this.customer.banned_at = response.data.data.customer.banned_at;
                        this.customer.stop_workflow_active = response.data.data.customer.stop_workflow_active;
                        this.customer.mobile_phone_invalid = response.data.data.customer.mobile_phone_invalid;
                        this.customer.phone_invalid = response.data.data.customer.phone_invalid;
                        this.customer.payment_rate = response.data.data.customer.payment_rate;
                        this.order.status_name = response.data.data.status_name;
                        this.order.offer_quote = response.data.data.offer_quote;
                        this.idology.idology_id = response.data.data.idology_transaction_id;
                        this.order.idology_status = response.data.data.idology_status;
                        this.order.idology_message = response.data.data.idology_message;
                        this.order.label_count = response.data.data.label_count;
                        this.trackingNumbers = response.data.data.trackingNumbers;
                        //this.order.trackingNumbers = response.data.data.trackingNumbers;
                        _.forEachRight(this.trackingNumbers, (e) => {
                            switch (e.tracking_number_type) {
                                case 'print':
                                    this.tracking_number_print = e.tracking_number;
                                    this.tracking_number_print_count = e.label_count;
                                    break;
                                case 'mail':
                                    this.tracking_number_mail = e.tracking_number;
                                    this.tracking_number_mail_count = e.label_count;
                                    break;
                                default:
                                    this.alternate_tracking_number = e.tracking_number;
                                    this.alternate_tracking_number_count = e.label_count;
                                    this.alternate_tracking_number_cache = e.tracking_number;
                                    break;
                            }
                        });
                        if(!this.tracking_number_print && this.order.status_id < 4) {
                            this.$parent.$bvModal.msgBoxOk('Order\'s Tracking number for e-kit was not generated, update to a valid address to fix this issue, if this issue persists, check to see if Fedex/USPS services are down. ', {
                                title: 'Issue Saving Address, E-kit not generated',
                                size: 'md',
                                buttonSize: 'sm',
                                okVariant: 'danger',
                                headerClass: 'p-2 border-bottom-0 text-center d-block',
                                footerClass: 'p-2 border-top-0',
                            });
                        }
                        //this.trackingNumbers = this.order.trackingNumbers;
                        if (response.data.data.idology_status !== 2 && response.data.data.idology_questions_presented) {
                            this.idology.questions = JSON.parse(response.data.data.idology_questions);
                            this.idology.answers = {};
                            this.idology.questions_presented = true;
                        }

                        this.cachedOrder = Object.assign({}, this.order);
                        this.cachedCustomer = Object.assign({}, this.customer);
                        resp();
                        this.loadBrand();//fixes bug with change order statuses.
                    });
                });
            },
            status_to_id(id){
                const list  = [
                    'Invalid Request',
                    'Kit Requested',
                    'Kit Shipped',
                    'Kit Inbound',
                    'Kit Received',
                    'Appraisal',
                    'Appraisal Hold',
                    'Offer Generation',
                    'Offer Ready',
                    'Offer Accepted',
                    'Offer Declined',
                    'Reverse Ship',
                    'Returned',
                    'Settled',
                    'Batched',
                    'Closed',
                    'Quality Assurance',

                ];
                return list[id];
            },
            sortHistory(model){
                switch(model.subject_type){
                    case 'Offer':
                        return _.filter([
                            {key:'status', field: model.properties.status},
                            {key:'total_dwt', field: model.properties.total_dwt},
                            {key:'actual_value', field: model.properties.actual_value},
                            {key:'in_offer_actual', field: model.properties.in_offer_total_value},
                            {key:'offer_pushed', field: model.properties.offer_pushed},
                            {key:'offer_pushed_percent', field: model.properties.offer_pushed_percent},
                            {key:'offer', field: model.properties.offer},
                            {key:'offer_percent', field: model.properties.offer_percent},
                            {key:'bonus_amount', field: model.properties.bonus_amount},
                            {key:'bonus_percent', field: model.properties.bonus_percent},
                            {key:'offer_total', field: model.properties.offer_total},
                            {key:'offer_total_percent', field: model.properties.offer_total_percent},
                            {key:'permission_overridden', field: model.properties.permission_overridden},
                            {key:'permission_overrider_id', field: model.properties.permission_overrider_id},
                            {key:'permission_overrider', field: model.properties.permission_overrider},
                            {key:'causer_reason', field: model.properties.causer_reason},
                        ],(e) => {return e.field;});
                    case 'Payment':
                        return _.filter([
                            {key:'first_name', field: model.properties.first_name},
                            {key:'last_name', field: model.properties.last_name},
                            {key:'address1', field: model.properties.address1},
                            {key:'address2', field: model.properties.address2},
                            {key:'city', field: model.properties.city},
                            {key:'state', field: model.properties.state},
                            {key:'zip', field: model.properties.zip},
                            {key:'status', field: model.properties.status},
                            {key:'amount',  field: ('$' +model.properties.amount)},
                            {key:'payment_type', field: model.properties.payment_type},
                            {key:'payment_method', field: model.properties.payment_method},
                            {key:'bank_routing', field: model.properties.bank_routing},
                            {key:'bank_account', field: model.properties.bank_account},
                            {key:'paypal_email', field: model.properties.paypal_email},
                            {key:'check_number', field: model.properties.check_number},
                            {key:'paypal_transaction_id', field: model.properties.paypal_transaction_id},
                            {key:'permission_overridden', field: model.properties.permission_overridden},
                            {key:'permission_overrider_id', field: model.properties.permission_overrider_id},
                            {key:'permission_overrider', field: model.properties.permission_overrider},
                            {key:'causer_reason', field: model.properties.causer_reason},
                        ],(e) => {return e.field;});
                    case 'flag':
                        return _.filter([
                            {key:'note', field: model.properties.note},
                            {key:'stop_workflow', field: model.properties.stop_workflow},
                            {key:'priority', field: model.properties.priority},
                            {key:'follow_up', field: model.properties.follow_up},
                            {key:'cleared_at', field: model.properties.cleared_at},
                            {key:'order_id', field: model.properties.order_id},
                            {key:'customer_id', field: model.properties.customer_id},
                            {key:'flag_target', field: model.properties.flag_target},
                            {key:'latest_note', field: model.properties.latest_note},
                            {key:'permission_overridden', field: model.properties.permission_overridden},
                            {key:'permission_overrider_id', field: model.properties.permission_overrider_id},
                            {key:'permission_overrider', field: model.properties.permission_overrider},
                            {key:'causer_reason', field: model.properties.causer_reason},
                        ],(e) => {return e.field;});
                    default:
                        let permission_overrider_id = model.properties.permission_overrider_id;
                        let permission_overrider = model.properties.permission_overrider;
                        let permission_overridden = model.properties.permission_overridden;
                        let causer_reason = model.properties.causer_reason;
                        delete model.properties.permission_overrider_id;
                        delete model.properties.permission_overrider;
                        delete model.properties.permission_overridden;
                        delete model.properties.causer_reason;
                        let ret =  _.map(model.properties, function(value, key) { return {key: key, field: value}; });
                        if (permission_overridden) {
                            ret.push({key: 'permission_overridden', field: permission_overridden});
                        }
                        if (permission_overrider_id) {
                            ret.push({key: 'permission_overrider_id', field: permission_overrider_id});
                        }
                        if (permission_overrider) {
                            ret.push({key: 'permission_overrider', field: permission_overrider});
                        }
                        if (causer_reason) {
                            ret.push({key: 'causer_reason', field: causer_reason});
                        }
                        return ret;
                }
            },
            getCustomersBySearch(event) {
                event.preventDefault();
                this.form.isBusy = true;
                this.form.showTable = true;
                this.form.isOpen = true;
                this.$refs.search_input_popover.$emit('open');
                setTimeout(()=>{this.form.isOpen = true; this.$refs.search_input_popover.$emit('open');}, 30);
                this.$http.get('/search/customers', {
                    params: {
                        q: this.form.name
                    }
                })
                    .then(response => {
                        this.form.items = response.data.data;
                        for(var i = 0; i <  this.form.items.length; i++)
                        {
                            var orders = this.form.items[i].orders.data;
                            this.form.items[i].latest_order = orders.length == 0 ? null : orders[orders.length - 1];
                        }
                        this.form.isBusy = false;
                    });
            },
            gotoOrder(customer){
                if(customer.orders && customer.orders.data && customer.orders.data.length != 0) {
                    let order = customer.orders.data[customer.orders.data.length - 1];
                    this.$router.replace({
                        path: '/kit/view/' + order.id,
                    });
                    this.$router.reload(0);
                }
            },
            updateHistory() {
                this.historyTypes = ['All'];
                this.historyView = _.filter(this.history, (e)=>{
                    //setup type to be seen
                    if(!this.historyTypes.includes(e.subject_type)){
                        this.historyTypes.push(e.subject_type);
                    }
                    if(this.historyType != 'All'){
                        if(this.historyType != e.subject_type){
                            return false;
                        }
                    }
                    if(!this.historyShowAllOrders){
                        switch(e.subject_type){
                            case 'Customer':
                                break;
                            case 'Order':
                                if(e.subject_id != this.order.id){
                                    return false;
                                }
                                break;
                            default:
                                if(e.properties && e.properties.order_id && e.properties.order_id != this.order.id){
                                    return false;
                                }
                                break;
                        }
                    }
                    return true;
                });
            },
            anchorHashCheck() {
                if(window.location.hash) {
                    let hash = this.$route.hash.slice(1);
                    if(hash == 'history' && !this.historyVisible) {
                        this.openHistory();
                    }
                    const el = this.$refs[hash];
                    if(el) {
                        el.scrollIntoView();
                    }
                }
            },


            doNotPrintAction(){
                this.$http.put('/leads/' + this.latestLead.id, {status: 'do-not-print'}).then((e)=>{
                   this.latestLead = e.data.data;
                });
            },
            disableItem(item) {
                let fireAction = () => {
                    item.isSaving = true;
                    this.$forceUpdate();
                    let send = {};
                    this.$http.delete('/documents/' + item.id, send).then(
                        (e) => {
                            this.reloadData([/*'flags','customer.amlDocuments'*/], () => {
                                //this.$refs.notesModule.getNotes();
                                _.forEach(this.documents, (d) => {
                                    if(d.id == item.id) {
                                        d.voided_at = e.data.data.voided_at;
                                    }
                                });
                                this.updateCompliance();
                            });
                        }
                    );
                };
                if (!this.$store.getters.hasPermission('void documents')) {
                    this.$refs.GenericPopups.displayPermission =
                        {
                            title: 'Permission denied',
                            permission: 'void documents',
                            text: 'Action was denied, request override for void documents',
                            ok: 'Manager Override', //manager override will do function
                            cancel: 'Cancel', //cancel is a 'ok'
                            okAction: () => {
                                fireAction();
                            },
                            onClose: () => {
                                //delete item.isSaving;
                                //this.$forceUpdate();
                            },
                            endPointsLater: ['/documents/' + item.id]
                        };
                } else {
                    fireAction();
                }
                this.$forceUpdate();
            },
            openUploadedDocument(path){
                this.$http.get('/document-uploads/getSignedUrl/byPath', {
                    params: {path: path}
                })
                    .then(response => {
                        window.open(response.data,'_blank');
                    });
            },
            uploadDocument(){
                this.document_upload.isSaving = true;
                let send = new FormData();
                send.append('file', this.document_upload.file);
                if(this.document_upload.type_selected == 'Other') {
                    send.append('description', this.document_upload.description);
                }
                else{
                    send.append('description', this.document_upload.type_selected);
                }
                let headerExtra = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                };
                this.$http.post('/orders/' + this.order.id +'/uploadDocuments',send,headerExtra).then((e)=>{
                    this.document_upload.isSaving = false;
                    this.$bvModal.hide('modal-documents');
                    this.documentUploaded.push(e.data.data);
                    this.updateCompliance();
                }).catch(e => {
                    this.document_upload.isSaving = false;
                });
            },
            createDocument(){
                this.document_created.isSaving = true;
                let send = {
                    document_type_id: this.document_created.type_selected,
                };
                if (this.document_created.type_selected == 7) { // Release of Claims
                    if (this.document_created.is_jewelry_replacement) {
                        send.form_data = '{"settlement_amount":"' + this.document_created.settlement + '"}';
                    } else if (this.document_created.settlement && !this.document_created.is_jewelry_replacement) {
                        send.form_data = '{"settlement_amount":"$' + this.document_created.settlement.replace('$', '') + '"}';
                    }
                }
                this.$http.post('/orders/' + this.order.id +'/documents',send).then((e)=>{

                    this.reloadData([/*'flags'*/], ()=> {
                        let dtime = new Date().getTime();
                        let formatTime = moment(dtime).format('h:mm A');

                        let option = _.find(this.document_created.type_options,(e)=>{return e.value == this.document_created.type_selected;});
                        //this.$refs.notesModule.addNote(formatTime + ' - ' + option.text + ' Document was created');
                       // this.$refs.notesModule.getNotes();
                        //this.documents.push(e.data.data);
                        this.updateDocument({ document: e.data.data });
                        this.document_created.isSaving = false;
                        this.$bvModal.hide('modal-documents');
                        this.updateCompliance();
                    });
                }).catch((e)=> {
                    this.document_created.isSaving = false;
                });
            },
            activateImageModal(item){
                this.$refs.PhotoWidget.renderImage(item);
            },
            activateVideoModal(item){
                this.$refs.PhotoWidget.renderVideo(item);
            },
            //fixme vue js bug? set functions were malformed
            isItemNegotiable: function(item) {
                //if (this.order.status_id != 13) {
                    switch (item.status_name) {
                        case 'hold':
                        case 'melt':
                        case 'batched':
                        case 'reverse-ship':
                            return true;
                    }
                //}
                return false;
            },
            hasBeenReceived(target){
                switch(target.status_name){
                    case 'Kit Received':
                    case 'Appraisal':
                    case 'Appraisal Hold':
                    case 'Quality Assurance':
                    case 'Offer Generation':
                    case 'Offer Ready':
                    case 'Offer Accepted':
                    case 'Offer Declined':
                    case 'Reverse Ship':
                    case 'Returned':
                    case 'Settled':
                    case 'Batched':
                    case 'Closed':
                        return true;
                }
                return false;
            },
            isReadyForNewRequest(target) {
                switch(target.status_name){
                    case 'Kit Inbound':
                    case 'Kit Received':
                    case 'Appraisal':
                    case 'Appraisal Hold':
                    case 'Quality Assurance':
                    case 'Offer Generation':
                    case 'Offer Ready':
                    case 'Offer Accepted':
                    case 'Offer Declined':
                    case 'Reverse Ship':
                    case 'Returned':
                    case 'Settled':
                    case 'Batched':
                    case 'Closed':
                        return true;
                }
                return false;
            },
            preventInvalidNumberKeys(event) {
                if (['e'].indexOf(event.key) != -1) { //
                    event.preventDefault();
                }
            },
            isToday(target){
                const today = new Date();
                return target.getDate() == today.getDate() &&
                    target.getMonth() == today.getMonth() &&
                    target.getFullYear() == today.getFullYear();
            },
            isAfterNow(date){
                const time = 30 * 60000; //30 minutes * ms for a minute
                return new Date().getTime() < date.getTime() + time ;
            },
            fixFormattingNoCaps(script){
                return script ? script.toString()
                    .replace('_masked','') //remove masked
                    .replace(/-/g, ' ') // remove -
                    .replace(/_/g, ' ') // remove _
                     : null;
            },
            fixFormatting(script){
                script = this.fixFormattingNoCaps(script);
                return script ? script.replace //cap letters
                (
                    /\w\S*/g
                    , function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();}
                ) : null;
            },
            isBoolField(key){
                switch(key){
                    case 'verification_xrf':
                    case 'verification_acid':
                    case 'verification_magnet':
                    case 'verification_hallmark':
                    case 'verification_other':
                    case 'large_kit':
                        return true;
                    default:
                        return false;
                }
            },
            convertBool(value){
                if(value === null || value === undefined){
                    return '-';
                }
                if (value == 1){
                    return 'True';
                }
                if (value == 0){
                    return 'False';
                }
                return '-';
            },
            sendEmail(){
                let send = {email: null};
                this.send_email.isSaving = true;
                let option = null;
                switch(this.send_email.topic.selected){
                    case 'customer_service':
                        send.email = this.send_email.customer_service.selected;
                        if (send.email == 'insurance_confirmation' || send.email == 'insurance_confirmation_overnight_label' || send.email == 'insurance_confirmation_parcal_pro') {
                            send.insurance_coverage_amount = this.send_email.customer_service.insurance_coverage_amount;
                        }
                        option = _.find(this.send_email.customer_service.options,function(e){return e.value == send.email;});
                        break;
                    case 'missing_info':
                        send.email = this.send_email.payment_hold.selected;
                        option = _.find(this.send_email.payment_hold.options,function(e){return e.value == send.email;});
                        break;
                    case 'shipping_label':
                        send.email = this.send_email.shipping_label.selected;
                        send.label_count = this.create_new_order.label_count;
                        option = _.find(this.send_email.shipping_label.options,function(e){return e.value == send.email;});
                        break;
                    default:
                        return;
                }

                this.$http.post('/orders/' + this.order.id + '/sendEmail',send).then((res)=>{
                    this.send_email.isSaving = false;
                    if(res.data.successful) {
                        this.$bvModal.hide('modal-email');
                        let dtime = new Date().getTime();
                        let formatTime = moment(dtime).format('h:mm A');
                        if (send.email === 'welcome_text_with_ekit') {
                            this.$refs.notesModule.addNote(formatTime + ' - ' + option.text + ' Text - was Sent');
                        } else {
                            this.$refs.notesModule.addNote(formatTime + ' - ' + option.text + ' Email - was Queued');
                        }
                        this.reloadData([/*'flags',*/ 'trackingNumbers']);
                    } else {
                        this.$parent.$bvModal.msgBoxOk(res.data.message, {
                            title: 'Issue Sending Email',
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'danger',
                            headerClass: 'p-2 border-bottom-0 text-center d-block',
                            footerClass: 'p-2 border-top-0',
                        });
                    }
                });
            },
            resetPassword() {
                this.passwordResetData.isSaving = true;
                let send = {
                    //email: 'reset_password',
                };
                //this.$http.post('/orders/' + this.order.id + '/sendEmail',send).then((res)=>{
                this.$http.get('/customers/' + this.customer.id + '/resetPassword/' + this.order.id).then((res)=>{
                    if(res.data) {
                        let dtime = new Date().getTime();
                        let formatTime = moment(dtime).format('h:mm A');
                        //this.$refs.notesModule.addNote(formatTime + ' - reset password Email - was Queued');
                        this.$bvModal.msgBoxOk('Reset password email has been queued.', {
                            title: 'Success',
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'success',
                            headerClass: 'p-2 border-bottom-0 text-center d-block',
                            footerClass: 'p-2 border-top-0',
                        });
                    } else {
                        this.$parent.$bvModal.msgBoxOk(res.data.message, {
                            title: 'Issue Sending Email',
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'danger',
                            headerClass: 'p-2 border-bottom-0 text-center d-block',
                            footerClass: 'p-2 border-top-0',
                        });
                    }
                }).finally(() => {
                    this.passwordResetData.isSaving = false;
                });
            },
            resendKit(){
                this.resend_kit_isWorking = true;
                let send = {send_welcome: this.resend_kit};
                this.$http.post('/orders/' + this.order.id + '/RemailKit', send).then((res)=>{
                    this.reloadData(['leads','currentLead'/*, 'flags'*/],()=> {
                        if (this.send_kit) {
                            let dtime = new Date().getTime();
                            let formatTime = moment(dtime).format('h:mm A');
                            this.$refs.notesModule.addNote(formatTime + ' - Welcome Email - was Queued');
                        }
                        if (this.leads.length > 0) {
                            this.leads[this.leads.length - 1] = res.data.data;
                        } else {
                            this.leads = [res.data.data];
                        }
                        //fixme for no reason, this wasn't working via watcher or computed, so I'm forcing it to work the most direct way.
                        this.latestLead = res.data.data;
                        this.cachedLeads = Object.assign([], this.leads);
                        this.$bvModal.hide('modal-resend-kit');
                        this.resend_kit_isWorking = false;
                        this.$forceUpdate();
                    });
                }).catch((e)=>{this.resend_kit_isWorking = false;});
            },
            scheduleFive9Call(){
                this.schedule_five9_call.isSaving = true;
                let send = {
                    date: new Date(this.schedule_five9_call.date),
                    type: this.schedule_five9_call.type,
                    notes: this.schedule_five9_call.notes,
                };
                this.$http.post('/orders/' + this.order.id + '/ScheduleFive9Call', send).then((res)=>{
                    this.schedule_five9_call.isSaving = false;
                    this.$bvModal.hide('modal-schedule-five9-call');
                    let dtime = new Date().getTime();
                    let formatTime = moment(dtime).format('h:mm A');
                    let showDate = moment(this.schedule_five9_call.date).tz('America/New_York').format('MM/DD/YYYY hh:mm a');
                    this.$refs.notesModule.addNote(formatTime + ' - Five9 call was scheduled for ' + showDate);
                    this.flags = res.data.data;
                }).catch((e)=>{this.schedule_five9_call.isSaving = false;});
            },
            attemptNPEdit(postAction = function(){}, item = null, popupOverride = true) {
                if((!item || item.appraisal.value != 0) && this.np_unlock) {
                    if (popupOverride) {
                        this.overrideNPLock(postAction);
                    }
                    return false;
                }
                postAction(false);
                return true;
            },
            checkNPEdit(item = null) {
                if((!item || item.appraisal.value != 0) && this.np_unlock) {
                    return false;
                }
                return true;
            },
            isItemEditable(item){
                if(this.isItemNegotiable(item)){
                    if(this.isOfferUnlocked){
                        if(this.checkNPEdit(item)) {
                            return true;
                        }
                    }
                }
                return false;
            },
            unlockOffer(){
                //todo permissions
                if(this.isOfferNegotiable){
                    //'manage offers'
                    if(!this.$store.getters.hasPermission('manage offers')) {
                        this.$refs.GenericPopups.displayPermission =
                            {
                                title: 'Needs Permission to unlock offer',
                                permission: 'manage offers',
                                text: 'Offer requires higher permission level to unlock',
                                ok: 'Manager Override', //manager override will do function
                                cancel: 'Cancel', //cancel is a 'ok'
                                okAction: () => {
                                    this.saveOfferFire();
                                },
                                endPointsLater: ['/offers/' + this.offer.id + '/approve', '/offers/' + this.offer.id + '/accept', '/offers/' + this.offer.id +  'updateAccept','/offers/' + this.offer.id + '/decline']
                            };
                    } else {
                        this.saveOfferFire(); //lazy unlock
                    }
                } else {
                    if (this.getFlagsByType(15).length > 0) {
                        this.np_unlock = true;
                        this.locked = false;
                    }
                    else if(!this.$store.getters.hasPermission('manage payments')) {
                        this.$refs.GenericPopups.displayPermission =
                            {
                                title: 'Needs Permission to unlock offer',
                                permission: 'manage payments',
                                text: 'Offer requires higher permission level to unlock',
                                ok: 'Manager Override', //manager override will do function
                                cancel: 'Cancel', //cancel is a 'ok'
                                okAction: () => {
                                    this.locked = false;
                                },
                                endPointsLater: ['/offers/' + this.offer.id + '/approve', '/offers/' + this.offer.id + '/accept', '/offers/' + this.offer.id +  'updateAccept','/offers/' + this.offer.id + '/decline']
                            };
                    } else {
                        this.locked = false;
                    }
                }
            },
            unlockOfferAndSaveAsAccepted(){
                this.edits.offer.isSaving = 'accept';
                this.$http.put('/orders/' + this.order.id, {override_inventory: 1})
                .then(() => {
                    _.keys(this.inventory).forEach((metal) => {
                        this.inventory[metal].forEach(function (item){
                            item.in_offer = true;
                        });
                    });
                    this.acceptOfferFire(true);
                })
                .catch(() => {
                    this.edits.offer.isSaving = false;
                    this.$forceUpdate();
                });
                
            },
            overrideNPLock(postAction = function(){}) {
                this.$refs.GenericPopups.displayPermission =
                    {
                        title: 'Updating precious metal requires approval',
                        permission: 'manage payments',
                        text: 'Precious metal items being altered affects the offer price. Please request approval to proceed.',
                        ok: 'Manager Override', //manager override will do function
                        cancel: 'Cancel', //cancel is a 'ok'
                        okAction: () => {
                            this.np_unlock = false;
                            postAction(true);
                        },
                        endPointsLater: ['/offers/' + this.offer.id + '/approve', '/offers/' + this.offer.id + '/accept', '/offers/' + this.offer.id +  'updateAccept', '/offers/' + this.offer.id + '/decline']
                    };
            },
            bonus_update5: function(value){
                if(value) {
                    this.order.bonus_card_present = true;
                    if(this.offer && this.isOfferNegotiable) {
                        //this.bonus_card_present = true;
                    }
                }
                else{
                    this.order.bonus_card_present = false;
                }
                this._saveEdits('bonus_override');
            },
            bonus_update10: function(value){
                if(value) {
                    this.order.trust_sequence_bonus = true;
                    if(this.offer && this.isOfferNegotiable) {
                        //this.trust_sequence_bonus = true;
                    }
                }
                else{
                    this.order.trust_sequence_bonus = false;
                }
                this._saveEdits('bonus_override');
            },
            updateCompliance(){
                this.edits.compliance.id = this.getIDCompliance();
                this.edits.compliance.dob = this.getDOBCompliance();
                this.edits.compliance.ssn = this.getSSNCompliance();
                if(!this.getValidStandardAddress()){
                    this.edits.compliance.address = 2;
                }
                else if(!this.getValidStandardAddress() && this.getPoBoxAddress()){
                    this.edits.compliance.address = 1;
                }
                else {
                    this.edits.compliance.address = 0;
                }
                this.edits.compliance.payment = this.getPaymentMethodCompliance();
                this.edits.compliance.Enhanced_verification = this.getEnhancedVerificationCompliance();
                this.edits.compliance.AML = this.getAMLCompliance();
                this.edits.compliance.isLoading = false;
                this.$forceUpdate();
                /*
                this.compliance = [];
                //signature
                this.compliance.push({text:"Signature",value: this.order.card_signed ? 0 : 1});
                //license
                this.compliance.push({text:'Identification', value: this.getIDCompliance() ? 0 : 1 });
                //dob
                this.compliance.push({text:"DOB", value:this.getDOBCompliance() ? 0 : 1});
                //address
                if(!this.getValidStandardAddress()){
                    this.compliance.push({text:"Address Not Verified", value: 1});
                }
                else if(!this.getPoBoxAddress()){
                    this.compliance.push({text: "Address is PO. Box", value: 1});
                }
                else {
                    this.compliance.push({text: "Address Verified", value: 0});
                }
                //payments
                this.compliance.push({text:"Payment Method", value: this.getPaymentMethodCompliance() ? 0 : 1});
                //aml
                this.compliance.push({text:'AML', value: this.getAMLCompliance().length == 0 ? 0 : 1} );
                //enhanced verification
                this.compliance.push({text: "Enhanced verification", value: this.getEnhancedVerificationCompliance().length == 0 ? 0 : 1 }); */
            },
            getValidStandardAddress() {
                return (this.customer.address.verified || this.customer.address.po_box_verified);
            },
            getPoBoxAddress() {
                let pattern = /p.*o.*b.*o.*x/i;
                return (this.customer.address.address1.match(pattern));
            },
            getDOBCompliance(){
                let ret = true;
                _.forEach(this.$refs.dob_observer.$data.errors, (e)=>{
                    if(e.length != 0){
                        ret = false;
                    }
                });
                return ret;
            },
            getSSNCompliance(){
                let ret = true;
                _.forEach(this.$refs.ssn_observer.$data.errors, (e)=>{
                    if(e.length != 0){
                        ret = false;
                    }
                });
                return ret;
            },
            getIDCompliance(){
                let ret = true;
                _.forEach(this.$refs.id_observer.$data.errors, (e)=>{
                    if(e.length != 0){
                        ret = false;
                    }
                });
                return ret;
            },
            getPaymentMethodCompliance(){
                let ret = true;
                _.forEach(this.$refs.payment_method_observer.$data.errors, (e)=>{
                    if(e.length != 0){
                        ret = false;
                    }
                });
                return ret && this.order.bank_routing_valid;
            },
            getEnhancedVerificationCompliance(){
                let ret = null;
                _.forEach(this.documents, (e) =>{
                     if((e.document_type == 'Proof of Ownership' || e.document_type == 'PTA - Proof of Ownership')){
                         if(e.voided_at == null && e.signed_at == null){
                             ret = 0;
                         } else if (ret == null && e.voided_at == null){
                             ret = 1;
                         }
                     }
                });
                return ret;
            },
            getAMLCompliance(){
                let ret = null;
                _.forEach(this.documents, (e) =>{
                    if(e.document_type == 'Anti-Money Laundering Declaration'){
                        if(e.voided_at == null && e.signed_at == null){
                            ret = 0;
                        } else if (ret == null && e.voided_at == null){
                            ret = 1;
                        }
                    }
                });
                return ret;
            },
            getEnhancedVerificationDocument(){
                return _.filter(this.documents, (e) =>{
                    return ((e.document_type == 'Proof of Ownership' || e.document_type == 'PTA - Proof of Ownership') && e.voided_at == null && e.signed_at == null);
                });
            },
            getAMLDocument(){
                return _.filter(this.documents, (e) =>{
                    return (e.document_type == 'Anti-Money Laundering Declaration' && e.voided_at == null && e.signed_at == null);
                });
            },
            updateConvienceAccept(){
                this.edits.customer_convience.wasUpdated = true;
                this._saveEdits('customer_convience');
            },
            getValidationState({dirty, validated, valid = null}) {
                return dirty || validated ? valid : null;
            },
            getValidationComplaint({errors = []}){
                if(errors.length > 0){
                    return errors[0];
                }
                return '';
            },
            getComplaintList(errors){
                if(errors.length > 0){
                    return errors[0];
                }
                return '';
            },

            reportErrorList(errors){
                console.log(errors);
                return errors;
            },
            deleteInventory(id){
                this.$refs.GenericPopups.displayDialog =
                    {
                        title: 'Delete Item?',
                        text: 'Are you sure you want to delete this item?',
                        okAction: () =>
                        {
                            this.$http.delete('/inventory/'+id).then((data) => {
                                this.getAppraisals();
                            });
                        },
                        ok: 'Delete',
                    };
            },
            createManualPayment() {
                if(!this.isVisiblePayments) {
                    this.isVisiblePayments = true;
                }
                this.manual_payment.modal = true;
                this.manual_payment.method_selected = this.order.payment_method;
                this.manual_payment.bank_routing = this.order.bank_routing;
                this.manual_payment.bank_account = this.order.bank_account;
                this.manual_payment.paypal_email = this.order.paypal_email;
                this.manual_payment.status_selected = 'pre-approved';
                this.manual_payment.type_selected = 'none';
                this.manual_payment.amount = null;
                this.manual_payment.amount_reissue = (this._failedPaymentsCount == 1) ? this._failedPayments[0].amount : null},
            closeManualPayment(){
                this.manual_payment.modal = null;
            },
            createManualPaymentFinal() {
                this.manual_payment.isSaving = true;
                let payment = {
                    id: this.order.id,
                    status: this.manual_payment.status_selected,
                    payment_method: this.manual_payment.method_selected,
                    payment_type: this.manual_payment.type_selected,
                    amount: this.manual_payment.type_selected == 'reissue' ? this.manual_payment.amount_reissue : this.manual_payment.amount,
                };
                switch(this.manual_payment.method_selected){
                    case 'paypal':
                        payment.paypal_email = this.manual_payment.paypal_email;
                        break;
                    case 'direct-deposit':
                        payment.bank_routing = this.manual_payment.bank_routing;
                        payment.bank_account = this.manual_payment.bank_account;
                        break;
                }
                this.$http.post('/orders/' + this.order.id + '/payments',payment)
                    .then((res)=>{
                        this.updatePayment(res.data.data);
                        this.cachedOrder = Object.assign({}, this.order);
                        this.manual_payment.modal = null;
                        this.manual_payment.isSaving = false;
                        //this.reloadData(['flags']);
                    }).catch((e)=>{
                        console.log('error',e);
                        this.manual_payment.isSaving = false;
                    });
            },
            getPaymentFields(){
                /*
                ['ID', 'Status','Type','Method','Amount','Created','Processed','Processed Status']
                 */
                return [
                    {label: 'id',  key: 'id'},
                    {label: 'Status',  key: 'status'},
                    {label: 'Type',  key: 'payment_type'},
                    {label: 'Method',  key: 'payment_method'},
                    {label: 'Check Number', key: 'check_number'},
                    {label: 'Amount',  key: 'amount'},
                    {label: 'Created',  key: 'created_at'},
                    {label: 'Processed at',  key: 'processed_at'}
                ];
            },
            getPaymentTypeText(value){
                switch(value){
                    case 'customer-payment': return 'Customer Payment';
                    case 'reimbursement': return  'Reimbursement';
                    case 'reissue' : return 'Reissue';
                    case 'claim': return 'Claim';
                    case 'referral': return 'Referral Payment';
                }
            },
            getPaymentMethodText(value){
                switch(value){
                    case 'paypal': return 'Paypal';
                    case 'direct-deposit': return  'Direct Deposit';
                    case 'company-check' : return 'Company Check';
                }
            },
            orderSelect(row){
                if(row.id != this.order.id) {
                    this.$router.push('/kit/view/' + row.id);
                    //fixme forced reset. fixed for kits view!!
                    //this.$router.go(0);
                }
            },
            loadBrand() {
                this.create_new_order.brand.options = [];
                this.$store.dispatch('LOAD_BRAND', (brands) =>
                    _.each(brands, item => {
                        let disabled = false;
                        if ((this.$route.query.brand && item.abbreviation === this.$route.query.brand)
                            || (this.$route.query.bid && item.id === parseInt(this.$route.query.bid))) {
                            this.create_new_order.brand.selected = item.id;
                        } else if (item.id === this.order.brand.id && (this.order.status_id === 1 || this.order.status_id === 2) && !this.order.HasRequestExpired) {
                            disabled = true;
                            if (!this.$route.query.brand && !this.$route.query.bid) {
                                this.create_new_order.brand.selected = null;
                            }
                        }
                        this.create_new_order.brand.options.push({value: item.id, text: item.name, disabled: disabled});
                    })
                );
            },
            createNewOrder(){
                let send = {
                    brand_id: this.create_new_order.brand.selected,
                    payment_method: 'company-check',
                    label_count: this.create_new_order.label_count,
                    home_pickup: this.create_new_order.home_pickup,
                    abstract_shipping_level: this.create_new_order.shipping_method.selected,
                };
                switch(this.create_new_order.campaign.option_selected) {
                    case null:
                        break;
                    case 'tv': // tv 98
                        send.campaign = 98;
                        break;
                    case 'phone'://phone 89
                        send.campaign = 89;
                        break;
                    case 'email'://email 108
                        send.campaign = 108;
                        break;
                    case 'text'://text 107
                        send.campaign = 107;
                        break;
                    case 'chat'://chat 103
                        send.campaign = 103;
                        break;
                    case 'google':
                        send.campaign = 109;
                        break;
                    case 'bing':
                        send.campaign = 110;
                        break;
                    case 'valpak':
                        send.campaign = 111;
                        break;
                    case 'referral':
                        send.campaign = 112;
                        break;
                    case 'other':
                        send.campaign = this.create_new_order.campaign.value;
                        break;
                }
                let targetOrders = _.filter(this.customerOrders, (e) => {
                    if(e.brand.id == send.brand_id){
                        return true;
                    }
                    return false;
                });
                let target = null;
                if(targetOrders.length > 0){
                    target = targetOrders[targetOrders.length-1];
                    if(target.id == this.order.id){
                        //override if status changed bug.
                        target = this.order;
                    }
                }
                //no order exists, or is after recieved.
                if(!target || this.isReadyForNewRequest(target) || target.HasRequestExpired) {
                    if(this.customer.ban_at_new_order) {
                        this.$refs.GenericPopups.displayPermission =
                            {
                                title: 'Issue creating new order',
                                permission: 'manage leads',
                                text: 'Customer has had their two previous orders with no value, override and create new Order?',
                                ok: 'Manager Override', //manager override will do function
                                cancel: 'Cancel', //cancel is a 'ok'
                                okAction: () => {send.override_ban = true; this.doCreateNewOrder(send);},
                                endPointsLater: ['/customers/' + this.customer.id + '/orders']
                            };
                    } else {
                        this.doCreateNewOrder(send);
                    }
                } else {
                    this.createNewOrders.isSaving = true;
                    this.$http.post('/orders/' + target.id + '/leads', send).then((response) => {
                        //this.$bvModal.hide('modal-create-new-order');
                        this.$router.push('/kit/view/' + target.id);
                        this.$bvModal.hide('modal-create-new-order');
                        //this.$router.go(0);
                    }).finally(e => {
                        this.createNewOrders.isSaving = false;
                    });
                }
            },
            doCreateNewOrder(send) {
                this.createNewOrders.isSaving = true;
                this.$http.post('/customers/' + this.customer.id + '/orders', send).then((response) => {
                    console.log(response);
                    //this.$bvModal.hide('modal-create-new-order');
                    this.$router.push('/kit/view/' + response.data.data.id);
                    this.$bvModal.hide('modal-create-new-order');
                    //this.$router.go(0);
                }).finally(e=>{
                    this.createNewOrders.isSaving = false;
                });
            },
            saveOffer() {
                if(this.offer.total_offer.toFixed(2) == 5 && this.offer.bonus_amount != 0){
                    this.$refs.GenericPopups.displayPermission =
                        {
                            title: 'Your Offer amount is less than $5',
                            permission: 'manage offers',
                            text: 'A 5% bonus should not be applied to offers less than $5.',
                            ok: 'Manager Override', //manager override will do function
                            cancel: 'Ok', //cancel is a 'ok'
                            okAction: () => {
                                this.saveOfferFire();
                            },
                            onClose: () => {
                                this.bonus_percent = 0;
                                this.offer.bonus_amount = 0;
                            },
                            endPointsLater: ['/offers/' + this.offer.id + '/approve', '/offers/' + this.offer.id + '/accept', '/offers/' + this.offer.id +  'updateAccept', '/offers/' + this.offer.id + '/decline']
                        };
                } else if (this._offerTotalAmount > this._maxOfferOverride) {
                    this.$refs.GenericPopups.displayPermission =
                        {
                            title: 'Your payout percentage requires approval',
                            permission: 'manage offers',
                            text: 'Your payout percentage exceeds the payout thresholds. Please request approval to move forward or adjust by removing a bonus or lowering the payout percentage.',
                            ok: 'Manager Override', //manager override will do function
                            cancel: 'Ok', //cancel is a 'ok'
                            okAction: () => {
                                this.saveOfferFire();
                            },
                            endPointsLater: ['/offers/' + this.offer.id + '/approve', '/offers/' + this.offer.id + '/accept', '/offers/' + this.offer.id +  'updateAccept', '/offers/' + this.offer.id + '/decline']
                        };
                } else {
                    this.saveOfferFire();
                }
             },
             saveOfferFire() {
                this.edits.offer.isSaving = 'save';
                 let that = this;
                 let offer_items = [];
                 _.keys(this.inventory).forEach(function (metal) {
                     that.inventory[metal].forEach(function (item) {
                         offer_items.push({
                             'inventory_id': item.id,
                             'offer_id': that.offer.id,
                             'offer_amount': item.offer_amount,
                             'in_offer': item.in_offer ? 1 : 0,
                         });
                     });
                 });
                 let send = _.assign({}, this.offer);
                 send.offer_items = offer_items;
                 delete send.inventory;
                 if (this.edits.customer_convience.wasUpdated) {
                     send.allow_convenience_accept = this.order.allow_convenience_accept;
                 } else {
                     this.order.allow_convenience_accept = false;
                     send.allow_convenience_accept = this.order.allow_convenience_accept;
                 }
                 ///orders/{order}/Offers
                 let url = '/offers/' + this.offer.id;
                 if (this.isOfferNegotiable) {
                     url += '/approve';
                 } else {
                     url += '/updateAccept';
                 }
                this.$http.post(url , send).then((response)=>{
                    this.reloadData2(['flags','documents', 'payments'], ()=>{
                        this.updateCompliance();

                        this.edits.offer.isSaving = false;
                        if (this.isOfferNegotiable) {
                            this.order.status_id = 8;
                            this.order.status_name = 'Offer Ready';
                        }

                        this.offer = response.data.data;
                        this.processInventory(response.data.data.inventory, null);
                    });
                }).catch(e => {this.edits.offer.isSaving = false;});
            },
            declineOffer() {
                this.attemptNPEdit(() => {
                    this.$bvModal.msgBoxConfirm('Are you sure you want to decline this offer on behalf of the customer?', {
                        title: 'Decline Offer?',
                        size: 'md',
                        buttonSize: 'sm',
                        okTitle: 'Yes',
                        okVariant: 'danger',
                        cancelVariant: 'secondary',
                        headerClass: 'p-2 border-bottom-0 text-center d-block',
                        footerClass: 'p-2 border-top-0',
                    }).then((value) => {
                        if (value) {
                            this.declineOfferFire();
                        }
                    });
                });
            },
            declineOfferFire(){
                this.edits.offer.isSaving = 'decline';
                let that = this;
                let offer_items = [];
                _.keys(this.inventory).forEach(function (metal) {
                    that.inventory[metal].forEach(function (item){
                        offer_items.push({
                            'inventory_id': item.id,
                            'offer_id': that.offer.id,
                            'offer_amount': item.offer_amount,
                            'in_offer': item.in_offer ? 1 : 0,
                        });
                    });
                });
                let send = _.assign({},this.offer);
                send.offer_items = offer_items;
                delete send.inventory;
                if(this.edits.customer_convience.wasUpdated) {
                    send.allow_convenience_accept = this.order.allow_convenience_accept;
                } else {
                    send.allow_convenience_accept = this.order.allow_convenience_accept;
                    this.order.allow_convenience_accept = false;
                }
                ///orders/{order}/Offers
                this.$http.post('/offers/' + this.offer.id + '/decline',send).then((response)=>{
                    this.reloadData2(['flags','documents', 'payments'], ()=>{
                        this.updateCompliance();
                        this.edits.offer.isSaving = false;
                        if(this.order.status_id == 8) {
                            this.order.status_id = 10;
                            this.order.status_name = 'Offer Declined';
                        }

                        this.offer = response.data.data;

                        let metals = {};
                        let sortedMetals = {};
                        response.data.data.inventory.forEach((item) => {
                            this.locked = true;
                            if (item.children.length > 1) {
                                this.$set(item, '_showDetails', false);
                            }

                            if(item && item.children && item.children[0]) {
                                if (item.children[0].class_name in metals) {
                                    metals[item.children[0].class_name].push(item);
                                } else {
                                    metals[item.children[0].class_name] = [];
                                    metals[item.children[0].class_name].push(item);
                                }
                            }
                        });

                        _.forEach(metals, function(value, key) {
                            sortedMetals[key] = _.orderBy(metals[key], [function(o) { return parseFloat(o.children[0].purity); }], ['desc']);
                        });
                        if( 'diamond' in sortedMetals && 'melee' in sortedMetals ) {
                            sortedMetals.diamond.push(...sortedMetals.melee);
                            delete sortedMetals.melee;
                        }

                        this.inventory = sortedMetals;
                    });
                }).catch(e => {this.edits.offer.isSaving = false;});
            },
            acceptOffer(){
                if(this.offer.total_offer.toFixed(2) == 5 && this.offer.bonus_amount != 0){
                    this.$refs.GenericPopups.displayPermission =
                        {
                            title: 'Your Offer amount is less than $5',
                            permission: 'manage offers',
                            text: 'A 5% bonus should not be applied to offers less than $5.',
                            ok: 'Manager Override', //manager override will do function
                            cancel: 'Ok', //cancel is a 'ok'
                            okAction: () => {
                                this.acceptOfferFire();
                            },
                            onClose: () => {
                                this.bonus_percent = 0;
                                this.offer.bonus_amount = 0;
                            },
                            endPointsLater: ['/offers/' + this.offer.id + '/approve', '/offers/' + this.offer.id + '/accept', '/offers/' + this.offer.id +  'updateAccept', '/offers/' + this.offer.id + '/decline']
                        };
                } else if (this._offerTotalAmount > this._maxOfferOverride) {
                    this.$refs.GenericPopups.displayPermission =
                        {
                            title: 'Your payout percentage requires approval',
                            permission: 'manage offers',
                            text: 'Your payout percentage exceeds the payout thresholds. Please request approval to move forward or adjust by removing a bonus or lowering the payout percentage.',
                            ok: 'Manager Override', //manager override will do function
                            cancel: 'Ok', //cancel is a 'ok'
                            okAction: () => {
                                this.acceptOfferFire();
                            },
                            endPointsLater: ['/offers/' + this.offer.id + '/approve', '/offers/' + this.offer.id + '/accept', '/offers/' + this.offer.id +  'updateAccept', '/offers/' + this.offer.id + '/decline']
                        };
                } else {
                    this.$bvModal.msgBoxConfirm('Are you sure you want to accept this offer on behalf of the customer?', {
                        title: 'Accept Offer?',
                        size: 'md',
                        okTitle: 'Yes',
                        buttonSize: 'sm',
                        okVariant: 'success',
                        cancelVariant: 'secondary',
                        headerClass: 'p-2 border-bottom-0 text-center d-block',
                        footerClass: 'p-2 border-top-0',
                    }).then((value) => {
                        if (value) {
                            this.acceptOfferFire();
                        }
                    });
                }
            },
            acceptOfferFire(force = null){
                this.edits.offer.isSaving = 'accept';
                let that = this;
                let offer_items = [];
                _.keys(this.inventory).forEach(function (metal) {
                    that.inventory[metal].forEach(function (item){
                        offer_items.push({
                            'inventory_id': item.id,
                            'offer_id': that.offer.id,
                            'offer_amount': item.offer_amount,
                            'in_offer': item.in_offer ? 1 : 0,
                        });
                    });
                });
                let send = _.assign({},this.offer);
                send.offer_items = offer_items;
                delete send.inventory;
                if(this.edits.customer_convience.wasUpdated) {
                    send.allow_convenience_accept = this.order.allow_convenience_accept;
                } else {
                    send.allow_convenience_accept = this.order.allow_convenience_accept;
                    this.order.allow_convenience_accept = false;
                }
                ///orders/{order}/Offers
                this.$http.post('/offers/' + this.offer.id + ((this.isOfferNegotiable || force) ? '/accept' : '/updateAccept'),send).then((response)=>{
                    this.reloadData2(['flags','documents', 'payments'], ()=>{
                        this.updateCompliance();
                        this.edits.offer.isSaving = false;
                        this.locked = true;
                        this.np_unlock = false;
                        /*if(this.order.status_id == 8) { #fixme no longer nessassary with reloadData2 being used to slow transport data.
                            this.order.status_id = 9;
                            this.order.status_name = 'Offer Accepted';
                        } else */if(this.order.status_name == 'Reverse Ship'){
                            this.$bvModal.msgBoxOk('The order has a zero value offer and is missing information. Please update the missing information, or this order will automatically return to the customer.', {
                                title: 'This Order is Missing `Information',
                                size: 'md',
                                buttonSize: 'sm',
                                okVariant: 'danger',
                                headerClass: 'p-2 border-bottom-0 text-center d-block',
                                footerClass: 'p-2 border-top-0',
                            });
                        }

                        this.offer = response.data.data;
                        this.processInventory(response.data.data.inventory, null);
                    });
                }).catch(e => {this.edits.offer.isSaving = false;});
            },
            setTotalPercentOfferWithBonusEvent(offer_percent){
                this.setTotalPercentOfferWithBonus(offer_percent.target.value);
            },
            setTotalOfferWithBonusEvent(offer_total){
                this.setTotalOfferWithBonus(offer_total.target.value);
                // console.log('setTotalOfferWithBonusEvent value:', offer_total.target.value);
            },
            setTotalPercentOfferWithBonus(offer_percent){
                if(this.isOfferUnlocked && this.offer) {
                    this.attemptNPEdit(() => {
                        let offer_total = this.offer.total_value * offer_percent / 100 || 0;
                        this.setTotalOfferWithBonus(offer_total);
                    });
                }
            },
            setTotalOfferWithBonus(offer_total){
                // let base = offer_total - this.offer.bonus_amount;
                let base = _.round(offer_total / (1 + (this.bonus_percent / 100)), 8);
                this.offer.bonus_amount = _.round(base * this.bonus_percent / 100, 2);

                // console.log('setTotalOfferWithBonus base value:', base);
                this.setTotalOfferValue(base);
            },
            setTotalOfferValue(offer_value){
                // console.log('setTotalOfferValue input value:', offer_value);
                let actual_value = _.round(this.offer.total_value, 2) || 0;
                if(actual_value == 0 ) {
                    let total = _.sum(_.keys(this.inventory).map((metal) =>{ return that.inventory[metal].length; }));
                    let eachValue = _.round(5.0/total, 2);
                    //for remainder check
                    let firstValuedItem = null;
                    _.keys(this.inventory).forEach(function (metal) {
                        that.inventory[metal].forEach(function (item) {
                            item.offer_percent = 0;
                            item.offer_amount = eachValue;
                            firstValuedItem = item;
                            let perChildItem = _.round(eachValue / item.children.length, 2);
                            item.children.forEach(function (item) {
                                item.offer_amount = perChildItem;
                            });
                        });
                    });
                    //patches remainder issue when being set from global
                    let remainder = 5 - this._getOfferTotal.offer_value;
                    if (firstValuedItem) {
                        firstValuedItem.offer_amount += remainder;
                    }
                    this.$forceUpdate();
                } else {
                    let that = this;
                    if (this.offer) {
                        let actual_value = _.round(this.offer.total_value, 2) || 0;
                        let percent = _.round(offer_value / actual_value, 8); //4 spaces 2 for whole percents, and 2 for decimal.
                        //for remainder check
                        let firstValuedItem = null;

                        //to prevent weird percent errors
                        let calculated = 0;
                        _.keys(this.inventory).forEach(function (metal) {
                            that.inventory[metal].forEach(function (item) {
                                if (item.in_offer) {
                                    item.offer_percent = percent * 100 || 0;
                                    item.offer_amount = _.round(((percent) * parseFloat(item.appraisal.total)), 2) || 0;
                                    calculated += item.offer_amount;
                                    if (item.appraisal.total > 0) {
                                        firstValuedItem = item;
                                    }
                                    item.children.forEach(function (item) {
                                        item.offer_amount = (item.appraisal.total * percent);
                                    });
                                }
                            });
                        });
                        //patches remainder issue when being set from global
                        let remainder = offer_value - calculated;
                        if (firstValuedItem) {
                            firstValuedItem.offer_amount += remainder;
                        }
                    }
                }
            },
            flagToView(flag, index) {
                //this.flag_to_view = flag;
                //if(flag.flag_type.category == 'flag') {
                    this.flagUpdateLoc = index;
                    this.$store.commit('setActiveFlag', flag);
               // }
            },
            addFlag() {
                this.flagUpdateLoc = this.flags.length;
                this.$store.commit('setAddFlag', true);
            },
            getFlagVariant(config) {
                let decodedConfig = JSON.parse(config);
                return decodedConfig.variant ? decodedConfig.variant : 'secondary';
            },
            getFlagsByType(type) {
                if(this.flags) {
                    return _.filter(this.flags, (e) => {
                        return e.flag_type.id == type && e.cleared_at == null;
                    });
                }
                return [];
            },
            hasPaymentIssueFlags() {
                if(this.flags) {
                    return _.filter(this.flags, (e) => {
                        return ([5, 6, 7, 8].includes(e.flag_type.id)) && e.cleared_at == null;
                    }).length > 0;
                }
                return false;
            },
            //computed refused to work on update (clear flag).
            previous_order_negotiated: function(){
                return false;
                return this.getFlagsByType(29).length > 0;
            },
            repair_request_flag: function(){
                return false;
                return this.getFlagsByType(30).length > 0;
            },
            getBonusOptions(){
                var baseOptions = [{value:0, text:'0%'},{value:5, text:'5%'},{value:10, text:'10%'}];
                if(this.bonus_percent != 0 && this.bonus_percent != 5 && this.bonus_percent != 10){
                    baseOptions.push({
                        value:this.bonus_percent, text:this.bonus_percent+'%',
                    });
                }
                return baseOptions;
            },
            formatDate(value){
                if(value){
                    return moment(String(value)).format('MM/DD/YYYY');
                }
                return '';
            },
            formateTime(value){
                if (value) {
                    return moment(String(value)).format('MM/DD/YYYY hh:mm');
                }
            },
            saveEdits(e) {
                let that = this;
                function save(e) {
                    let key;
                    if(e == 'home_pickup') {
                        key = e;
                    } else {
                        key = e.target.attributes['data-editing'].value;
                    }
                    that._saveEdits(key);
                }

                if(this.edits.email.isEditing) {
                    this.verifyEmail();
                    if(!this.mailCheckedEmail) {
                        save(e);
                    }
                } else {
                    save(e);
                }
            },
            applyDocument(document){
                this.documents.push(document);
            },
            voidDocByID(id){
                _.forEach(this.documents, (doc) => {
                    if(doc.id == id){
                        doc.voided_at =  new Date();
                    }
                });
            },
            mapObject(obj, iteratee, context) {
                var output = {};
                _.each(obj, function(v, k) {
                    output[k] = iteratee.apply(context || this, arguments);
                });
                return output;
            },
            getDifferences(original, base) {
                const changes = (object, base) => (
                    _.pickBy(
                        this.mapObject(object, (value, key) => (
                            (!_.isEqual(value, base[key])) ?
                                ((_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value) :
                                undefined
                        )),
                        (value) => {return value !== undefined;}
                    )
                );
                return changes(original, base);
            },
            _saveEdits(key) {
                let that = this;
                this.edits[key].isSaving = true;

                let order = this.getDifferences(this.order, this.cachedOrder);
                let customer = this.getDifferences(this.customer, this.cachedCustomer);

                //general
                function generalSave(){
                    that.cachedCustomer = Object.assign({}, that.customer);
                    that.order.payments = that.cachedOrder.payments; //fixme bad fix
                    that.cachedOrder = Object.assign({}, that.order);
                    that.cachedLeads = Object.assign([], that.leads);
                    that.alternate_tracking_number_cache = that.alternate_tracking_number;
                    //that.$refs.notesModule.getNotes();
                    that.reloadData([/*'documents','flags',*/'leads','currentLead'], (z) =>{
                        that.edits[key].isSaving = false;
                        that.edits[key].isSaved = true;
                        that.edits[key].isEditing = false;

                        that.updateCompliance();
                        setTimeout(function(){
                            that.edits[key].isSaved = false;
                        }, 1500);
                    });
                }

                switch (key) {
                    case 'phone':
                        this.$http.put('/customers/' + this.customer.id, customer)
                            .then(response => {
                                this.customer = response.data.data;
                                this.$http.put('/orders/' + this.order.id, order) //for dnc order
                                    .then(response => {
                                        this.order = response.data.data;
                                        generalSave();
                                        this.updateCompliance();
                                    })
                                    .catch((error) => {
                                        console.log('error',error);
                                        that.edits[key].isSaving = false;
                                    });
                            }).catch((error) => {
                                console.log('error',error);
                                that.edits[key].isSaving = false;
                            });
                        break;
                    case 'email':
                    case 'name':
                    case 'dob':
                    case 'ssn_last_4':
                    case 'id':
                    case 'banned':
                    case 'payment_rate':
                    case 'mobile_phone':
                        this.$http.put('/customers/' + this.customer.id, customer)
                        .then(response => {
                            //prevent a weird disapearance of data fora  second (prevent panik)
                            response.data.data.identity_number = this.customer.identity_number;
                            this.customer = response.data.data;
                            generalSave();
                            this.updateCompliance();
                            //this.reloadData(['flags']);
                        }).catch((error) => {
                            console.log('error',error);
                            that.edits[key].isSaving = false;
                        });
                        break;
                    case 'compliance':
                        let aml_list = this.getAMLDocument();
                        let enhanced_verifiy_list = this.getEnhancedVerificationDocument();
                        let count = (!this.edits.compliance.Enhanced_verification ? (enhanced_verifiy_list.length == 0 && this.edits.compliance.Enhanced_verification != null  ? -1 : enhanced_verifiy_list.length): 0)
                            + (!this.edits.compliance.AML && this.edits.compliance.AML != null ? (aml_list.length == 0 ? -1 : aml_list.length) : 0);

                        if (aml_list.length == 0 && !this.edits.compliance.AML && this.edits.compliance.AML != null) {
                            let send = {
                                document_type_id: 4,
                            };
                            this.$http.post('/orders/' + this.order.id +'/documents',send).then((e)=>{
                                let dtime = new Date().getTime();
                                let formatTime = moment(dtime).format('h:mm A');

                                let option = _.find(this.document_created.type_options,(e)=>{return e.value == this.document_created.type_selected;});
                                //this.$refs.notesModule.addNote(formatTime + ' - ' + option.text + ' Document was created');
                               // this.applyDocument(e.data.data); FIXME causes error crash, only solution is to reload it all. I already spent 2 hours on this (`do not mutate vuex store state outside mutation handlers.`)
                                count++;
                                if(count == aml_list.length + enhanced_verifiy_list.length){
                                    this.reloadData2(['documents', 'flags'], (z) =>
                                    {
                                        this._saveEdits('compliance_post');
                                    });
                                }
                            });
                        } else if (aml_list.length  > 0 && this.edits.compliance.AML) {
                            _.forEach(aml_list, (e) =>{
                                let send = {signed_at: new Date()};
                                this.$http.put('/documents/'+e.id,send).then(
                                    (z) => {
                                       // this.voidDocByID(send.id); FIXME causes error crash, only solution is to reload it all. I already spent 2 hours on this (`do not mutate vuex store state outside mutation handlers.`)
                                        //this.updateCompliance();
                                        count++;
                                        if(count == aml_list.length + enhanced_verifiy_list.length){
                                           this.reloadData2(['documents', 'flags'], (z) =>
                                            {
                                                this._saveEdits('compliance_post');
                                            });
                                        }
                                    }
                                );
                            });
                        }

                        if (enhanced_verifiy_list.length == 0 && !this.edits.compliance.Enhanced_verification && this.edits.compliance.Enhanced_verification != null) {
                            let send = {
                                document_type_id: 8,
                            };
                            this.$http.post('/orders/' + this.order.id +'/documents',send).then((e)=>{
                                let dtime = new Date().getTime();
                                let formatTime = moment(dtime).format('h:mm A');

                                let option = _.find(this.document_created.type_options,(e)=>{return e.value == this.document_created.type_selected;});
                                //this.$refs.notesModule.addNote(formatTime + ' - ' + option.text + ' Document was created');
                                //this.applyDocument(e.data.data); FIXME handled by reload data now
                                count++;
                                if(count == aml_list.length + enhanced_verifiy_list.length){
                                    this.reloadData2(['documents','flags'], (z) => {//todo REMOVE ME after fixing above, used to fix code above
                                        this._saveEdits('compliance_post');
                                    });
                                }
                            });
                        } else if (enhanced_verifiy_list.length  > 0 && this.edits.compliance.Enhanced_verification) {
                            _.forEach(enhanced_verifiy_list, (e) =>{
                                let send = {signed_at: new Date()};
                                this.$http.put('/documents/'+e.id,send).then(
                                    (z) => {
                                        //this.voidDocByID(send.id); FIXME causes error crash, only solution is to reload it all. I already spent 2 hours on this (`do not mutate vuex store state outside mutation handlers.`)
                                        //this.updateCompliance();
                                        count++;
                                        if(count == aml_list.length + enhanced_verifiy_list.length){
                                            //todo REMOVE ME after fixing above, used to fix code above
                                            this.reloadData2(['documents','flags'], (z) =>
                                            {
                                                this._saveEdits('compliance_post');
                                            });
                                        }
                                    }
                                );
                            });
                        }
                        if(count != aml_list.length + enhanced_verifiy_list.length){ //no records tochange.
                            break;
                        }
                    case 'compliance_post':
                        key = 'compliance';
                    case 'payment_method':
                    case 'offer_quote':
                    case 'bonus_override':
                    case 'status':
                    case 'home_pickup':
                    case 'home_pickup_confirmation_number':
                    case 'customer_convience':
                        this.$http.put('/orders/' + this.order.id, order)
                            .then(response => {
                                //prevent a weird disapearance of data fora  second (prevent panik)
                                response.data.data.bank_account = this.order.bank_account;
                                response.data.data.bank_routing = this.order.bank_routing;
                                this.order = response.data.data;
                                generalSave();
                                //this.reloadData(['flags']);
                            })
                            .catch((error) => {
                                console.log('error22',error);
                                that.edits[key].isSaving = false;
                            });
                        break;
                    case 'address':
                        let address = this.customer.address;
                        address.created_at = null;
                        address.updated_at = null;
                        address.verified = null;
                        this.$http.post('/customers/updateAddress/' + address.id, address).then((res)=>{
                            this.reloadData2(['leads','currentLead', 'flags', 'trackingNumbers'],()=> {
                                //todo a check for invalid addresses (popup?)
                                this.customer.address = res.data.data;
                                generalSave();
                            });
                        })
                        .catch((error) => {
                            console.log('error22',error);
                            that.edits[key].isSaving = false;
                        });
                        break;
                    case 'alternate_tracking_num':
                        let payload = {
                            order_id: this.order.id,
                            shipper_id: 1,
                            tracking_number: this.alternate_tracking_number,
                            tracking_number_type: 'alternate',
                        };
                        this.$http.post('/orders/' +  this.order.id + '/trackingnumbers', payload).then((res)=>{
                            generalSave();
                        }).catch((error) => {
                            console.log('error22',error);
                            that.edits[key].isSaving = false;
                        });
                        break;

                }
            },
            cancelEdits(e) {
                let key = e.target.attributes['data-editing'].value;
                this.customer = Object.assign({}, this.cachedCustomer);
                this.order = Object.assign({}, this.cachedOrder);
                this.leads = Object.assign([], this.cachedLeads);
                this.alternate_tracking_number = this.alternate_tracking_number_cache;
                this.edits[key].isEditing = false;
                this.edits[key].isSaving = false;
                //try to stop gap a few overrides
                this.$store.commit(OVERRIDE, null);
                this.updateCompliance();
            },
            setRateFromTable(rate) {
                rate = (parseFloat(rate) / 100);
            },
            truncate(value) {
                if (!value) return '';
                value = value.toString();
                return value.slice(0, 25) + (value.length >= 25 ? '...' : '');
            },
            customerConveniencePayment() {
                this.order.block_autoaccept = 1;
            },
            inventoryWeightTotals(metal) {
                if (this.inventory) {
                    let weight = 0;
                    this.inventory[metal].forEach(function (item) {
                        weight += item.aggregate_dwt;
                    });
                    return weight;
                }
            },
            updateItemPayoutRates(metal, e) {
                let that = this;
                let payoutRate = parseInt(e.target.value);
                this.inventory[metal].forEach(function (item) {
                    item.offer_percent = payoutRate || 0;
                    that.setItemAmount(item);
                });
            },
            updateTotalAmount() {

            },
            setItemAmount(item) {
                item.offer_percent = parseFloat(item.offer_percent) || 0;
                let newRate = (item.offer_percent / 100);
                item.offer_amount = _.round(((item.offer_percent / 100) * parseFloat(item.appraisal.total)), 2) || 0;
                item.children.forEach( function(item) {
                        item.offer_amount =  (item.appraisal.total * newRate);
                });
            },
            calcChildPercentRate(item) {
                let calc = parseFloat(((item.offer_amount / item.appraisal.total) * 100).toFixed(2));
                return (calc ? calc : 0);
            },
            childHasDetails(categoryID) {
                let details;
                switch(categoryID) {
                    case 2:
                    case 7:
                    case 8:
                    case 9:
                    case 13:
                        details = true;
                        break;
                    default:
                        details = false;
                }
                return details;
            },
            childDetailInventoryFields(categoryID) {
                let fields;
                switch(categoryID) {
                    case 2:
//                      // coins
                        fields = [
                            {key: 'type_name', label: 'Region'},
                            {key: 'style_name', label: 'Coin Type'},
                            {key: 'quantity', label: 'Quantity'},
                            {key: 'appraisal.numismatic', label: 'EAV'},
                        ];
                        break;
//
                    case 13:
                    case 7:
                        // Diamonds/Melee & precious stones
                        fields = [
                            {key: 'style_name', label: 'Cut'},
                            {key: 'color_name', label: 'Color'},
                            {key: 'clarity_name', label: 'Clarity'},
                            {key: 'appraisal.numismatic', label: 'EAV'},
                            {key: 'certificate_name', label: 'Certificate Type'},
                            {key: 'certificate_number', label: 'Certificate Number'},
                            { key: 'condition_name', label: 'Condition' },
                        ];
                        break;
                    case 8:
                    case 9:
                        // Gem/Synthetic
                        fields = [
                            {key: 'type_name', label: 'Item Type'},
                            {key: 'style_name', label: 'Style'},
                        ];
                        break;
                }
                return fields;
            },

            rowClass(item, type) {
                if (this.order.status_name == 'Batched' || this.order.status_name == 'Settled') {
                    if(!item.in_offer) {
                        return 'table-danger';
                    } else {
                        return 'table-info';
                    }
                }
                if(this.isItemNegotiable(item)) {
                    if (item.in_offer) {
                        if (this.order.status_name == 'Offer Declined') return 'table-danger';
                        if (!item || type !== 'row') return;
                        if (item.status_name === 'hold') return 'table-warning';
                        //if (item.status_name === 'reverse-ship') return 'table-danger';
                    } else {
                        return 'table-danger';
                    }
                } else {
                    return 'danger-zone';
                }
            },
            inventorySearchHighlightClass(itemId) {
                if (this.searchFilters) {
                    let searchedInventoryItem = _.find(this.searchFilters, {'filterModel':'inventory','filterField':'id','filterName':'Inventory ID','filterParameter':'equals','filterValue':itemId.toString()});
                    if (searchedInventoryItem) {
                        return 'bg-warning text-dark p-1';
                    }
                }
            },
            getHeaderWidth() {
                let header = document.querySelector('.kit-view-header');
                let width = header.offsetWidth;
                return width;
            },
            getCustomer() {
            },
            getDocuments() {
                if (!this.documentsShowAllOrders) {
                    this.documents = [];
                        this.documentsLoading = true;
                        this.$http.get('/orders/' + this.order.id + '/documents').then((res) => {
                            this.documents = res.data.data;
                            this.documentsLoading = false;
                        });
                    } else {
                        this.documents = [];
                        this.documentsLoading = true;
                        this.$http.get('/customers/' + this.customer.id + '/documents').then((res) => {
                            this.documents = res.data.data;
                            this.documentsLoading = false;
                        });
                    }
            },
            openHistory() {
                this.historyVisible = !this.historyVisible;
                this.getHistory();
            },
            reloadHistory() {
                this.historyIsOpened = false;
                this.getHistory();
            },
            getHistory() {
                if(!this.historyIsOpened) {
                    this.historyWasOpened = true;
                    this.historyIsOpened = true;
                    if (!this.historyShowAllOrders) {
                        this.history = null;
                        this.$http.get('/customers/' + this.customer.id + '/' + this.order.id + '/activity').then((res) => {
                            this.history = res.data.data;
                            this.updateHistory();
                        });
                    } else {
                        this.history = null;
                        this.$http.get('/customers/' + this.customer.id + '/activity').then((res) => {
                            this.history = res.data.data;
                            this.updateHistory();
                        });
                    }
                }
            },
            getAppraisals(){
                this.inventory = true;
                this.bonus_percent = null; //prevent order page switching bug.
                this.$http.get('/orders/' + this.$route.params.id + '/appraisals')
                    .then(response => {
                        this.offer = response.data.data;
                        this.processInventory(response.data.data.inventory, 'getAppraisals');
                        this.bonus_percent = _.round(this.offer.bonus_amount / this.offer.total_offer * 100) || 0;
                        // scroll to kit view section if requested
                        this.anchorHashCheck();
                        this.$nextTick(()=> {
                            if (this.searchFilters) {
                                let searchedInventoryItem = _.find(this.searchFilters, {'filterModel':'inventory','filterField':'id','filterName':'Inventory ID','filterParameter':'equals'});
                                if (searchedInventoryItem) {
                                    document.getElementById('inventory-table__row_' + searchedInventoryItem.filterValue).scrollIntoView({ block: "center" });
                                }
                            }
                        });
                    });
            },
            processInventory(inventory, fromMethod) {
                let that = this;
                let metals = {
                    'gold': [],
                    'gold-filled': [],
                    'silver': [],
                    'silver-filled': [],
                    'platinum': [],
                    'palladium': [],
                    'diamond': [],
                    'melee': [],
                    'other': [],
                };
                let sortedMetals = {};
                inventory.forEach((item) => {
                    if (item.children.length > 1) {
                        this.$set(item, '_showDetails', false);
                    }
                    if(fromMethod == 'getAppraisals') {
                        item.children.forEach((a) => {
                            that.$set(a, '_showDetails', true);
                        });
                    }

                    if(item && item.children && item.children[0]) {
                        if (item.children[0].class_name in metals) {
                            metals[item.children[0].class_name].push(item);
                        } else {
                            metals[item.children[0].class_name] = [];
                            metals[item.children[0].class_name].push(item);
                        }
                    }
                });


                //sort metal
                _.forEach(metals, function(value, key) {
                    if(fromMethod == 'getAppraisals') {
                        if(_.isEmpty(that.marketPrices) && !_.isEmpty(metals[key])) {
                            that.marketPrices = metals[key][0].appraisal.market_prices;
                        }
                    }
                    sortedMetals[key] = _.orderBy(metals[key], [function(o) { return parseFloat(o.children[0].purity); }], ['desc']);

                    if( sortedMetals[key].length == 0) {
                        delete sortedMetals[key];
                    }
                });

                //consolidate diamond and melee
                if( 'diamond' in sortedMetals && 'melee' in sortedMetals ) {
                    sortedMetals.diamond.push(...sortedMetals.melee);
                    delete sortedMetals.melee;
                }
                this.inventory = sortedMetals;
            },

            bulkSetInOffer(metal, value) {
                this.inventory[metal].forEach((item) => {
                    item.in_offer = value;
                });
            },

            getCustomerOrders() {
            },

            // Print functions
            printOrderLabel() {
                this.$label('order', this.order);
            },
            printItemLabel(item) {
                item.customer = this.customer;
                item.order = this.order;
                this.$label('item', item);
            },
            printBagLabels() {
                this.$http.get('/orders/' + this.$route.params.id + '/bags')
                    .then((response) => {
                        let bags = response.data.data;
                        _.forEach(bags, (bag) => {
                            bag.customer = this.customer;
                            bag.order = this.order;
                            this.$label('bag', bag);
                        });
                    });
            },
            printHoldLabels() {
                this.offer.inventory.forEach((item) => {
                    if (item.status_name === 'hold') {
                        item.customer = this.customer;
                        item.order = this.order;
                        this.$label('hold', item);
                    }
                });
            },
            printTrackingLabels() {
                this.trackingNumbers.forEach((tracking_number) => {
                    this.$label('fedex', tracking_number, 'barcode');
                });
            },
            saveFlag(data) {
                this.$http.post('orders/' + this.order.id + '/flags', data)
                .then(response => {
                });
                this.$bvModal.hide('modal-edit-flag');
            },
            updateFlag(flag){
                let index = _.findIndex(this.flags, (e)=>{
                    return e.id == flag.id;
                });
                if(index == -1){
                    //index = this.flags.length;
                    if(flag.deleted_at) {
                        return;
                    }
                    this.flags.push(flag);
                }
                else {
                    let flagsCopy = Object.assign([], this.flags);
                    //todo I have no idea why but I must do this terriableness to update the flags, I should literally need to do this.flag[index] = flag;
                    if (flag.deleted_at) {
                        if (index < this.flags.length) {
                            flagsCopy.splice(index, 1);
                        }
                    } else {
                        flagsCopy[index] = flag;
                    }
                    this.flags = flagsCopy;
                }
                this.reloadData();
                this.$forceUpdate();
            },

            runIdology() {
                this.idology.idology_working = true;
                this.idology.questions_presented = false;
                this.$http.get('idology/run/' + this.order.id)
                    .then(response => {
                        if(response.data.msg) {
                            if (response.data.msg.reason) {
                                this.order.idology_status = response.data.msg.status;
                                this.order.idology_message = response.data.msg.reason + ',' + (_.isArray(response.data.msg.qualifiers) ? response.data.msg.qualifiers.join() : response.data.msg.qualifiers);
                                this.idology.idology_id = response.data.idologyid;
                            } else {
                                this.order.idology_message = response.data.msg;
                            }
                            if (response.data.msg.questions) {
                                this.idology.questions = response.data.msg.questions;
                                this.idology.answers = {};
                                this.idology.questions_presented = true;
                            }
                        }
                        this.idology.idology_working = false;
                        if(response.data.status !== undefined) {
                            this.order.idology_status = response.data.status;
                            //console.log("updated status to ", response.data.status, response)
                        }
                        //this.reloadData2([]);
                    })
                .catch(() => {
                    this.order.idology_message = 'Error';
                    this.idology.idology_working = false;
                });
            },

            submitIdologyAnswers () {
                this.$refs.idology_questions.validate().then(success => {
                    if (!success) {
                        return;
                    } else {
                        this.$bvModal.hide('modal-idology-questions');
                        this.idology.idology_working = true;
                        let payload = {
                            idology_id: this.idology.idology_id,
                            answers: this.idology.answers,
                        };
                        this.$http.post('idology/questions/' + this.order.id, payload)
                            .then(response => {
                                this.order.idology_status = response.data.msg.status;
                                this.order.idology_message = response.data.msg.reason + ',' + response.data.msg.qualifiers.join() + ',' + response.data.msg.result;
                                this.idology.idology_working = false;
                                this.idology.questions_presented = false;
                            })
                            .catch(() => {
                                this.order.idology_message = 'Error';
                                this.idology.idology_working = false;
                                this.idology.questions_presented = false;
                            });
                    }
                });

            },

            clearIdology () {
                this.idology.idology_working = true;
                this.idology.questions_presented = false;
                this.$http.get('idology/clear/' + this.order.id)
                    .then(response => {
                        this.order.idology_status = 0;
                        this.order.idology_message = '';
                        this.idology.idology_working = false;
                    })
                    .catch(() => {
                        this.order.idology_message = 'Error';
                        this.idology.idology_working = false;
                    });
            },

            forcefullyVerifyIdology () {
                this.$bvModal.hide('modal-idology-questions');
                this.idology.idology_working = true;
                this.idology.questions_presented = false;
                this.$http.get('idology/force/' + this.order.id)
                    .then(response => {
                        this.order.idology_status = 2;
                        this.order.idology_message = 'Forced Pass';
                        this.idology.idology_working = false;
                    })
                    .catch(() => {
                        this.order.idology_message = 'Error';
                        this.idology.idology_working = false;
                    });
            },
            openProtectedDocument (path) {
                this.$http.get('/documents/getSignedUrl/byPath', {
                    params: {path: path}
                })
                .then(response => {
                    window.open(response.data, '_blank');
                });
            },
            openProtectedMedia (type, path) {
                this.$http.get('/media/getSignedUrl/byPath', {
                    params: {path: path}
                })
                    .then(response => {
                        if (type === 'photo') {
                            this.activateImageModal(response.data);
                        } else if (type === 'video') {
                            this.activateVideoModal(response.data);
                        }
                    })
                    .catch(() => {
                        return null;
                    });
            },
            modalTrackingRowClass(item, type) {
                if (!item || type !== 'row') return;
                if (item.expected_delivery_at) return 'bg-warning text-dark';
                return 'text-muted';
            },
            modalTrackingButtonClass(item) {
                if (item.expected_delivery_at) {
                    return 'primary';
                } else {
                    return 'secondary';
                }
            },
            modalTrackingIsInbound(item) {
                if (item.expected_delivery_at) {
                    return true;
                } else {
                    return false;
                }
            },
            getPrintAsset(item) {
                item.printing = true;
                let env_bucket = process.env.VUE_APP_BUCKET || 'b79-gx-media';
                if (item.label_url && (item.label_url.match(/.zpl$/i) || item.label_url.match(/.zpl2$/i))) {
                    this.$http.get('https://' + env_bucket + '.s3.amazonaws.com' + item.label_url, {
                        withCredentials: false,
                        headers: {'Authorization': ''}
                    })
                        .then(async (response) => {
                            console.log(response);
                            await this.$printer.printRaw('fedex', response.data);
                            item.printing = false;
                        });
                } else {
                    this.$label('fedex', item, 'barcode').then(() => {
                        item.printing = false;
                        window.open('https://' + env_bucket + '.s3.amazonaws.com' + item.label_url, '_blank');
                    });
                }
            },
            printReturnShippingLabel(item) {
                item.printing = true;
                this.$http.get('/reverse-shipments/' + item.id + '/get-label')
                    .then(response => {
                        let labelData = atob(response.data.label);
                        this.$printer.printRaw('usps', labelData).then(() => {
                            item.printing = false;
                        }).catch(() => {
                            item.printing = false;
                        });

                    })
                    .catch(() => {
                        item.printing = false;
                    });
            },
        },
        watch: {
            $route: {
                //immediate: true,
                //deep: true,
                handler(to, from){
                    if (to.name.includes('kit-view-index')) {
                        if(this.order) {
                            this.$echo.leaveChannel('App.Document.Order.' + this.order.id);
                            this.$echo.leaveChannel('App.Document.Customer.' + this.customer.id);
                        }
                        this.inventory = null;
                        this.historyView = null;
                        this.history = null;
                        this.historyVisible = false;
                        this.historyIsOpened = false;

                        this.loadOrder();
                    }
                }
            },
            'customer.identity_type': {
                handler(val) {
                    if (val == 'military') {
                        this.customer.identity_state = 'NA';
                    }
                }
            },

            '_latestReverseShip.return_tracking_number': {
                //immediate: true,
                //deep: true,
                handler(val) {
                    if (val != null) {
                        this.isVisibleReturn = true;
                    }
                }
            },
            'order.payments': {
                //immediate: true,
                deep: true,
                handler(val) {
                    if (val != null && val.length && val.length > 0) {
                        this.isVisiblePayments = true;
                    }
                }
            },

            documents: {
                //immediate: true,
                deep: true,
                handler(val){
                    if (val != null) {
                        this.isVisibleDocuments = true;
                    }
                }
            },

            _isFlagUpdated: {
                immediate: true,
                deep: true,
                handler(flag) {
                    if(this.flags) {
                        this.updateFlag(flag);
                        //this.reloadData(['documents']);
                        //this.flags = Object.assign([], this.flags);
                        this.$forceUpdate();
                    }
                }
            },
            'order.home_pickup': {
                //immediate: true,
                //deep: true,
                handler(val) {
                    if (this.$refs.notesModule && !this.loading) {
                        let date = new Date();
                        let dtime = date.getTime();
                        let formatTime = moment(dtime).format('h:mm A');
                        if (val == '1') {
                            this.$refs.notesModule.addNote(`${formatTime} - Home pickup scheduled`);
                        } else {
                            this.$refs.notesModule.addNote(`${formatTime} - Home pickup canceled`);
                        }
                        this.saveEdits('home_pickup');
                    }
                }
            },
            'bonus_percent': {
                //immediate: true,
                //deep: true,
                handler(val, old) {
                    if (this.offer && old !== null && val !== null) {
                        this.offer.bonus_amount = _.round(this.offer.total_offer * this.bonus_percent / 100, 2) || 0;
                    }
                    //return 0;
                }
            },
            'inventory': {
                deep: true,
                handler() {

                    // console.log('inventory watcher');
                    let that = this;
                    let total_value = 0;
                    let offer_value = 0;
                    let actual_total_value = 0;
                    _.keys(this.inventory).forEach(function (metal) {
                        that.inventory[metal].forEach(function (item) {
                            if (item.in_offer) {
                                offer_value += _.round(parseFloat(item.offer_amount), 8);
                                total_value += _.round(parseFloat(item.appraisal.total), 8);
                            }
                            actual_total_value += _.round(parseFloat(item.appraisal.total), 2);
                        });
                    });
                    if(this.offer) {
                        this.offer.total_value = _.round(total_value, 2);
                        this.offer.actual_total_value = _.round(actual_total_value, 2);
                        this.offer.total_offer = _.round(offer_value, 2);
                        this.offer.offer_rate = _.round(((offer_value / total_value) * 100), 2);
                        this.offer.bonus_amount = _.round(offer_value * this.bonus_percent / 100, 2) || 0;
                        // console.log('inventory watcher offer value', offer_value);
                    }
                }
            },
            historyType: {
                immediate: true,
                deep: true,
                handler(val) {
                    this.updateHistory();
                }
            },
            documentsShowAllOrders: {
                // immediate: true,
                // deep: true,
                handler(val, orig) {
                    if(orig != val) {
                        this.getDocuments();
                    }
                }
            },
            historyShowAllOrders: {
                immediate: true,
                deep: true,
                handler(val, orig) {
                    if(orig != undefined) {
                        this.historyIsOpened = false;
                        this.getHistory();
                    }
                }
            },
            'document_created.is_jewelry_replacement': {
                handler(val) {
                    if (val === true) {
                        this.document_created.settlement = 'by providing replacement jewelry';
                    } else {
                        this.document_created.settlement = null;
                    }
                }
            },
        }
    };
</script>

<style>
    *:focus {
        outline: none;
    }
    .customer-section-rows {
        padding: 4px 0;
    }
    .kit-view-header {
        position: sticky;
        top: 0;
        z-index:1019;
    }
    /*has to be out of scope to affect tables*/
    .danger-zone {
        background-color: #f5c7c6 !important;
        padding: 4px !important;
    }
    .danger-zone > th,
    .danger-zone > td {
        background-color: #f5c7c6 !important;
    }
    /* date range picker quick fix */
    .daterangepicker{
        min-width:100px !important;
        width:270px !important;
    }
    .force_height_button{
        height:20px;
    }
</style>
<style scoped>
    .text-tiny{
        font-size: 12px;
    }
    .text-faded {
        color: #666666;
    }
    .order-section-header {
        color: #545454;
    }
    .set-flag-height {
        height: 200px !important;
        overflow: scroll !important;
    }
    .five9_header{
        background-color: #d3e9f0;
    }
    .side-panel-font {
        font-size: 12px;
    }

    .inventoryImgBadge {
        position: absolute;
        left: 15px;
        top: 15px;
    }

    .inventory-card .font-xxs {
        font-size: .7rem !important;
    }


    .offer-auto-accept-1 {
        text-decoration: line-through;
    }

    /* offer rate scale */
    .offer-scale-table {
        font-size: 12px;
        font-weight: 900;
    }

    .offer-scale-table td,
    .offer-scale-table th {
        padding: 0 2px;
    }

    .offer-scale-table th {
        text-align: right;
    }

    .offer-scale-table img {
        max-width: 45px;
    }

    .offer-scale-table img:hover {
        background-color: #fff !important;
    }

    .offer-scale-table .tier {
        border-left: 8px solid #ddd;
    }

    .offer-scale-table .tier.basic {
        border-color: limegreen;
    }

    .offer-scale-table .tier.deluxe {
        border-color: #b5cd19;
    }

    .offer-scale-table .tier.superior {
        border-color: yellow;
    }

    .offer-scale-table .tier.select {
        border-color: #ffcf06;
    }

    .offer-scale-table .tier.preferred {
        border-color: orange;
    }

    .offer-scale-table .tier.elite {
        border-color: #ff6507;
    }

    .offer-scale-table .tier.premium {
        border-color: #ff1a1a;
    }

    /* customer info */
    .orders-dropdown-table {
        font-size: 10px;
        width: 340px;
    }

    .order-info .card-height {
        min-height: 370px;
    }

    .order-info .item {
        padding-bottom: 6px;
    }

    .order-info label {
        margin-bottom: 0;
    }

    .order-info .item .sub-label {
        font-size: 8px;
    }

    .order-info .data {
        font-size: 80%;
        font-weight: bold;
    }

    /* notes */
    .notes-wrapper {
        max-height: 300px;
        overflow: scroll;
    }

    .notes-btn-bg {
        background-color: #d3e9f0;
    }


    /* edits */
    .editable .controls .fa-solid {
        font-size: 18px;
        transition: .2s ease;
    }
    .editable .controls .fas:hover {
        transform: scale(1.2);
    }

    .editable .data {
        position: relative;
        transition: .2s ease;
    }

    .editable .data:hover {
        background: #f0f0f0;
        cursor: pointer;
        position: relative;
    }
    .editable .data.danger-zone:hover {
        background: #f39492 !important;
    }

    .editable .data.danger-zone:hover:after {
        color: red;
    }

    .editable .data:hover:after {
        font-family: 'Font Awesome 5 Pro';
        content: "\f14b";
        position: absolute;
        right: 2px;
        top: 2px;
        color: lightcoral;
        font-size: 12px;
    }
    .onSave {
        animation: saved 1.5s;
        position: absolute;
        right:0;
        top: 0;
    }
    @keyframes saved {
        30% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }


    /* flags */
    .flag-default {
        background-color: #aec2cb;
    }

    .flag-info {
        background-color: #5bc0de;
    }

    .flag-primary {
        background-color: #337ab7;
    }

    .flag-success {
        background-color: #a5cb9f;
    }

    .flag-success2 {
        background-color: #5cb85c;
    }

    .flag-alert {
        background-color: #f0ad4e;
    }

    .flag-warning {
        background-color: #f0701f;
    }

    .flag-warning2 {
        background-color: #d019d5;
    }

    .flag-danger {
        background-color: #d9534f;
    }

    .flag-critical {
        background-color: #cd0d0e;
    }

    /* history card icon colors */
    .inventory-icon-color {
        color: #848583;
    }

    .qa-icon-color {
        color: #c255ba;
    }

    .customer-icon-color {
        color: #c27474;
    }

    .order-icon-color {
        color: #E3C474;
    }
    .offer-icon-color {
        color: #6ECCCC;
    }

    .payment-icon-color {
        color: #57ad25;
    }

    /**/
    .border-light {
        border-color: #eee !important;
    }
    .sticky {
        position: sticky;
        top:20px;
    }
    .strike-through{
        text-decoration: line-through;
    }
    .row.no-gutters > [class*='col-'] {
         padding-right:0;
         padding-left:0;
     }
    .offer-breakdown-table .font-xxs {
        font-size: .7rem !important;
    }
    .collapsed .when-open,
    .not-collapsed .when-closed {
        display: none;
    }
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .multiselect__option {
        padding: 8px !important;
        line-height: 10px !important;
        min-height: 20px !important;
        font-size: 0.8em;
    }
    .multiselect__tags, .multiselect__select{
        padding:0;
        margin-left: 2px;
        min-height: 33px !important;
        height:33px !important;
        max-height: 33px !important;
    }
    .multiselect__placeholder{
        margin-left: 4px;
    }
    .multiselect__single {
        margin-top: 3px;
        font: 400 13px Arial;
    }
    .multiselect__tags {
        padding-top: 4px;
    }
    .multiselect {
        min-height: 33px !important;
        height:33px !important;
        max-height: 33px !important;
    }

    .multiselect__option--group.multiselect__option--disabled {
        font-weight: bold;
        color: black !important;
    }
</style>